/* tslint:disable */
/* eslint:disable */
/**
* @typedef {Object} widgetVideoAutoplayStartParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - instance_id
* @property {GUID} biToken - msid
* @property {string} origin - on_site/embed
* @property {string} compId - player_id
* @property {string} siteUrl - site url (only when embed video)
* @property {string} videoID - videoID
* @property {string} videoType - live/upload/youtube/vimeo/facebook
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.video.autoplay.start. Evid: 280.
 * Event description: When video autoplay start to play.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: instance_id
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: on_site/embed
 *
 * compId - Type: string. Desc: player_id
 *
 * siteUrl - Type: string. Desc: site url (only when embed video)
 *
 * videoID - Type: string. Desc: videoID
 *
 * videoType - Type: string. Desc: live/upload/youtube/vimeo/facebook
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetVideoAutoplayStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetVideoAutoplayStart = function (params) {
    return { evid: 280, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} playerDebugInfoParams
* @property {number} avgBandwidth - avg bandwidth
* @property {number} bitrate - Bitrate
* @property {string} channelID - Channel ID
* @property {string} correlationId - ID for one unique view connection
* @property {string} deliveryType - Delivery type of stream(native, library, etc)
* @property {number} duration - duration of full video in ms
* @property {GUID} videoInstanceID - videoInstanceID
* @property {boolean} isAutoplay - If video start autoplay or user click on play
* @property {boolean} isEmbed - Ind if the video embedded
* @property {boolean} isLive - Ind if the video is live
* @property {GUID} biToken - biToken
* @property {string} compId - compId
* @property {string} siteUrl - site url (only when embed video)
* @property {string} timeFrame - The time in the video we shoot this event (Not the time the user see the movie)
* @property {number} videoHeight - Actual height of video source
* @property {string} videoID - ID of video in terms of Wix VOD
* @property {string} videoType - Type of video source
* @property {string} videoUrl - Url of video source
* @property {number} videoWidth - Actual width of video source
* @property {number} viewportHeight - Height of video viewport
* @property {number} viewportWidth - Width of video viewport
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: player.debug.info. Evid: 233.
 * Event description: New Video Player debug system.

 * avgBandwidth - Type: numeric. Desc: avg bandwidth
 *
 * bitrate - Type: numeric. Desc: Bitrate
 *
 * channelID - Type: string. Desc: Channel ID
 *
 * correlationId - Type: string. Desc: ID for one unique view connection
 *
 * deliveryType - Type: string. Desc: Delivery type of stream(native, library, etc)
 *
 * duration - Type: numeric. Desc: duration of full video in ms
 *
 * videoInstanceID - Type: guid. Desc: videoInstanceID
 *
 * isAutoplay - Type: bool. Desc: If video start autoplay or user click on play
 *
 * isEmbed - Type: bool. Desc: Ind if the video embedded
 *
 * isLive - Type: bool. Desc: Ind if the video is live
 *
 * biToken - Type: guid. Desc: biToken
 *
 * compId - Type: string. Desc: compId
 *
 * siteUrl - Type: string. Desc: site url (only when embed video)
 *
 * timeFrame - Type: string. Desc: The time in the video we shoot this event (Not the time the user see the movie)
 *
 * videoHeight - Type: numeric. Desc: Actual height of video source
 *
 * videoID - Type: string. Desc: ID of video in terms of Wix VOD
 *
 * videoType - Type: string. Desc: Type of video source
 *
 * videoUrl - Type: string. Desc: Url of video source
 *
 * videoWidth - Type: numeric. Desc: Actual width of video source
 *
 * viewportHeight - Type: numeric. Desc: Height of video viewport
 *
 * viewportWidth - Type: numeric. Desc: Width of video viewport
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {playerDebugInfoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var playerDebugInfo = function (params) {
    return { evid: 233, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLiveEventEditClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - player_id
* @property {string} videoID - video
**/
/**
 * Name: bo.live.event.edit.clicked. Evid: 473.
 * Event description: click on Edit Event on Live stream tab.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video
 * @param {boLiveEventEditClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLiveEventEditClicked = function (params) {
    return { evid: 473, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageEditCardsClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.editCards.click. Evid: 166.
 * Event description: click on "Edit Cards" section in video page.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageEditCardsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageEditCardsClick = function (params) {
    return { evid: 166, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetAboutChClickedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.aboutCh.clicked. Evid: 215.
 * Event description: About channel  button clicked.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetAboutChClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetAboutChClicked = function (params) {
    return { evid: 215, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditScheduleSavedParams
* @property {string} action - create/change
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - player_id
* @property {string} source - computer/dropbox/drive/youtube/vimeo/facebook
* @property {string} videoID - videoID
**/
/**
 * Name: bo.chEdit.schedule.saved. Evid: 80.
 * Event description: Schedule save.

 * action - Type: string. Desc: create/change
 *
 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: computer/dropbox/drive/youtube/vimeo/facebook
 *
 * videoID - Type: string. Desc: videoID
 * @param {boChEditScheduleSavedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditScheduleSaved = function (params) {
    return { evid: 80, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditUpdateChangesClickedParams
* @property {string} button - popup/button/library
* @property {string} channelID - channelID
* @property {boolean} coverAdded - cover added
* @property {boolean} descriptionExists - description channel exists
* @property {boolean} featuredSelected - featured video selected
* @property {boolean} hasCustomCover - has channel custom cover
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isYouTubeFeed - if channel is youtube feed
* @property {GUID} biToken - msid
* @property {number} numOfTags - num of tags
* @property {number} numberVideos - number videos in the channel
* @property {string} origin - origin
* @property {number} overQuotaVideosCount - how many of the videos are OverQ
* @property {string} compId - player_id
* @property {boolean} scheduledExists - scheduled video exists
* @property {boolean} subscriptionEnabledChange - did you change the subscription option
* @property {boolean} subscriptionEnabled - subscription enabled
* @property {boolean} subscriptionOnly - "make paid videos on this channel subscription only" on/off
* @property {boolean} subscriptionOnlyChange - "make paid videos on this channel subscription only" changed
* @property {number} subscriptionPricing - doubled by 10000
* @property {boolean} subscriptionPricingChange - did the price of the subscription change
* @property {boolean} titleAdded - title added
* @property {string} videoID - JSON video_id
**/
/**
 * Name: bo.chEdit.updateChanges.clicked. Evid: 76.
 * Event description: Update Changes clicked or channel start to be created from library, clicking "add to new channel".

 * button - Type: string. Desc: popup/button/library
 *
 * channelID - Type: string. Desc: channelID
 *
 * coverAdded - Type: bool. Desc: cover added
 *
 * descriptionExists - Type: bool. Desc: description channel exists
 *
 * featuredSelected - Type: bool. Desc: featured video selected
 *
 * hasCustomCover - Type: bool. Desc: has channel custom cover
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isYouTubeFeed - Type: bool. Desc: if channel is youtube feed
 *
 * biToken - Type: guid. Desc: msid
 *
 * numOfTags - Type: numeric. Desc: num of tags
 *
 * numberVideos - Type: numeric. Desc: number videos in the channel
 *
 * origin - Type: string. Desc: origin
 *
 * overQuotaVideosCount - Type: numeric. Desc: how many of the videos are OverQ
 *
 * compId - Type: string. Desc: player_id
 *
 * scheduledExists - Type: bool. Desc: scheduled video exists
 *
 * subscriptionEnabledChange - Type: bool. Desc: did you change the subscription option
 *
 * subscriptionEnabled - Type: bool. Desc: subscription enabled
 *
 * subscriptionOnly - Type: bool. Desc: "make paid videos on this channel subscription only" on/off
 *
 * subscriptionOnlyChange - Type: bool. Desc: "make paid videos on this channel subscription only" changed
 *
 * subscriptionPricing - Type: numeric. Desc: doubled by 10000
 *
 * subscriptionPricingChange - Type: bool. Desc: did the price of the subscription change
 *
 * titleAdded - Type: bool. Desc: title added
 *
 * videoID - Type: string. Desc: JSON video_id
 * @param {boChEditUpdateChangesClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditUpdateChangesClicked = function (params) {
    return { evid: 76, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditVideoPricingSelectParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - player_id
* @property {string} target - free/pp/subs
**/
/**
 * Name: bo.chEdit.VideoPricing.Select. Evid: 259.
 * Event description: user select free, pricing plan or subs option in Cannel Settings.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string. Desc: player_id
 *
 * target - Type: string. Desc: free/pp/subs
 * @param {boChEditVideoPricingSelectParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditVideoPricingSelect = function (params) {
    return { evid: 259, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boUploadAddVideosHoveredParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - ADI / editor / МА
* @property {string} compId - player_id
**/
/**
 * Name: bo.upload.addVideos.hovered. Evid: 108.
 * Event description: Sent when user hovers add videos button.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string. Desc: player_id
 * @param {boUploadAddVideosHoveredParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boUploadAddVideosHovered = function (params) {
    return { evid: 108, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibPricingSaveClickedParams
* @property {boolean} downloadChanged - If user changed the download option
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isDownload - if uou can download the video
* @property {boolean} isPurchasable - is the videos for purchase
* @property {boolean} isRental - is the videos for rental
* @property {GUID} biToken - msid
* @property {number} numberVideos - number of videos chosen
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} pricingSelection - free/paid
* @property {boolean} pricingSelectionChange - did the pricing selection changed
* @property {boolean} purchasableChange - did the purchase option changed
* @property {number} purchasePricinig - the price for purchase doubled by 10000
* @property {boolean} purchasePricinigChange - did the purchase price changed
* @property {boolean} rentalChange - did the rental option changed
* @property {string} rentalPeriod - 24/48/72
* @property {boolean} rentalPeriodChange - did the rental period changed
* @property {number} rentalPricinig - the price of renting doubled by 10000
* @property {boolean} rentalPricinigChange - did the rental price changed
* @property {string} videoID - json of video_id
**/
/**
 * Name: bo.lib.pricing.saveClicked. Evid: 49.
 * Event description: Clicking on save set pricing.

 * downloadChanged - Type: bool. Desc: If user changed the download option
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isDownload - Type: bool. Desc: if uou can download the video
 *
 * isPurchasable - Type: bool. Desc: is the videos for purchase
 *
 * isRental - Type: bool. Desc: is the videos for rental
 *
 * biToken - Type: guid. Desc: msid
 *
 * numberVideos - Type: numeric. Desc: number of videos chosen
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * pricingSelection - Type: string. Desc: free/paid
 *
 * pricingSelectionChange - Type: bool. Desc: did the pricing selection changed
 *
 * purchasableChange - Type: bool. Desc: did the purchase option changed
 *
 * purchasePricinig - Type: numeric. Desc: the price for purchase doubled by 10000
 *
 * purchasePricinigChange - Type: bool. Desc: did the purchase price changed
 *
 * rentalChange - Type: bool. Desc: did the rental option changed
 *
 * rentalPeriod - Type: string. Desc: 24/48/72
 *
 * rentalPeriodChange - Type: bool. Desc: did the rental period changed
 *
 * rentalPricinig - Type: numeric. Desc: the price of renting doubled by 10000
 *
 * rentalPricinigChange - Type: bool. Desc: did the rental price changed
 *
 * videoID - Type: string. Desc: json of video_id
 * @param {boLibPricingSaveClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibPricingSaveClicked = function (params) {
    return { evid: 49, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} mobileAppSetLoadFinishedParams
* @property {string} editorMode - editorMode
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isFirst - first time open the app settings
* @property {string} layoutType - classic/strip/compact
* @property {number} loading_time - loading time
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {boolean} success - t / f
**/
/**
 * Name: mobileAppSet.load.finished. Evid: 264.
 * Event description: Mobile app settings load start.

 * editorMode - Type: string. Desc: editorMode
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isFirst - Type: bool. Desc: first time open the app settings
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * loading_time - Type: numeric. Desc: loading time
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * success - Type: bool. Desc: t / f
 * @param {mobileAppSetLoadFinishedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobileAppSetLoadFinished = function (params) {
    return { evid: 264, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsFeatureChannelPopUpOpenedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.featureChannelPopUp.opened. Evid: 346.
 * Event description: "feature a Channel" modal opened.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsFeatureChannelPopUpOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsFeatureChannelPopUpOpened = function (params) {
    return { evid: 346, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditPricingPlanConnectedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} planIDs - plan_id
* @property {string} compId - player_id
**/
/**
 * Name: bo.chEdit.PricingPlan.connected. Evid: 261.
 * Event description: user connected pricing plan  in Channel Settings, but not saved yet.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * planIDs - Type: string. Desc: plan_id
 *
 * compId - Type: string. Desc: player_id
 * @param {boChEditPricingPlanConnectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditPricingPlanConnected = function (params) {
    return { evid: 261, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boGeneralErrorNotCompleteActionParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - ADI / editor / МА
* @property {string} compId - player_id
**/
/**
 * Name: bo.general.error.notCompleteAction. Evid: 98.
 * Event description: Error state action not complete.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string. Desc: player_id
 * @param {boGeneralErrorNotCompleteActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boGeneralErrorNotCompleteAction = function (params) {
    return { evid: 98, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageUnsavedChangesPopUpLeaveClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.unsavedChangesPopUp.leave.click. Evid: 332.
 * Event description: click on leave in ""unsaved changes"" pop up.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageUnsavedChangesPopUpLeaveClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageUnsavedChangesPopUpLeaveClick = function (params) {
    return { evid: 332, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsPromoteVideoPopUpChannelPickerLoadedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.promoteVideoPopUp.channelPicker.loaded. Evid: 345.
 * Event description: the channel picker loaded.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsPromoteVideoPopUpChannelPickerLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsPromoteVideoPopUpChannelPickerLoaded = function (params) {
    return { evid: 345, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boUploadAddVideosLoginAndAddVideoButtonClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - first_video/add_videos_menu
* @property {string} compId - player_id
**/
/**
 * Name: bo.upload.addVideos.loginAndAddVideo.button.clicked. Evid: 163.
 * Event description: Sent when user clicks on "Login and Add Video" button in embed video window.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: first_video/add_videos_menu
 *
 * compId - Type: string. Desc: player_id
 * @param {boUploadAddVideosLoginAndAddVideoButtonClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boUploadAddVideosLoginAndAddVideoButtonClicked = function (params) {
    return { evid: 163, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boWelcomeScreenClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - editor/ADI/my account
* @property {string} compId - player_id
**/
/**
 * Name: bo.welcomeScreen.clicked. Evid: 122.
 * Event description: Clicked on the let's go button in the bo welcome screen.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: editor/ADI/my account
 *
 * compId - Type: string. Desc: player_id
 * @param {boWelcomeScreenClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boWelcomeScreenClicked = function (params) {
    return { evid: 122, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditRemovePopUpBtnClickedParams
* @property {string} button - delete/cancel
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {boolean} overQuoted - is video id under OverQuota, true / false
* @property {string} compId - player_id
* @property {string} videoID - videoID
**/
/**
 * Name: bo.chEdit.remove.popUpBtn.clicked. Evid: 82.
 * Event description: Button delete or cancel in the remove video form channel popup.

 * button - Type: string. Desc: delete/cancel
 *
 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * overQuoted - Type: bool. Desc: is video id under OverQuota, true / false
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: videoID
 * @param {boChEditRemovePopUpBtnClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditRemovePopUpBtnClicked = function (params) {
    return { evid: 82, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appNewLiveChannelChooseClickParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
**/
/**
 * Name: app.newLive.channel.choose.click. Evid: 631.
 * Event description: User click on channel to choose where to start new live.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 * @param {appNewLiveChannelChooseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appNewLiveChannelChooseClick = function (params) {
    return { evid: 631, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibBatchEditSaveCompletedParams
* @property {string} audience - (all/mature)
* @property {boolean} audienceChanged - did the audience changed
* @property {boolean} categoryExists - did categories added
* @property {string} genre - genre
* @property {boolean} genreChanged - did the genre changed
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isSuccess - save completed successfully or not
* @property {string} errorMsg - error message the user see
* @property {GUID} biToken - msid
* @property {number} numOfCastMembers - number of cast members
* @property {number} numOfCrewMembers - number of crew members
* @property {number} numOfTags - number of tags
* @property {number} numVideoEdit - number of videos user edit
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {boolean} publisherExists - did publisher added
* @property {string} source - computer/vimeo/facebook/youtube
* @property {string} videoID - new_videoID
* @property {string} videoType - video type
* @property {boolean} videoTypeChanged - did the video type changed
**/
/**
 * Name: bo.lib.batchEdit.save.completed. Evid: 144.
 * Event description: Save completed at the video library (batch edit).

 * audience - Type: string. Desc: (all/mature)
 *
 * audienceChanged - Type: bool. Desc: did the audience changed
 *
 * categoryExists - Type: bool. Desc: did categories added
 *
 * genre - Type: string. Desc: genre
 *
 * genreChanged - Type: bool. Desc: did the genre changed
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isSuccess - Type: bool. Desc: save completed successfully or not
 *
 * errorMsg - Type: string. Desc: error message the user see
 *
 * biToken - Type: guid. Desc: msid
 *
 * numOfCastMembers - Type: numeric. Desc: number of cast members
 *
 * numOfCrewMembers - Type: numeric. Desc: number of crew members
 *
 * numOfTags - Type: numeric. Desc: number of tags
 *
 * numVideoEdit - Type: numeric. Desc: number of videos user edit
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * publisherExists - Type: bool. Desc: did publisher added
 *
 * source - Type: string. Desc: computer/vimeo/facebook/youtube
 *
 * videoID - Type: string. Desc: new_videoID
 *
 * videoType - Type: string. Desc: video type
 *
 * videoTypeChanged - Type: bool. Desc: did the video type changed
 * @param {boLibBatchEditSaveCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibBatchEditSaveCompleted = function (params) {
    return { evid: 144, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetVidShareClickedParams
* @property {string} button - facebook/twitter/pinterest/tumblr/link
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - on_site/embed
* @property {string} compId - player_id
* @property {string} shareType - video/channel
* @property {string} siteUrl - site url (only when embed video)
* @property {string} videoID - videoID
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.vid.share.clicked. Evid: 225.
 * Event description: Share butten clicked.

 * button - Type: string. Desc: facebook/twitter/pinterest/tumblr/link
 *
 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: on_site/embed
 *
 * compId - Type: string. Desc: player_id
 *
 * shareType - Type: string. Desc: video/channel
 *
 * siteUrl - Type: string. Desc: site url (only when embed video)
 *
 * videoID - Type: string. Desc: videoID
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetVidShareClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetVidShareClicked = function (params) {
    return { evid: 225, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibChooseLogoPopUpSettingsClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoId - video_id
**/
/**
 * Name: bo.lib.chooseLogoPopUp.settings.click. Evid: 180.
 * Event description: click on settings word in choose logo pop up.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoId - Type: string. Desc: video_id
 * @param {boLibChooseLogoPopUpSettingsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibChooseLogoPopUpSettingsClick = function (params) {
    return { evid: 180, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appLiveSlowNetworkEndParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
* @property {string} videoID - video_id
**/
/**
 * Name: app.live.slowNetwork.end. Evid: 665.
 * Event description: end after when network speed is ok.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 *
 * videoID - Type: string. Desc: video_id
 * @param {appLiveSlowNetworkEndParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appLiveSlowNetworkEnd = function (params) {
    return { evid: 665, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetSettingsShowInfoChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isShowInfo - Choosing to show video info on the player or not
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - editor / ADI (null is editor)
* @property {string} playVideo - in_the_frame/expanded_view
* @property {string} compId - player_id
**/
/**
 * Name: appSet.settings.showInfo.changed. Evid: 14.
 * Event description: Choosing to show video info on the player or not.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isShowInfo - Type: bool. Desc: Choosing to show video info on the player or not
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: editor / ADI (null is editor)
 *
 * playVideo - Type: string. Desc: in_the_frame/expanded_view
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetSettingsShowInfoChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetSettingsShowInfoChanged = function (params) {
    return { evid: 14, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetVidClickedParams
* @property {string} buttonName - play_video / next_video
* @property {string} channelID - channelID
* @property {string} correlationId - ID for one unique view connection
* @property {number} duration - duration of full video in ms
* @property {GUID} videoInstanceID - null
* @property {GUID} biToken - null
* @property {boolean} overQuoted - is video id under OverQuota, true / false
* @property {string} compId - null
* @property {string} videoID - video id
* @property {string} videoType - facebook/youtube/computer/vimeo/live
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.vid.clicked. Evid: 128.
 * Event description: play video clicked.

 * buttonName - Type: string. Desc: play_video / next_video
 *
 * channelID - Type: string. Desc: channelID
 *
 * correlationId - Type: string. Desc: ID for one unique view connection
 *
 * duration - Type: numeric. Desc: duration of full video in ms
 *
 * videoInstanceID - Type: guid.
 *
 * biToken - Type: guid.
 *
 * overQuoted - Type: bool. Desc: is video id under OverQuota, true / false
 *
 * compId - Type: string.
 *
 * videoID - Type: string. Desc: video id
 *
 * videoType - Type: string. Desc: facebook/youtube/computer/vimeo/live
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetVidClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetVidClicked = function (params) {
    return { evid: 128, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boOverQuotaStateParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {boolean} overQuoted - true for over-quoted video appear
* @property {string} compId - null
* @property {string} source - upload / live
* @property {string} videoID - video_id
**/
/**
 * Name: bo.overQuota.state. Evid: 363.
 * Event description: User downgrades / changes premium and get his videos over-quoted.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * overQuoted - Type: bool. Desc: true for over-quoted video appear
 *
 * compId - Type: string.
 *
 * source - Type: string. Desc: upload / live
 *
 * videoID - Type: string. Desc: video_id
 * @param {boOverQuotaStateParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boOverQuotaState = function (params) {
    return { evid: 363, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageAddCardClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.addCard.click. Evid: 164.
 * Event description: click on "Add a card" in video page.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageAddCardClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageAddCardClick = function (params) {
    return { evid: 164, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChDefaultChTooltipSettingsHoverParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - player_id
**/
/**
 * Name: bo.ch.defaultChTooltipSettings.hover. Evid: 72.
 * Event description: Tool tip settings hovered in the default channel.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string. Desc: player_id
 * @param {boChDefaultChTooltipSettingsHoverParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChDefaultChTooltipSettingsHover = function (params) {
    return { evid: 72, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boStatsExportcsvClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - ADI / editor / МА
* @property {string} compId - player_id
* @property {string} tabName - Channels/Videos
**/
/**
 * Name: bo.stats.exportCSV.clicked. Evid: 23.
 * Event description: Clicking on the export CSV button.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string. Desc: player_id
 *
 * tabName - Type: string. Desc: Channels/Videos
 * @param {boStatsExportcsvClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boStatsExportcsvClicked = function (params) {
    return { evid: 23, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetChCoverBtnClickedParams
* @property {string} button - startWatching/watchPreview/subscribe
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.chCover.btn.clicked. Evid: 205.
 * Event description: Clicked cover button (start watching, watch preview or subscribe).

 * button - Type: string. Desc: startWatching/watchPreview/subscribe
 *
 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetChCoverBtnClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetChCoverBtnClicked = function (params) {
    return { evid: 205, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appLiveCountdownMessageAppearParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
* @property {string} videoID - video_id
**/
/**
 * Name: app.live.countdownMessage.appear. Evid: 653.
 * Event description: Countdown message appears to user.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 *
 * videoID - Type: string. Desc: video_id
 * @param {appLiveCountdownMessageAppearParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appLiveCountdownMessageAppear = function (params) {
    return { evid: 653, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageTrailerProcessingCompletedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isFirst - first time uploading
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - null
* @property {string} source - upload/drive/dropbox
* @property {boolean} success - true = trailer processed successfully
**/
/**
 * Name: bo.vidPage.trailer.processing.completed. Evid: 815.
 * Event description: Auto-generated trailer processing completed..

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isFirst - Type: bool. Desc: first time uploading
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string.
 *
 * source - Type: string. Desc: upload/drive/dropbox
 *
 * success - Type: bool. Desc: true = trailer processed successfully
 * @param {boVidPageTrailerProcessingCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageTrailerProcessingCompleted = function (params) {
    return { evid: 815, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsVideoPlayStartParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} playSource - keyboard/play_button/screen_click
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.video.play.start. Evid: 335.
 * Event description: video start play in video cards section (after 71:337).

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * playSource - Type: string. Desc: keyboard/play_button/screen_click
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsVideoPlayStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsVideoPlayStart = function (params) {
    return { evid: 335, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsCardEditClickParams
* @property {string} cardName - promote_video/feature_channel/promote_product/get_social_followers/custom
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.card.edit.click. Evid: 327.
 * Event description: click on edit card (Pencil) image or on the card’s title.

 * cardName - Type: string. Desc: promote_video/feature_channel/promote_product/get_social_followers/custom
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsCardEditClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsCardEditClick = function (params) {
    return { evid: 327, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsSaveCompletedParams
* @property {string} cardsOrientation - vertical/horizontal
* @property {string} cardsPosition - top_left/top_right/bottom_left/bottom_right
* @property {boolean} embed - embed toggle on/off
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isPurchasable - is the videos for purchase
* @property {boolean} isRental - is the videos for rental
* @property {boolean} isSuccess - save success or not
* @property {string} errorMsg - error message if save fail
* @property {GUID} biToken - msid
* @property {string} numberOfBoostSales - number of boost sales cards
* @property {number} numberOfCards - number of cards after this session
* @property {string} numberOfCardsUpdated - number of cards updated in this session
* @property {string} numberOfCardsCreated - number of cards created in this session
* @property {string} numberOfCardsDeleted - number of cards deleted in this session
* @property {string} numberOfCustomText - number of custom texts
* @property {string} numberOfIncreaseSocial - number of get increase social followers
* @property {string} numberOfPromoteChannel - number of promote channel cards
* @property {string} numberOfPromoteVideo - number of promote video cards
* @property {string} origin - my_account/editor/ADI
* @property {boolean} overQuoted - is video id under OverQuota, true / false
* @property {string} compId - player_id
* @property {string} pricingSelection - free/paid
* @property {string} saveOrigin - popup/cards_page
* @property {string} videoID - new_videoID
**/
/**
 * Name: bo.vidPage.videoCards.save.completed. Evid: 330.
 * Event description: Save  completed at the video cards section / unsaved changes popup.

 * cardsOrientation - Type: string. Desc: vertical/horizontal
 *
 * cardsPosition - Type: string. Desc: top_left/top_right/bottom_left/bottom_right
 *
 * embed - Type: bool. Desc: embed toggle on/off
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isPurchasable - Type: bool. Desc: is the videos for purchase
 *
 * isRental - Type: bool. Desc: is the videos for rental
 *
 * isSuccess - Type: bool. Desc: save success or not
 *
 * errorMsg - Type: string. Desc: error message if save fail
 *
 * biToken - Type: guid. Desc: msid
 *
 * numberOfBoostSales - Type: string. Desc: number of boost sales cards
 *
 * numberOfCards - Type: numeric. Desc: number of cards after this session
 *
 * numberOfCardsUpdated - Type: string. Desc: number of cards updated in this session
 *
 * numberOfCardsCreated - Type: string. Desc: number of cards created in this session
 *
 * numberOfCardsDeleted - Type: string. Desc: number of cards deleted in this session
 *
 * numberOfCustomText - Type: string. Desc: number of custom texts
 *
 * numberOfIncreaseSocial - Type: string. Desc: number of get increase social followers
 *
 * numberOfPromoteChannel - Type: string. Desc: number of promote channel cards
 *
 * numberOfPromoteVideo - Type: string. Desc: number of promote video cards
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * overQuoted - Type: bool. Desc: is video id under OverQuota, true / false
 *
 * compId - Type: string. Desc: player_id
 *
 * pricingSelection - Type: string. Desc: free/paid
 *
 * saveOrigin - Type: string. Desc: popup/cards_page
 *
 * videoID - Type: string. Desc: new_videoID
 * @param {boVidPageVideoCardsSaveCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsSaveCompleted = function (params) {
    return { evid: 330, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appCameraButtonClickParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - from where user click on the button (new_video/schedualed_video,live)
* @property {string} compId - null
**/
/**
 * Name: app.cameraButton.click. Evid: 606.
 * Event description: User click on camera button  in go live screen.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: from where user click on the button (new_video/schedualed_video,live)
 *
 * compId - Type: string.
 * @param {appCameraButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appCameraButtonClick = function (params) {
    return { evid: 606, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetLayoutActionBarShowActionBarChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {boolean} toggle - TRUE/FALSE
**/
/**
 * Name: appSet.layout.actionBar.showActionBar.changed. Evid: 173.
 * Event description: User change  show action bar in  appSet.layout.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * toggle - Type: bool. Desc: TRUE/FALSE
 * @param {appSetLayoutActionBarShowActionBarChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetLayoutActionBarShowActionBarChanged = function (params) {
    return { evid: 173, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageStoreClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} storeName - apple/google
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.store.click. Evid: 168.
 * Event description: Click on Google Play store or Apple store image.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * storeName - Type: string. Desc: apple/google
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageStoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageStoreClick = function (params) {
    return { evid: 168, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibDeleteVideoPopupDeleteBtnClickedParams
* @property {string} button - batch/video page
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {number} numberVideos - number of videos chosen
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - json of video_id
**/
/**
 * Name: bo.lib.deleteVideo.popup.deleteBtn.clicked. Evid: 55.
 * Event description: Clicking delete in the delete video popup.

 * button - Type: string. Desc: batch/video page
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * numberVideos - Type: numeric. Desc: number of videos chosen
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: json of video_id
 * @param {boLibDeleteVideoPopupDeleteBtnClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibDeleteVideoPopupDeleteBtnClicked = function (params) {
    return { evid: 55, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} upgradeButtonClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: upgrade.button.click. Evid: 2.
 * Event description: Clicking  the upgrade button on the gfpp.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {upgradeButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var upgradeButtonClick = function (params) {
    return { evid: 2, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appLiveEndCameraRollAccessButtonClickParams
* @property {string} buttonName - ok/not
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
* @property {string} videoID - video_id
**/
/**
 * Name: app.live.end.cameraRollAccess.button.click. Evid: 659.
 * Event description: in camera roll access user click on don't allow or ok.

 * buttonName - Type: string. Desc: ok/not
 *
 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 *
 * videoID - Type: string. Desc: video_id
 * @param {appLiveEndCameraRollAccessButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appLiveEndCameraRollAccessButtonClick = function (params) {
    return { evid: 659, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibAddToChannelSaveBtnClickedParams
* @property {string} channelID - json of channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {number} numberChannels - number of channels the video added to
* @property {number} numberVideos - number of videos added
* @property {string} origin - my_account/editor/ADI
* @property {number} overQuotaVideosCount - how many of the videos are OverQ
* @property {string} compId - player_id
* @property {string} videoID - json of video_id
**/
/**
 * Name: bo.lib.addToChannel.saveBtn.clicked. Evid: 57.
 * Event description: Clicking save button to add videos to channel.

 * channelID - Type: string. Desc: json of channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * numberChannels - Type: numeric. Desc: number of channels the video added to
 *
 * numberVideos - Type: numeric. Desc: number of videos added
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * overQuotaVideosCount - Type: numeric. Desc: how many of the videos are OverQ
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: json of video_id
 * @param {boLibAddToChannelSaveBtnClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibAddToChannelSaveBtnClicked = function (params) {
    return { evid: 57, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appChooseScheduledVideoClickParams
* @property {string} entryPoint - from which entry point user see live screen (bottom_bar/quick_actions/feed_card/more_apps)
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
**/
/**
 * Name: app.chooseScheduledVideo.click. Evid: 602.
 * Event description: User click on "choose scheduled video" button.

 * entryPoint - Type: string. Desc: from which entry point user see live screen (bottom_bar/quick_actions/feed_card/more_apps)
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 * @param {appChooseScheduledVideoClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appChooseScheduledVideoClick = function (params) {
    return { evid: 602, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boSettingsBackToBackofficeClickedParams
* @property {string} backToTab - library/channels
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.settings.backToBackoffice.clicked. Evid: 420.
 * Event description: Clicking on "Back To Library" button in bo.settings.

 * backToTab - Type: string. Desc: library/channels
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boSettingsBackToBackofficeClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boSettingsBackToBackofficeClicked = function (params) {
    return { evid: 420, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageUnsavedChangesPopUpCloseClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.unsavedChangesPopUp.close.click. Evid: 333.
 * Event description: click on close in "unsaved changes" pop up.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageUnsavedChangesPopUpCloseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageUnsavedChangesPopUpCloseClick = function (params) {
    return { evid: 333, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetSettingsChannelOptionsShowVideoListChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isShowVideoList - Choosing to show video list or not
* @property {GUID} biToken - null
* @property {string} compId - player_id
**/
/**
 * Name: appSet.settings.channelOptions.ShowVideoList.changed. Evid: 9.
 * Event description: Choosing to show video list or not
(a strip layout event).

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isShowVideoList - Type: bool. Desc: Choosing to show video list or not
 *
 * biToken - Type: guid.
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetSettingsChannelOptionsShowVideoListChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetSettingsChannelOptionsShowVideoListChanged = function (params) {
    return { evid: 9, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageTrailerProcessingStartParams
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isFirst - first time uploading
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - null
* @property {string} source - upload/drive/dropbox
**/
/**
 * Name: bo.vidPage.trailer.processing.start. Evid: 814.
 * Event description: Auto-generated trailer processing started..

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isFirst - Type: bool. Desc: first time uploading
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string.
 *
 * source - Type: string. Desc: upload/drive/dropbox
 * @param {boVidPageTrailerProcessingStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageTrailerProcessingStart = function (params) {
    return { evid: 814, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appNextClickParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
* @property {string} videoType - scheduled/new
**/
/**
 * Name: app.next.click. Evid: 605.
 * Event description: User click on "Next" button when starting  live.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 *
 * videoType - Type: string. Desc: scheduled/new
 * @param {appNextClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appNextClick = function (params) {
    return { evid: 605, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetTagsClickedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.tags.clicked. Evid: 210.
 * Event description: Tags button clicked.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetTagsClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetTagsClicked = function (params) {
    return { evid: 210, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageCancelButtonClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoId - video_id
**/
/**
 * Name: bo.vidPage.cancelButton.click. Evid: 136.
 * Event description: Clicking cancel in video page.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoId - Type: string. Desc: video_id
 * @param {boVidPageCancelButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageCancelButtonClick = function (params) {
    return { evid: 136, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageTrailerAddTrailerClickParams
* @property {string} actionName - add/change
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - videoID
**/
/**
 * Name: bo.vidPage.trailer.addTrailer.click. Evid: 139.
 * Event description: click on add trailer or change trailer.

 * actionName - Type: string. Desc: add/change
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: videoID
 * @param {boVidPageTrailerAddTrailerClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageTrailerAddTrailerClick = function (params) {
    return { evid: 139, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boStatsTabClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - ADI / editor / МА
* @property {string} compId - player_id
* @property {string} newTabName - QuickStats/Channels/Videos
**/
/**
 * Name: bo.stats.tab.clicked. Evid: 25.
 * Event description: Clicking on tab QuickStats/Channels/Videos in the stats page.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string. Desc: player_id
 *
 * newTabName - Type: string. Desc: QuickStats/Channels/Videos
 * @param {boStatsTabClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boStatsTabClicked = function (params) {
    return { evid: 25, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetMainNewChannelClickedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isFirst - first time clicking on new channel button
* @property {GUID} biToken - null
* @property {string} compId - player_id
**/
/**
 * Name: appSet.main.newChannel.clicked. Evid: 4.
 * Event description: Clicking on new channel button.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isFirst - Type: bool. Desc: first time clicking on new channel button
 *
 * biToken - Type: guid.
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetMainNewChannelClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetMainNewChannelClicked = function (params) {
    return { evid: 4, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidChangeCoverCompletedParams
* @property {string} coverOrigin - upload/exist
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - new_videoID
**/
/**
 * Name: bo.vid.changeCover.completed. Evid: 64.
 * Event description: changing cover completed.

 * coverOrigin - Type: string. Desc: upload/exist
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: new_videoID
 * @param {boVidChangeCoverCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidChangeCoverCompleted = function (params) {
    return { evid: 64, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetSubscriptionClickedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.subscription.clicked. Evid: 208.
 * Event description: Subscription click from widget.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetSubscriptionClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetSubscriptionClicked = function (params) {
    return { evid: 208, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsCustomCardPopUpOpenedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.customCardPopUp.opened. Evid: 354.
 * Event description: "custom card" pop up opened.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsCustomCardPopUpOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsCustomCardPopUpOpened = function (params) {
    return { evid: 354, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appLiveSlowNetworkStartParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
* @property {string} videoID - video_id
**/
/**
 * Name: app.live.slowNetwork.start. Evid: 664.
 * Event description: Starting when network speed is slow.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 *
 * videoID - Type: string. Desc: video_id
 * @param {appLiveSlowNetworkStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appLiveSlowNetworkStart = function (params) {
    return { evid: 664, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appGoLiveShareClickParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
**/
/**
 * Name: app.goLive.share.click. Evid: 645.
 * Event description: User click on share button in "Go Live" screen.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 * @param {appGoLiveShareClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appGoLiveShareClick = function (params) {
    return { evid: 645, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibUpgradeStateButtonClickParams
* @property {string} button - Upgrade_Now /Clear
* @property {string} buttonType - state/tool_tip
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my account/editor/ADI
* @property {boolean} overQuoted - is video id under OverQuota, true / false
* @property {string} compId - player_id
* @property {string} upgradeState - free_more_than_10/free_more_30_min_package/exceeds_package_limit
* @property {string} videoID - videoID
**/
/**
 * Name: bo.lib.upgrade.state.button.click. Evid: 93.
 * Event description: Clicking a button (Upgrade Now /Clear) in upgrade state.

 * button - Type: string. Desc: Upgrade_Now /Clear
 *
 * buttonType - Type: string. Desc: state/tool_tip
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my account/editor/ADI
 *
 * overQuoted - Type: bool. Desc: is video id under OverQuota, true / false
 *
 * compId - Type: string. Desc: player_id
 *
 * upgradeState - Type: string. Desc: free_more_than_10/free_more_30_min_package/exceeds_package_limit
 *
 * videoID - Type: string. Desc: videoID
 * @param {boLibUpgradeStateButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibUpgradeStateButtonClick = function (params) {
    return { evid: 93, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageSaveSaveCompletedParams
* @property {string} audience - (all/mature)
* @property {boolean} audienceChanged - did the audience changed
* @property {boolean} categoryExists - did categories added
* @property {string} channelID - channel is for scheduled live
* @property {boolean} coverUploaded - did cover uploaded
* @property {DateTime} dateStartLive - go live on date & hour
* @property {boolean} dateStartLiveChanged - go live on date or hour changed
* @property {boolean} descriptionExists - did description added
* @property {boolean} downloadChanged - If user changed the download option
* @property {boolean} embed - embed toggle on/off
* @property {boolean} embedChanged - if the user change the embed toggle
* @property {boolean} embedInfo - info button in embed option on/off
* @property {boolean} embedInfoChanged - info button in embed option changed
* @property {boolean} embedLogo - embed custom logo checkbox on/off
* @property {boolean} embedLogoChanged - embed custom logo changed
* @property {string} embedLogoOption - custom logo in embed options value (control_bar/always)
* @property {boolean} embedLogoOptionChanged - custom logo options changed (show on control bar/ always)
* @property {boolean} embedShare - share button in embed options on/off
* @property {boolean} embedShareChanged - share button in embed options changed
* @property {boolean} embedVideoTitle - video title on/off in embed options
* @property {boolean} embedVideoTitleChanged - video title in embed options changed
* @property {string} errorType - error message when user tried to save
* @property {string} genre - genre
* @property {boolean} genreChanged - did the genre changed
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isDownload - if uou can download the video
* @property {boolean} isPurchasable - is the videos for purchase
* @property {boolean} isRental - is the videos for rental
* @property {GUID} biToken - msid
* @property {number} numOfCastMembers - number of cast members
* @property {number} numOfCrewMembers - number of crew members
* @property {number} numOfTags - number of tags
* @property {number} numVideoEdit - number of videos user edit
* @property {string} origin - my_account/editor/ADI
* @property {boolean} overQuoted - is video id under OverQuota, true / false
* @property {string} compId - player_id
* @property {boolean} posterExists - did poster uploaded
* @property {string} pricingSelection - free/paid
* @property {boolean} pricingSelectionChange - did the pricing selection changed
* @property {boolean} publisherExists - did publisher added
* @property {boolean} purchasableChange - did the purchase option changed
* @property {number} purchasePricinig - doubled by 10000
* @property {boolean} purchasePricinigChange - did the purchase price changed
* @property {boolean} rentalChange - did the rental option changed
* @property {string} rentalPeriod - 24/48/72
* @property {boolean} rentalPeriodChange - did the rental period changed
* @property {number} rentalPricinig - doubled by 10000
* @property {boolean} rentalPricinigChange - did the rental price changed
* @property {boolean} showTrailer - show trailer toggle on/off
* @property {boolean} showTrailerChanged - show trailer toggle changed
* @property {boolean} signUpToWatch - sign up to watch toggle on/off
* @property {boolean} signUpToWatchChanged - user changed sign up to watch toggle
* @property {string} source - computer/vimeo/facebook/youtube
* @property {boolean} isSuccess - save complete ok
* @property {boolean} titleChanged - user changed the video title
* @property {string} trailer - preview/traliler/auto_generated/DontShow
* @property {boolean} trailerChanged - did the trailer changed
* @property {boolean} videoChanged - user changed the video from video library
* @property {string} videoID - new_videoID
* @property {string} videoType - video type
* @property {boolean} videoTypeChanged - did the video type changed
**/
/**
 * Name: bo.vidPage.save.saveCompleted. Evid: 68.
 * Event description: Save completed at the video page / live event page.

 * audience - Type: string. Desc: (all/mature)
 *
 * audienceChanged - Type: bool. Desc: did the audience changed
 *
 * categoryExists - Type: bool. Desc: did categories added
 *
 * channelID - Type: string. Desc: channel is for scheduled live
 *
 * coverUploaded - Type: bool. Desc: did cover uploaded
 *
 * dateStartLive - Type: datetime. Desc: go live on date & hour
 *
 * dateStartLiveChanged - Type: bool. Desc: go live on date or hour changed
 *
 * descriptionExists - Type: bool. Desc: did description added
 *
 * downloadChanged - Type: bool. Desc: If user changed the download option
 *
 * embed - Type: bool. Desc: embed toggle on/off
 *
 * embedChanged - Type: bool. Desc: if the user change the embed toggle
 *
 * embedInfo - Type: bool. Desc: info button in embed option on/off
 *
 * embedInfoChanged - Type: bool. Desc: info button in embed option changed
 *
 * embedLogo - Type: bool. Desc: embed custom logo checkbox on/off
 *
 * embedLogoChanged - Type: bool. Desc: embed custom logo changed
 *
 * embedLogoOption - Type: string. Desc: custom logo in embed options value (control_bar/always)
 *
 * embedLogoOptionChanged - Type: bool. Desc: custom logo options changed (show on control bar/ always)
 *
 * embedShare - Type: bool. Desc: share button in embed options on/off
 *
 * embedShareChanged - Type: bool. Desc: share button in embed options changed
 *
 * embedVideoTitle - Type: bool. Desc: video title on/off in embed options
 *
 * embedVideoTitleChanged - Type: bool. Desc: video title in embed options changed
 *
 * errorType - Type: string. Desc: error message when user tried to save
 *
 * genre - Type: string. Desc: genre
 *
 * genreChanged - Type: bool. Desc: did the genre changed
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isDownload - Type: bool. Desc: if uou can download the video
 *
 * isPurchasable - Type: bool. Desc: is the videos for purchase
 *
 * isRental - Type: bool. Desc: is the videos for rental
 *
 * biToken - Type: guid. Desc: msid
 *
 * numOfCastMembers - Type: numeric. Desc: number of cast members
 *
 * numOfCrewMembers - Type: numeric. Desc: number of crew members
 *
 * numOfTags - Type: numeric. Desc: number of tags
 *
 * numVideoEdit - Type: numeric. Desc: number of videos user edit
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * overQuoted - Type: bool. Desc: is video id under OverQuota, true / false
 *
 * compId - Type: string. Desc: player_id
 *
 * posterExists - Type: bool. Desc: did poster uploaded
 *
 * pricingSelection - Type: string. Desc: free/paid
 *
 * pricingSelectionChange - Type: bool. Desc: did the pricing selection changed
 *
 * publisherExists - Type: bool. Desc: did publisher added
 *
 * purchasableChange - Type: bool. Desc: did the purchase option changed
 *
 * purchasePricinig - Type: numeric. Desc: doubled by 10000
 *
 * purchasePricinigChange - Type: bool. Desc: did the purchase price changed
 *
 * rentalChange - Type: bool. Desc: did the rental option changed
 *
 * rentalPeriod - Type: string. Desc: 24/48/72
 *
 * rentalPeriodChange - Type: bool. Desc: did the rental period changed
 *
 * rentalPricinig - Type: numeric. Desc: doubled by 10000
 *
 * rentalPricinigChange - Type: bool. Desc: did the rental price changed
 *
 * showTrailer - Type: bool. Desc: show trailer toggle on/off
 *
 * showTrailerChanged - Type: bool. Desc: show trailer toggle changed
 *
 * signUpToWatch - Type: bool. Desc: sign up to watch toggle on/off
 *
 * signUpToWatchChanged - Type: bool. Desc: user changed sign up to watch toggle
 *
 * source - Type: string. Desc: computer/vimeo/facebook/youtube
 *
 * isSuccess - Type: bool. Desc: save complete ok
 *
 * titleChanged - Type: bool. Desc: user changed the video title
 *
 * trailer - Type: string. Desc: preview/traliler/auto_generated/DontShow
 *
 * trailerChanged - Type: bool. Desc: did the trailer changed
 *
 * videoChanged - Type: bool. Desc: user changed the video from video library
 *
 * videoID - Type: string. Desc: new_videoID
 *
 * videoType - Type: string. Desc: video type
 *
 * videoTypeChanged - Type: bool. Desc: did the video type changed
 * @param {boVidPageSaveSaveCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageSaveSaveCompleted = function (params) {
    return { evid: 68, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidChangeCoverSetAsCoverClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - ADI / editor / МА
* @property {string} compId - null
**/
/**
 * Name: bo.vid.changeCover.setAsCover.clicked. Evid: 125.
 * Event description: Click on set as a cover in change video cover box - We don't shoot this event, we have event 64 for it.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string.
 * @param {boVidChangeCoverSetAsCoverClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidChangeCoverSetAsCoverClicked = function (params) {
    return { evid: 125, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetRenderCompleteParams
* @property {GUID} videoInstanceID - InstanceID
* @property {number} loadingTime - ms
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {string} viewMode - editor/viewer
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.renderComplete. Evid: 256.
 * Event description: widget.renderComplete.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * loadingTime - Type: numeric. Desc: ms
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * viewMode - Type: string. Desc: editor/viewer
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetRenderCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetRenderComplete = function (params) {
    return { evid: 256, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetVidInfoDisplayedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {string} videoID - videoID
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.vid.info.displayed. Evid: 222.
 * Event description: Info butten displayed.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: videoID
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetVidInfoDisplayedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetVidInfoDisplayed = function (params) {
    return { evid: 222, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boGeneralCancelUploadPopUpClickParams
* @property {string} button - Delete/Cancel
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.general.cancelUploadPopUp.click. Evid: 41.
 * Event description: In cancel upload popup which button did he clicked.

 * button - Type: string. Desc: Delete/Cancel
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boGeneralCancelUploadPopUpClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boGeneralCancelUploadPopUpClick = function (params) {
    return { evid: 41, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetVideoCardsAllCardsCloseClickParams
* @property {GUID} videoInstanceID - instance_id
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {string} siteUrl - site url when video embeded
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.videoCards.allCards.close.click. Evid: 253.
 * Event description: UoU click close on  4th button overlay.

 * videoInstanceID - Type: guid. Desc: instance_id
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * siteUrl - Type: string. Desc: site url when video embeded
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetVideoCardsAllCardsCloseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetVideoCardsAllCardsCloseClick = function (params) {
    return { evid: 253, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boEmailMarketingPreviewClickedParams
* @property {GUID} videoInstanceID - null
* @property {GUID} biToken - null
* @property {string} origin - ADI / editor / МА
* @property {string} compId - null
* @property {string} templateType - Share Video/Promote Channel/Send Newsletter
**/
/**
 * Name: bo.emailMarketing.preview.clicked. Evid: 151.
 * Event description: Click on preview button in email marketing tab.

 * videoInstanceID - Type: guid.
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string.
 *
 * templateType - Type: string. Desc: Share Video/Promote Channel/Send Newsletter
 * @param {boEmailMarketingPreviewClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boEmailMarketingPreviewClicked = function (params) {
    return { evid: 151, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appErrorPageButtonClickParams
* @property {string} buttonName - refresh/got_it/save_to_device/resume/end_live
* @property {string} channelID - channel_id (if we have)
* @property {number} errorCode - error code
* @property {string} errorType - storage/connection_lost etc.
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
* @property {string} videoID - video_id (if we have)
**/
/**
 * Name: app.errorPage.button.click. Evid: 611.
 * Event description: When user in error page and click on button:
Refresh - General error screen
Got It / Save to device - No option to resume live
Resume / End live - User can resume live or when user re-open the app.

 * buttonName - Type: string. Desc: refresh/got_it/save_to_device/resume/end_live
 *
 * channelID - Type: string. Desc: channel_id (if we have)
 *
 * errorCode - Type: numeric. Desc: error code
 *
 * errorType - Type: string. Desc: storage/connection_lost etc.
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 *
 * videoID - Type: string. Desc: video_id (if we have)
 * @param {appErrorPageButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appErrorPageButtonClick = function (params) {
    return { evid: 611, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsGetSocialFollowersPopUpEnterUrlParsingCompleteParams
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isSuccess - parsing complete success or not
* @property {string} errorMsg - error message if parsing failed
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} source - Facebook/Twitter/YouTube/NULL
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.GetSocialFollowersPopUp.enterUrl.parsingComplete. Evid: 351.
 * Event description: send after user enter the URL and parsing complete.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isSuccess - Type: bool. Desc: parsing complete success or not
 *
 * errorMsg - Type: string. Desc: error message if parsing failed
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: Facebook/Twitter/YouTube/NULL
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsGetSocialFollowersPopUpEnterUrlParsingCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsGetSocialFollowersPopUpEnterUrlParsingComplete = function (params) {
    return { evid: 351, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boStatsChannelsChStatsClickedParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - ADI / editor / МА
* @property {string} compId - player_id
**/
/**
 * Name: bo.stats.channels.chStats.clicked. Evid: 21.
 * Event description: Clicking on the stats of a channel.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string. Desc: player_id
 * @param {boStatsChannelsChStatsClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boStatsChannelsChStatsClicked = function (params) {
    return { evid: 21, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditLaterBtnClickedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - player_id
**/
/**
 * Name: bo.chEdit.laterBtn.clicked. Evid: 78.
 * Event description: Later button clicked.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string. Desc: player_id
 * @param {boChEditLaterBtnClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditLaterBtnClicked = function (params) {
    return { evid: 78, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsActionCardsHowToBannerButtonClickParams
* @property {string} button - show_me_how/close
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.actionCardsHowToBanner.button.click. Evid: 365.
 * Event description: Button click on "how to" action cards banner: close or show me how.

 * button - Type: string. Desc: show_me_how/close
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsActionCardsHowToBannerButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsActionCardsHowToBannerButtonClick = function (params) {
    return { evid: 365, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetDesignMainItemShowMainActionsAsChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} selection - text/icon_buttons
**/
/**
 * Name: appSet.design.mainItem.showMainActionsAs.changed. Evid: 176.
 * Event description: User change  show main actions in appSet.design.mainItem (styleParamName: mainActionStyleType).

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * selection - Type: string. Desc: text/icon_buttons
 * @param {appSetDesignMainItemShowMainActionsAsChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetDesignMainItemShowMainActionsAsChanged = function (params) {
    return { evid: 176, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appStartClickParams
* @property {string} button - get_started/start_new live
* @property {string} entryPoint - from which entry point user see live screen (bottom_bar/quick_actions/feed_card/more_apps)
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
**/
/**
 * Name: app.start.click. Evid: 610.
 * Event description: User click on "Get started" / "Start New Live" button.

 * button - Type: string. Desc: get_started/start_new live
 *
 * entryPoint - Type: string. Desc: from which entry point user see live screen (bottom_bar/quick_actions/feed_card/more_apps)
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 * @param {appStartClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appStartClick = function (params) {
    return { evid: 610, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsPromoteVideoPopUpCancelClickParams
* @property {string} currentStep - In which step user click cancel
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} previousStep - the previous step of the modal
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.promoteVideoPopUp.cancel.click. Evid: 339.
 * Event description: click on cancel in "Promote A Video" modal.

 * currentStep - Type: string. Desc: In which step user click cancel
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * previousStep - Type: string. Desc: the previous step of the modal
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsPromoteVideoPopUpCancelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsPromoteVideoPopUpCancelClick = function (params) {
    return { evid: 339, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetLiveVideoEndedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - instance_id
* @property {GUID} biToken - msid
* @property {string} origin - on_site/embed
* @property {string} compId - player_id
* @property {string} siteUrl - site url (only when embed video)
* @property {string} videoID - videoID
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.live.video.ended. Evid: 281.
 * Event description: When Live video ends.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: instance_id
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: on_site/embed
 *
 * compId - Type: string. Desc: player_id
 *
 * siteUrl - Type: string. Desc: site url (only when embed video)
 *
 * videoID - Type: string. Desc: videoID
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetLiveVideoEndedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetLiveVideoEnded = function (params) {
    return { evid: 281, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLiveEditConnectStreamCloseClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.live.edit.connectStream.close.click. Evid: 461.
 * Event description: Click on Close on Connect stream tab.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boLiveEditConnectStreamCloseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLiveEditConnectStreamCloseClick = function (params) {
    return { evid: 461, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsCustomCardPopUpSaveClickParams
* @property {boolean} buttonExists - Product have call to action button
* @property {string} buttonName - the button name user insert
* @property {boolean} coverExists - if cover exists
* @property {boolean} descriptionExists - Product have description
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isSuggestedButtonName - if the button name is from list or user type
* @property {boolean} linkExists - Product have URL link
* @property {string} errorMsg - error message if save fail
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {boolean} isSuccess - save success or not
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.customCardPopUp.save.click. Evid: 355.
 * Event description: click on save in "Custom Card" pop up.

 * buttonExists - Type: bool. Desc: Product have call to action button
 *
 * buttonName - Type: string. Desc: the button name user insert
 *
 * coverExists - Type: bool. Desc: if cover exists
 *
 * descriptionExists - Type: bool. Desc: Product have description
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isSuggestedButtonName - Type: bool. Desc: if the button name is from list or user type
 *
 * linkExists - Type: bool. Desc: Product have URL link
 *
 * errorMsg - Type: string. Desc: error message if save fail
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * isSuccess - Type: bool. Desc: save success or not
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsCustomCardPopUpSaveClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsCustomCardPopUpSaveClick = function (params) {
    return { evid: 355, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsPromoteProductPopUpUploadImageCompletedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isSuccess - image upload success or not
* @property {string} errorMsg - error message if upload fail
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.promoteProductPopUp.uploadImage.completed. Evid: 326.
 * Event description: upload image in  "Promote A Product" pop up finished.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isSuccess - Type: bool. Desc: image upload success or not
 *
 * errorMsg - Type: string. Desc: error message if upload fail
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsPromoteProductPopUpUploadImageCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsPromoteProductPopUpUploadImageCompleted = function (params) {
    return { evid: 326, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boFeedbackClickedParams
* @property {string} fromTab - video-library/channels/stats/settings
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.feedback.clicked. Evid: 133.
 * Event description: feedback button clicked.

 * fromTab - Type: string. Desc: video-library/channels/stats/settings
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boFeedbackClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boFeedbackClicked = function (params) {
    return { evid: 133, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditDefaultChannelTooltipCloseClickParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor
* @property {string} compId - player_id
**/
/**
 * Name: bo.chEdit.defaultChannel.tooltip.close.click. Evid: 132.
 * Event description: Tooltip about default channel closed.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor
 *
 * compId - Type: string. Desc: player_id
 * @param {boChEditDefaultChannelTooltipCloseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditDefaultChannelTooltipCloseClick = function (params) {
    return { evid: 132, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsPromoteProductPopUpSaveClickParams
* @property {boolean} buttonExists - Product have call to action button
* @property {string} buttonName - the button name user insert
* @property {boolean} coverExists - if cover exists
* @property {boolean} descriptionExists - Product have description
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isSuggestedButtonName - if the button name is from list or user type
* @property {boolean} linkExists - Product have URL link
* @property {string} errorMsg - error message if save fail
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {boolean} isSuccess - save success or not
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.promoteProductPopUp.save.click. Evid: 323.
 * Event description: click on save in "Promote A Product" pop up.

 * buttonExists - Type: bool. Desc: Product have call to action button
 *
 * buttonName - Type: string. Desc: the button name user insert
 *
 * coverExists - Type: bool. Desc: if cover exists
 *
 * descriptionExists - Type: bool. Desc: Product have description
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isSuggestedButtonName - Type: bool. Desc: if the button name is from list or user type
 *
 * linkExists - Type: bool. Desc: Product have URL link
 *
 * errorMsg - Type: string. Desc: error message if save fail
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * isSuccess - Type: bool. Desc: save success or not
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsPromoteProductPopUpSaveClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsPromoteProductPopUpSaveClick = function (params) {
    return { evid: 323, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appLiveStreamInfoParams
* @property {number} avgBitrate - Bitrate
* @property {string} channelID - Channel ID
* @property {GUID} videoInstanceID - videoInstanceID
* @property {GUID} biToken - biToken
* @property {string} path - path
* @property {string} compId - null
* @property {string} rtmpEndPoint - RTMP end point
* @property {string} streamingModuleVer - streaming module version
* @property {string} timeFrame - The time in the video we shoot this event (Not the time the user see the movie)
* @property {string} videoID - ID of video in terms of Wix VOD
**/
/**
 * Name: app.live.stream.info. Evid: 667.
 * Event description: Event with stream info for live(user stream).

 * avgBitrate - Type: numeric. Desc: Bitrate
 *
 * channelID - Type: string. Desc: Channel ID
 *
 * videoInstanceID - Type: guid. Desc: videoInstanceID
 *
 * biToken - Type: guid. Desc: biToken
 *
 * path - Type: string. Desc: path
 *
 * compId - Type: string.
 *
 * rtmpEndPoint - Type: string. Desc: RTMP end point
 *
 * streamingModuleVer - Type: string. Desc: streaming module version
 *
 * timeFrame - Type: string. Desc: The time in the video we shoot this event (Not the time the user see the movie)
 *
 * videoID - Type: string. Desc: ID of video in terms of Wix VOD
 * @param {appLiveStreamInfoParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appLiveStreamInfo = function (params) {
    return { evid: 667, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boUploadCompletedParams
* @property {number} auto_resumed - manual_resumed
* @property {string} button - drag&drop /upload
* @property {number} status_code - status code
* @property {string} correlationId - correlation_id
* @property {string} errorKey - wmp error key
* @property {string} errorScope - OK/failedChecking/failedRequirement/failedTransmission/failedByUseAction/failedProcessing
* @property {string} errorType - OK/networkError/serverError/unknownError/userClosedDashboard/quotaExceeded/invalidFile/notSupported/exceedsMaxSize
* @property {string} fileFormat - file extension
* @property {number} fileSize - file_size
* @property {string} fileType - image / video / audio / doc / folder
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isFirst - first time uploading
* @property {boolean} is_resumable - is download resume available for this file
* @property {boolean} isSuccess - did the upload succesed
* @property {number} loadingTime - loadingTime
* @property {number} manual_resumed - count how many times (in current correlation_id) upload was resumed manually
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} path - url path of a http call that caused the error
* @property {string} compId - player_id
* @property {string} source - upload/drive/dropbox
* @property {string} tracksUploaded - number of files, what was selected to upload including current
**/
/**
 * Name: bo.upload.completed. Evid: 53.
 * Event description: Uploading single video completed. It includes only Drag&drop and upload by clicking on a button for videos library and wellcome screens.

 * auto_resumed - Type: numeric. Desc: manual_resumed
 *
 * button - Type: string. Desc: drag&drop /upload
 *
 * status_code - Type: numeric. Desc: status code
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * errorKey - Type: string. Desc: wmp error key
 *
 * errorScope - Type: string. Desc: OK/failedChecking/failedRequirement/failedTransmission/failedByUseAction/failedProcessing
 *
 * errorType - Type: string. Desc: OK/networkError/serverError/unknownError/userClosedDashboard/quotaExceeded/invalidFile/notSupported/exceedsMaxSize
 *
 * fileFormat - Type: string. Desc: file extension
 *
 * fileSize - Type: numeric. Desc: file_size
 *
 * fileType - Type: string. Desc: image / video / audio / doc / folder
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isFirst - Type: bool. Desc: first time uploading
 *
 * is_resumable - Type: bool. Desc: is download resume available for this file
 *
 * isSuccess - Type: bool. Desc: did the upload succesed
 *
 * loadingTime - Type: numeric. Desc: loadingTime
 *
 * manual_resumed - Type: numeric. Desc: count how many times (in current correlation_id) upload was resumed manually
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * path - Type: string. Desc: url path of a http call that caused the error
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: upload/drive/dropbox
 *
 * tracksUploaded - Type: string. Desc: number of files, what was selected to upload including current
 * @param {boUploadCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boUploadCompleted = function (params) {
    return { evid: 53, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetSettingsTextAlignmentChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {string} layoutType - small_slider/big_slider
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} selection - left / right / center
**/
/**
 * Name: appSet.settings.textAlignment.changed. Evid: 405.
 * Event description: Users changes text alignment, design tab.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * layoutType - Type: string. Desc: small_slider/big_slider
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * selection - Type: string. Desc: left / right / center
 * @param {appSetSettingsTextAlignmentChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetSettingsTextAlignmentChanged = function (params) {
    return { evid: 405, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditChannelSubscriptionOnlyCheckBoxClickParams
* @property {string} channelID - channel_id
* @property {boolean} check_box - on/off
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.chEdit.channelSubscriptionOnly.checkBox.click. Evid: 115.
 * Event description: Sent when user clicks on Make videos on this channel subscription only
check box.

 * channelID - Type: string. Desc: channel_id
 *
 * check_box - Type: bool. Desc: on/off
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boChEditChannelSubscriptionOnlyCheckBoxClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditChannelSubscriptionOnlyCheckBoxClick = function (params) {
    return { evid: 115, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditChannelInfoCancelClickParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - player_id
**/
/**
 * Name: bo.chEdit.channelInfo.cancel.click. Evid: 148.
 * Event description: Click on cancel in channel page.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string. Desc: player_id
 * @param {boChEditChannelInfoCancelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditChannelInfoCancelClick = function (params) {
    return { evid: 148, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boTrailerShowFailToastParams
* @property {string} channelID - channelID
* @property {string} errorType - indication of why auto-generation didn't succeed
* @property {GUID} videoInstanceID - InstanceID
* @property {string} message - toast message
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - null
**/
/**
 * Name: bo.trailer.showFailToast. Evid: 819.
 * Event description: 'your trailer for <yourVideo> couldn't be created' toast appears after unsuccessful auto trailer generation.

 * channelID - Type: string. Desc: channelID
 *
 * errorType - Type: string. Desc: indication of why auto-generation didn't succeed
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * message - Type: string. Desc: toast message
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string.
 * @param {boTrailerShowFailToastParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boTrailerShowFailToast = function (params) {
    return { evid: 819, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boGeneralCancelUploadClickParams
* @property {string} correlationId - id to find one upload process (same as 71:52)
* @property {string} fileFormat - file extension
* @property {number} fileSize - file size in KB
* @property {string} fileType - image / video / audio / doc / folder
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} target - cancel / cancel_upload / go_back / close_popup
**/
/**
 * Name: bo.general.cancelUpload.click. Evid: 42.
 * Event description: Click  on cancel upload.

 * correlationId - Type: string. Desc: id to find one upload process (same as 71:52)
 *
 * fileFormat - Type: string. Desc: file extension
 *
 * fileSize - Type: numeric. Desc: file size in KB
 *
 * fileType - Type: string. Desc: image / video / audio / doc / folder
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * target - Type: string. Desc: cancel / cancel_upload / go_back / close_popup
 * @param {boGeneralCancelUploadClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boGeneralCancelUploadClick = function (params) {
    return { evid: 42, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChNewChannelClickedParams
* @property {string} button - button/box
* @property {string} channelType - channel/youtube-feed
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - player_id
**/
/**
 * Name: bo.ch.newChannel.clicked. Evid: 69.
 * Event description: Add new channel clicked.

 * button - Type: string. Desc: button/box
 *
 * channelType - Type: string. Desc: channel/youtube-feed
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string. Desc: player_id
 * @param {boChNewChannelClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChNewChannelClicked = function (params) {
    return { evid: 69, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetSettingsChannelOptionsShareChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isShare - let the viewers share my channel or not
* @property {string} layoutType - compact / classic etc
* @property {GUID} biToken - msid
* @property {string} origin - editor / ADI
* @property {string} compId - player_id
**/
/**
 * Name: appSet.settings.channelOptions.share.changed. Evid: 8.
 * Event description: Choosing to let the viewers share my channel or not.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isShare - Type: bool. Desc: let the viewers share my channel or not
 *
 * layoutType - Type: string. Desc: compact / classic etc
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: editor / ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetSettingsChannelOptionsShareChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetSettingsChannelOptionsShareChanged = function (params) {
    return { evid: 8, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageLivePopUpDownloadClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} storeName - apple/google
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.livePopUp.download.click. Evid: 380.
 * Event description: Click on Google Play store or Apple store image from download the app in live stream pop up.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * storeName - Type: string. Desc: apple/google
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageLivePopUpDownloadClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageLivePopUpDownloadClick = function (params) {
    return { evid: 380, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetEmbedLoadedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {string} siteUrl - site url (only when embed video)
* @property {number} videoHeight - Actual height of video source
* @property {string} videoID - video_id
* @property {number} videoWidth - Actual width of video source
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.embed.loaded. Evid: 240.
 * Event description: widget from embed site loaded.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * siteUrl - Type: string. Desc: site url (only when embed video)
 *
 * videoHeight - Type: numeric. Desc: Actual height of video source
 *
 * videoID - Type: string. Desc: video_id
 *
 * videoWidth - Type: numeric. Desc: Actual width of video source
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetEmbedLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetEmbedLoaded = function (params) {
    return { evid: 240, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetLayoutDisplayInfoTimestampChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {string} layoutType - small_slider/big_slider
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {boolean} toggle - on / off
**/
/**
 * Name: appSet.layout.displayInfo.timestamp.changed. Evid: 403.
 * Event description: User toggles to show Video timestamp.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * layoutType - Type: string. Desc: small_slider/big_slider
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * toggle - Type: bool. Desc: on / off
 * @param {appSetLayoutDisplayInfoTimestampChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetLayoutDisplayInfoTimestampChanged = function (params) {
    return { evid: 403, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetDownloadVideoClickedParams
* @property {string} channelID - channelID
* @property {number} duration - video duration in ms
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isLive - If video is live
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {string} videoID - videoID
* @property {string} videoType - free/purchased
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.download.video.clicked. Evid: 284.
 * Event description: UoU clicked on download video button.

 * channelID - Type: string. Desc: channelID
 *
 * duration - Type: numeric. Desc: video duration in ms
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isLive - Type: bool. Desc: If video is live
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: videoID
 *
 * videoType - Type: string. Desc: free/purchased
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetDownloadVideoClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetDownloadVideoClicked = function (params) {
    return { evid: 284, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsPromoteVideoPopUpCloseClickParams
* @property {string} currentStep - In which step user click close (promote_a_video/choose_a_channel/
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.promoteVideoPopUp.close.click. Evid: 340.
 * Event description: click on close (X button) in "Promote A Video" modal.

 * currentStep - Type: string. Desc: In which step user click close (promote_a_video/choose_a_channel/
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsPromoteVideoPopUpCloseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsPromoteVideoPopUpCloseClick = function (params) {
    return { evid: 340, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetAdiDisplayElementsShareMyVideosChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isEnabled - true/false
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: appSet.adi.displayElements.shareMyVideos.changed. Evid: 313.
 * Event description: User click on "share my videos" in ADI.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isEnabled - Type: bool. Desc: true/false
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetAdiDisplayElementsShareMyVideosChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetAdiDisplayElementsShareMyVideosChanged = function (params) {
    return { evid: 313, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appLiveConnectionIssueStartParams
* @property {string} channelID - channel_id
* @property {string} errorType - storage/connection_lost etc.
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
* @property {string} videoID - video_id
**/
/**
 * Name: app.live.connectionIssue.start. Evid: 655.
 * Event description: When user have connection issues (connection/storage etc).

 * channelID - Type: string. Desc: channel_id
 *
 * errorType - Type: string. Desc: storage/connection_lost etc.
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 *
 * videoID - Type: string. Desc: video_id
 * @param {appLiveConnectionIssueStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appLiveConnectionIssueStart = function (params) {
    return { evid: 655, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} adiConnectFeedCompletedParams
* @property {string} channelID - channel_id
* @property {number} errorCode - Error code
* @property {GUID} videoInstanceID - InstanceID
* @property {string} errorMsg - Error message
* @property {GUID} biToken - msid
* @property {string} url - the URL address the user entered if add failed
* @property {string} compId - player_id
* @property {string} source - youtube
* @property {boolean} isSuccess - if the connect feed finished successfully
**/
/**
 * Name: ADI.connectFeed.completed. Evid: 396.
 * Event description: Send when user connected youtube feed in ADI.

 * channelID - Type: string. Desc: channel_id
 *
 * errorCode - Type: numeric. Desc: Error code
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * errorMsg - Type: string. Desc: Error message
 *
 * biToken - Type: guid. Desc: msid
 *
 * url - Type: string. Desc: the URL address the user entered if add failed
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: youtube
 *
 * isSuccess - Type: bool. Desc: if the connect feed finished successfully
 * @param {adiConnectFeedCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var adiConnectFeedCompleted = function (params) {
    return { evid: 396, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetVideosSingleVideoAddNewVideoClickParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
**/
/**
 * Name: appSet.videos.singleVideo.addNewVideo.click. Evid: 306.
 * Event description: When user choose click on add new video from appSet.singleVideo.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetVideosSingleVideoAddNewVideoClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetVideosSingleVideoAddNewVideoClick = function (params) {
    return { evid: 306, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChSearchClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - player_id
**/
/**
 * Name: bo.ch.search.clicked. Evid: 70.
 * Event description: Search clicked.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string. Desc: player_id
 * @param {boChSearchClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChSearchClicked = function (params) {
    return { evid: 70, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsPromoteVideoPopUpOpenedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.promoteVideoPopUp.opened. Evid: 337.
 * Event description: "Promote A Video" modal opened.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsPromoteVideoPopUpOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsPromoteVideoPopUpOpened = function (params) {
    return { evid: 337, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageQuickActionActionClickParams
* @property {string} actionName - promote/stats
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} source - computer/vimeo/facebook/youtube
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.quickAction.action.click. Evid: 137.
 * Event description: click on action from quick actions in video page.

 * actionName - Type: string. Desc: promote/stats
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: computer/vimeo/facebook/youtube
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageQuickActionActionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageQuickActionActionClick = function (params) {
    return { evid: 137, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boSettingsDefaultPriceCancelButtonClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.settings.defaultPrice.cancelButton.clicked. Evid: 30.
 * Event description: Clicking cancel in default price edit.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boSettingsDefaultPriceCancelButtonClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boSettingsDefaultPriceCancelButtonClicked = function (params) {
    return { evid: 30, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsPromoteProductPopUpOpenedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.promoteProductPopUp.opened. Evid: 322.
 * Event description: "Promote A Product" pop up opened.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsPromoteProductPopUpOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsPromoteProductPopUpOpened = function (params) {
    return { evid: 322, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLoadedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - ADI / editor / МА
* @property {string} compId - player_id
* @property {string} source - back_office / business_manager
**/
/**
 * Name: bo.loaded. Evid: 119.
 * Event description: The existing  bo.opened (evid=120) event sends when the app starts (aka js inits), this one would send right from the html load.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: back_office / business_manager
 * @param {boLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLoaded = function (params) {
    return { evid: 119, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boTrailerShowToastParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {string} message - toast message
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - null
**/
/**
 * Name: bo.trailer.showToast. Evid: 816.
 * Event description: 'your trailer for <yourVideo> is ready' toast appears after successful auto trailer generation.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * message - Type: string. Desc: toast message
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string.
 * @param {boTrailerShowToastParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boTrailerShowToast = function (params) {
    return { evid: 816, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditVidReorderedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - player_id
* @property {string} videoID - videoID
**/
/**
 * Name: bo.chEdit.vid.reordered. Evid: 87.
 * Event description: Video reordered.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: videoID
 * @param {boChEditVidReorderedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditVidReordered = function (params) {
    return { evid: 87, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appEnableAccessClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
**/
/**
 * Name: app.enableAccess.click. Evid: 603.
 * Event description: User click on "Enable Access" button for camera and mic.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 * @param {appEnableAccessClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appEnableAccessClick = function (params) {
    return { evid: 603, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetExploreThisChannelClickedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.exploreThisChannel.clicked. Evid: 228.
 * Event description: Explore this channel click from widget on the mobile site.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetExploreThisChannelClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetExploreThisChannelClicked = function (params) {
    return { evid: 228, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibVideoItemQuickActionsActionClickParams
* @property {string} actionName - add_card/social/promote
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.lib.videoItem.quickActions.action.click. Evid: 361.
 * Event description: click on an action from quick actions in the video library.

 * actionName - Type: string. Desc: add_card/social/promote
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boLibVideoItemQuickActionsActionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibVideoItemQuickActionsActionClick = function (params) {
    return { evid: 361, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} mobileAppSetLoadStartedParams
* @property {string} editorMode - editorMode
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: mobileAppSet.load.started. Evid: 263.
 * Event description: The existing appSet.opened (evid=100) event sends when the app starts (aka js inits), this one would send right from the html load.

 * editorMode - Type: string. Desc: editorMode
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {mobileAppSetLoadStartedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobileAppSetLoadStarted = function (params) {
    return { evid: 263, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boTrailerClickOnToastParams
* @property {string} button - check_it_out / x
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - null
**/
/**
 * Name: bo.trailer.clickOnToast. Evid: 817.
 * Event description: Fired when user has interaction with auto-generated trailer's toast.

 * button - Type: string. Desc: check_it_out / x
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string.
 * @param {boTrailerClickOnToastParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boTrailerClickOnToast = function (params) {
    return { evid: 817, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boStatsVideosChStatsClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - ADI / editor / МА
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.stats.videos.chStats.clicked. Evid: 22.
 * Event description: Clicking on the stats of a video.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boStatsVideosChStatsClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boStatsVideosChStatsClicked = function (params) {
    return { evid: 22, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boPageLoadedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - MA/Editor/ADI
* @property {string} pageName - Page name (video_library,channels_page etc.)
* @property {string} compId - player_id
* @property {string} previousPage - last page seen by the user
* @property {string} referralInfo - Side_bar, bread_crumbs...
**/
/**
 * Name: bo.page.loaded. Evid: 360.
 * Event description: Video BO page loaded successfully.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: MA/Editor/ADI
 *
 * pageName - Type: string. Desc: Page name (video_library,channels_page etc.)
 *
 * compId - Type: string. Desc: player_id
 *
 * previousPage - Type: string. Desc: last page seen by the user
 *
 * referralInfo - Type: string. Desc: Side_bar, bread_crumbs...
 * @param {boPageLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boPageLoaded = function (params) {
    return { evid: 360, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appVideoListChooseClickParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
* @property {string} videoId - video_id
**/
/**
 * Name: app.videoList.choose.click. Evid: 640.
 * Event description: user click on video to choose scheduled video.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 *
 * videoId - Type: string. Desc: video_id
 * @param {appVideoListChooseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appVideoListChooseClick = function (params) {
    return { evid: 640, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetVidCancelBuyCompletedParams
* @property {string} buyType - buy/rent/buyFrom
* @property {string} channelID - channelID
* @property {string} currency - currency
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {GUID} orderid - orderId
* @property {string} compId - player_id
* @property {number} price - doubled by 10000
* @property {string} videoID - videoID
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.vid.cancelBuy.Completed. Evid: 227.
 * Event description: Cancel buying from Paypal.

 * buyType - Type: string. Desc: buy/rent/buyFrom
 *
 * channelID - Type: string. Desc: channelID
 *
 * currency - Type: string. Desc: currency
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * orderid - Type: guid. Desc: orderId
 *
 * compId - Type: string. Desc: player_id
 *
 * price - Type: numeric. Desc: doubled by 10000
 *
 * videoID - Type: string. Desc: videoID
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetVidCancelBuyCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetVidCancelBuyCompleted = function (params) {
    return { evid: 227, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boEmailMarketingUseThisTemplateChooseCloseClickParams
* @property {GUID} videoInstanceID - null
* @property {GUID} biToken - null
* @property {string} origin - ADI / editor / МА
* @property {string} compId - null
* @property {string} templateType - Share Video/Promote Channel/Send Newsletter
**/
/**
 * Name: bo.emailMarketing.useThisTemplate.choose.close.click. Evid: 156.
 * Event description: Click on close in choose a channel/video box from use this template button in email marketing tab.

 * videoInstanceID - Type: guid.
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string.
 *
 * templateType - Type: string. Desc: Share Video/Promote Channel/Send Newsletter
 * @param {boEmailMarketingUseThisTemplateChooseCloseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boEmailMarketingUseThisTemplateChooseCloseClick = function (params) {
    return { evid: 156, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetPlayerShowSignInChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isEnabled - toggle on/off
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: appSet.player.showSignIn.changed. Evid: 302.
 * Event description: User change in appSet.player "show sign in"  toggle.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isEnabled - Type: bool. Desc: toggle on/off
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetPlayerShowSignInChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetPlayerShowSignInChanged = function (params) {
    return { evid: 302, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibDeleteVideoPopupCancelBtnClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.lib.deleteVideo.popup.cancelBtn.clicked. Evid: 54.
 * Event description: Clicking  cancel delete video in the popup.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boLibDeleteVideoPopupCancelBtnClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibDeleteVideoPopupCancelBtnClicked = function (params) {
    return { evid: 54, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsGetSocialFollowersPopUpOpenedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.GetSocialFollowersPopUp.opened. Evid: 350.
 * Event description: "Get Social Followers" pop up opened.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsGetSocialFollowersPopUpOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsGetSocialFollowersPopUpOpened = function (params) {
    return { evid: 350, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetSettingsChannelOptionsShowCategoriesChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isCategories - Choosing to show categories or not
* @property {string} layoutType - classic / grid / slider / strip
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: appSet.settings.channelOptions.showCategories.changed. Evid: 11.
 * Event description: Choosing to show categories or not.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isCategories - Type: bool. Desc: Choosing to show categories or not
 *
 * layoutType - Type: string. Desc: classic / grid / slider / strip
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetSettingsChannelOptionsShowCategoriesChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetSettingsChannelOptionsShowCategoriesChanged = function (params) {
    return { evid: 11, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLiveConnectStreamClosePopupClickParams
* @property {string} button - close / cancel / got_it
* @property {boolean} dontShow - true / false
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.live.connectStream.closePopup.click. Evid: 465.
 * Event description: Click on 'You're still live' pop up.

 * button - Type: string. Desc: close / cancel / got_it
 *
 * dontShow - Type: bool. Desc: true / false
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boLiveConnectStreamClosePopupClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLiveConnectStreamClosePopupClick = function (params) {
    return { evid: 465, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditChannelInfoSaveClickedParams
* @property {string} channelID - channelID
* @property {boolean} descriptionExists - if description exist
* @property {boolean} hasCustomCover - has channel custom cover
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} planIDs - list of plan_id
* @property {string} compId - player_id
* @property {boolean} pricingPlanEnabled - true/false
* @property {boolean} subscriptionEnabled - is subscription enable
* @property {boolean} subscriptionOnlyChange - if subscription changed
* @property {number} subscriptionPricing - subscription price doubled by 10000
* @property {boolean} titleChanged - title changed
**/
/**
 * Name: bo.chEdit.channelInfo.save.clicked. Evid: 159.
 * Event description: click on "save" in channel info.

 * channelID - Type: string. Desc: channelID
 *
 * descriptionExists - Type: bool. Desc: if description exist
 *
 * hasCustomCover - Type: bool. Desc: has channel custom cover
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * planIDs - Type: string. Desc: list of plan_id
 *
 * compId - Type: string. Desc: player_id
 *
 * pricingPlanEnabled - Type: bool. Desc: true/false
 *
 * subscriptionEnabled - Type: bool. Desc: is subscription enable
 *
 * subscriptionOnlyChange - Type: bool. Desc: if subscription changed
 *
 * subscriptionPricing - Type: numeric. Desc: subscription price doubled by 10000
 *
 * titleChanged - Type: bool. Desc: title changed
 * @param {boChEditChannelInfoSaveClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditChannelInfoSaveClicked = function (params) {
    return { evid: 159, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetLoadCompleteParams
* @property {GUID} videoInstanceID - InstanceID
* @property {number} loadingTime - in ms
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {string} viewMode - editor/viewer
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.loadComplete. Evid: 257.
 * Event description: widget.loadComplete.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * loadingTime - Type: numeric. Desc: in ms
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * viewMode - Type: string. Desc: editor/viewer
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetLoadCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetLoadComplete = function (params) {
    return { evid: 257, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetCategoriesClickedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.categories.clicked. Evid: 213.
 * Event description: Categories  button clicked.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetCategoriesClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetCategoriesClicked = function (params) {
    return { evid: 213, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditScheduleClickedParams
* @property {string} action - set/change
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - player_id
* @property {string} source - computer/dropbox/drive/youtube/vimeo/facebook
* @property {string} videoID - videoID
**/
/**
 * Name: bo.chEdit.schedule.clicked. Evid: 79.
 * Event description: Schedule button clicked.

 * action - Type: string. Desc: set/change
 *
 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: computer/dropbox/drive/youtube/vimeo/facebook
 *
 * videoID - Type: string. Desc: videoID
 * @param {boChEditScheduleClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditScheduleClicked = function (params) {
    return { evid: 79, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appAccessPopUpButtonClickParams
* @property {string} buttonName - dont_allow/ok
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
* @property {string} privilegeName - microphone/camera etc
**/
/**
 * Name: app.accessPopUp.button.click. Evid: 604.
 * Event description: User clicks on "Don't Allow" / "Ok" in access pop up.

 * buttonName - Type: string. Desc: dont_allow/ok
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 *
 * privilegeName - Type: string. Desc: microphone/camera etc
 * @param {appAccessPopUpButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appAccessPopUpButtonClick = function (params) {
    return { evid: 604, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boUploadTotalCompleteParams
* @property {number} auto_resumed - count how many times (in current correlation_id) upload was resumed manually
* @property {boolean} batch - true/false (several files in one import)
* @property {number} batchSize - amount of files
* @property {string} button - drag&drop /upload
* @property {string} correlationId - id to find one upload process (same as 71:52)
* @property {string} fileFormat - file extension
* @property {number} fileSize - file size in KB
* @property {string} fileType - image / video / audio / doc / folder
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isFirst - first time uploading
* @property {boolean} is_resumable - is download resume available for this file
* @property {boolean} isSuccess - whether ALL videos were successfully uploaded
* @property {number} loadingTime - loading_time
* @property {number} manual_resumed - count how many times (in current correlation_id) upload was resumed automatically
* @property {GUID} biToken - msid
* @property {number} numberOfFailedUploads - How many files failed to upload
* @property {number} numberOfSuccessfulUploads - How many filed were successfully uploaded
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} source - upload/drive/dropbox
**/
/**
 * Name: bo.upload.totalComplete. Evid: 105.
 * Event description: Sent when upload (single file of multiple files) is totally finished, meaning all files were proceeded (successfully uploaded or failed). It includes only Drag&drop and upload by clicking on a button for videos library and wellcome screens.

 * auto_resumed - Type: numeric. Desc: count how many times (in current correlation_id) upload was resumed manually
 *
 * batch - Type: bool. Desc: true/false (several files in one import)
 *
 * batchSize - Type: numeric. Desc: amount of files
 *
 * button - Type: string. Desc: drag&drop /upload
 *
 * correlationId - Type: string. Desc: id to find one upload process (same as 71:52)
 *
 * fileFormat - Type: string. Desc: file extension
 *
 * fileSize - Type: numeric. Desc: file size in KB
 *
 * fileType - Type: string. Desc: image / video / audio / doc / folder
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isFirst - Type: bool. Desc: first time uploading
 *
 * is_resumable - Type: bool. Desc: is download resume available for this file
 *
 * isSuccess - Type: bool. Desc: whether ALL videos were successfully uploaded
 *
 * loadingTime - Type: numeric. Desc: loading_time
 *
 * manual_resumed - Type: numeric. Desc: count how many times (in current correlation_id) upload was resumed automatically
 *
 * biToken - Type: guid. Desc: msid
 *
 * numberOfFailedUploads - Type: numeric. Desc: How many files failed to upload
 *
 * numberOfSuccessfulUploads - Type: numeric. Desc: How many filed were successfully uploaded
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: upload/drive/dropbox
 * @param {boUploadTotalCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boUploadTotalComplete = function (params) {
    return { evid: 105, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetVidBuyClickedParams
* @property {string} button - thumbnail/main/cover/lightbox
* @property {string} buyType - buy/rent/buyFrom
* @property {string} channelID - channelID
* @property {string} currency - currency
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - on_site/embed
* @property {string} compId - player_id
* @property {number} price - doubled by 10000
* @property {string} siteUrl - site url (only when embed video)
* @property {string} videoID - videoID
* @property {string} videoType - computer / youtube etc
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.vid.buy.clicked. Evid: 220.
 * Event description: Buy button clicked on video.

 * button - Type: string. Desc: thumbnail/main/cover/lightbox
 *
 * buyType - Type: string. Desc: buy/rent/buyFrom
 *
 * channelID - Type: string. Desc: channelID
 *
 * currency - Type: string. Desc: currency
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: on_site/embed
 *
 * compId - Type: string. Desc: player_id
 *
 * price - Type: numeric. Desc: doubled by 10000
 *
 * siteUrl - Type: string. Desc: site url (only when embed video)
 *
 * videoID - Type: string. Desc: videoID
 *
 * videoType - Type: string. Desc: computer / youtube etc
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetVidBuyClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetVidBuyClicked = function (params) {
    return { evid: 220, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditQuickActionActionClickParams
* @property {string} actionName - promote/stats
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - player_id
**/
/**
 * Name: bo.chEdit.quickAction.action.click. Evid: 146.
 * Event description: Click on quick actions button in channel page (promote/stats).
For delete we have 81.

 * actionName - Type: string. Desc: promote/stats
 *
 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string. Desc: player_id
 * @param {boChEditQuickActionActionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditQuickActionActionClick = function (params) {
    return { evid: 146, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetPlayerActionsInMenuShareChannelToggleChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {string} layoutType - small_slider/big_slider
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {boolean} toggle - on / off
**/
/**
 * Name: appSet.design.useOptimalFont.changed. Evid: 319.
 * Event description: User changed toggle Use optimal font sizes on Design tab in App Set.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * layoutType - Type: string. Desc: small_slider/big_slider
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * toggle - Type: bool. Desc: on / off
 * @param {appSetPlayerActionsInMenuShareChannelToggleChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetPlayerActionsInMenuShareChannelToggleChanged = function (params) {
    return { evid: 319, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditAddVidsCompletedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {boolean} overQuoted - is video id under OverQuota, true / false
* @property {string} compId - player_id
* @property {string} source - computer/dropbox/drive/youtube/vimeo/facebook
* @property {string} videoID - videoID
**/
/**
 * Name: bo.chEdit.addVids.completed. Evid: 84.
 * Event description: Choose video to add.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * overQuoted - Type: bool. Desc: is video id under OverQuota, true / false
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: computer/dropbox/drive/youtube/vimeo/facebook
 *
 * videoID - Type: string. Desc: videoID
 * @param {boChEditAddVidsCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditAddVidsCompleted = function (params) {
    return { evid: 84, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetLayoutVideoListShowVideoTitlesChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} selection - on_hover/always/never
**/
/**
 * Name: appSet.layout.videoList.showVideoTitles.changed. Evid: 175.
 * Event description: User change  show video titels in appSet.layout.videoList ( the old name was showInfoAction).

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * selection - Type: string. Desc: on_hover/always/never
 * @param {appSetLayoutVideoListShowVideoTitlesChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetLayoutVideoListShowVideoTitlesChanged = function (params) {
    return { evid: 175, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boSettingsLogoAdditionalActionsClickParams
* @property {string} button_name - change_logo/make_default/delete/remove_default
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.settings.logo.additionalActions.click. Evid: 185.
 * Event description: click on one of additional actions in settings.logo section (change logo,make default,remove_default and delete).

 * button_name - Type: string. Desc: change_logo/make_default/delete/remove_default
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boSettingsLogoAdditionalActionsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boSettingsLogoAdditionalActionsClick = function (params) {
    return { evid: 185, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetSettingsPlayTypeChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} selection - in_frame/expanded_view
**/
/**
 * Name: appSet.settings.playType.changed. Evid: 172.
 * Event description: User change in appSet.settings the play option.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * selection - Type: string. Desc: in_frame/expanded_view
 * @param {appSetSettingsPlayTypeChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetSettingsPlayTypeChanged = function (params) {
    return { evid: 172, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetVidCommentsLoginRequestedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isSingleVideo - true for single / false for channel
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {string} source - live/computer/drive/dropbox
* @property {string} videoID - videoID
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.vid.commentsLogin.requested. Evid: 286.
 * Event description: Clicked on "Get the conversation started" in comments (Annoto) and all other logins.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isSingleVideo - Type: bool. Desc: true for single / false for channel
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: live/computer/drive/dropbox
 *
 * videoID - Type: string. Desc: videoID
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetVidCommentsLoginRequestedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetVidCommentsLoginRequested = function (params) {
    return { evid: 286, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appDeleteVideoPopUpButtonClickParams
* @property {string} buttonName - cancel/delete
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - video_list/end_screen
* @property {string} compId - null
* @property {string} videoID - video_id
**/
/**
 * Name: app.deleteVideoPopUp.button.click. Evid: 612.
 * Event description: After clicking on Delete Video button ,User click on cancel / Delete in  delete pop up.

 * buttonName - Type: string. Desc: cancel/delete
 *
 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: video_list/end_screen
 *
 * compId - Type: string.
 *
 * videoID - Type: string. Desc: video_id
 * @param {appDeleteVideoPopUpButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appDeleteVideoPopUpButtonClick = function (params) {
    return { evid: 612, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.click. Evid: 165.
 * Event description: click on "Video Cards" section in video page.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsClick = function (params) {
    return { evid: 165, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLiveStreamScheduledPopUpOpenedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.live.streamScheduledPopUp.opened. Evid: 476.
 * Event description: 'Your live stream has been scheduled'  pop up open.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boLiveStreamScheduledPopUpOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLiveStreamScheduledPopUpOpened = function (params) {
    return { evid: 476, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appNewLiveChannelTitleClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
**/
/**
 * Name: app.newLive.channelTitle.click. Evid: 630.
 * Event description: User click on channel title button when starting new live.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 * @param {appNewLiveChannelTitleClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appNewLiveChannelTitleClick = function (params) {
    return { evid: 630, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetCommentsToggleLiveStreamCommentsClickParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isEnabled - Comments on/off on live streams
* @property {boolean} isSingleVideo - true for single / false for channel
* @property {GUID} biToken - msid
* @property {string} compId - player_id
**/
/**
 * Name: appSet.comments.toggleLiveStreamComments.click. Evid: 238.
 * Event description: Click on "On live streams" toggle on Comments tab in app setting.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isEnabled - Type: bool. Desc: Comments on/off on live streams
 *
 * isSingleVideo - Type: bool. Desc: true for single / false for channel
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetCommentsToggleLiveStreamCommentsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetCommentsToggleLiveStreamCommentsClick = function (params) {
    return { evid: 238, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetLayoutNumberVideoRowsChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} selection - 1,2,3,4,5,6,7,8,9,10
**/
/**
 * Name: appSet.layout.numberVideoRows.changed. Evid: 312.
 * Event description: User change in appSet the number of video rows.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * selection - Type: string. Desc: 1,2,3,4,5,6,7,8,9,10
 * @param {appSetLayoutNumberVideoRowsChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetLayoutNumberVideoRowsChanged = function (params) {
    return { evid: 312, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boEmailMarketingPreviewPromoteCloseClickParams
* @property {GUID} videoInstanceID - null
* @property {GUID} biToken - null
* @property {string} origin - ADI / editor / МА
* @property {string} compId - null
* @property {string} templateType - Share Video/Promote Channel/Send Newsletter
**/
/**
 * Name: bo.emailMarketing.preview.promote.close.click. Evid: 158.
 * Event description: Click on close in promote box from preview in email marketing tab.

 * videoInstanceID - Type: guid.
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string.
 *
 * templateType - Type: string. Desc: Share Video/Promote Channel/Send Newsletter
 * @param {boEmailMarketingPreviewPromoteCloseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boEmailMarketingPreviewPromoteCloseClick = function (params) {
    return { evid: 158, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibAddLivestreamButtonClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.lib.addLivestreamButton.click. Evid: 255.
 * Event description: User clicks on +Livestream button in a library (which opens Livestream tab).

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boLibAddLivestreamButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibAddLivestreamButtonClick = function (params) {
    return { evid: 255, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appLiveEndDeleteVideoClickParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
* @property {string} videoID - video_id
**/
/**
 * Name: app.live.end.deleteVideo.click. Evid: 658.
 * Event description: After live ends user click on delete video button.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 *
 * videoID - Type: string. Desc: video_id
 * @param {appLiveEndDeleteVideoClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appLiveEndDeleteVideoClick = function (params) {
    return { evid: 658, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageLivePopUpCloseClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.livePopUp.close.click. Evid: 381.
 * Event description: click on close (X) in the live pop up.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageLivePopUpCloseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageLivePopUpCloseClick = function (params) {
    return { evid: 381, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetVidPlayedParams
* @property {string} button - thumbnail/main
* @property {string} channelID - channelID
* @property {string} correlationId - ID for one unique view connection
* @property {number} duration - duration of full video in ms
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isAutoplay - If video start autoplay or user click on play
* @property {boolean} isLive - If video is live
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {string} videoID - videoID
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.vid.played. Evid: 218.
 * Event description: Video played.

 * button - Type: string. Desc: thumbnail/main
 *
 * channelID - Type: string. Desc: channelID
 *
 * correlationId - Type: string. Desc: ID for one unique view connection
 *
 * duration - Type: numeric. Desc: duration of full video in ms
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isAutoplay - Type: bool. Desc: If video start autoplay or user click on play
 *
 * isLive - Type: bool. Desc: If video is live
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: videoID
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetVidPlayedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetVidPlayed = function (params) {
    return { evid: 218, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetLayoutLayoutChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - editor / ADI (null is editor)
* @property {string} compId - player_id
* @property {string} selection - classic/strip
**/
/**
 * Name: appSet.layout.layoutChanged. Evid: 6.
 * Event description: Choosing layout between classic or strip.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: editor / ADI (null is editor)
 *
 * compId - Type: string. Desc: player_id
 *
 * selection - Type: string. Desc: classic/strip
 * @param {appSetLayoutLayoutChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetLayoutLayoutChanged = function (params) {
    return { evid: 6, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boPopUpClickParams
* @property {string} channelID - channelID
* @property {string} choice - yes / no
* @property {GUID} videoInstanceID - InstanceID
* @property {string} message - old_subs_to_free etc
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - player_id
* @property {string} target - continue / close
**/
/**
 * Name: bo.popUp.Click. Evid: 267.
 * Event description: click in any pop up.

 * channelID - Type: string. Desc: channelID
 *
 * choice - Type: string. Desc: yes / no
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * message - Type: string. Desc: old_subs_to_free etc
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string. Desc: player_id
 *
 * target - Type: string. Desc: continue / close
 * @param {boPopUpClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boPopUpClick = function (params) {
    return { evid: 267, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boTabClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} newTabName - video-library/channels/stats/settings
**/
/**
 * Name: bo.tab.clicked. Evid: 121.
 * Event description: Tab clicked in the back office.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * newTabName - Type: string. Desc: video-library/channels/stats/settings
 * @param {boTabClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boTabClicked = function (params) {
    return { evid: 121, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsFeatureChannelPopUpDismissClickParams
* @property {string} buttonName - cancel/close
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.featureChannelPopUp.dismiss.click. Evid: 347.
 * Event description: click on cancel or X (close) button in Feature a Channel pop up.

 * buttonName - Type: string. Desc: cancel/close
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsFeatureChannelPopUpDismissClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsFeatureChannelPopUpDismissClick = function (params) {
    return { evid: 347, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageLiveLearnMoreClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.live.learnMore.click. Evid: 167.
 * Event description: Click on learn more in live stream section.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageLiveLearnMoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageLiveLearnMoreClick = function (params) {
    return { evid: 167, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boSettingsReviewContactsClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.settings.reviewContacts.clicked. Evid: 37.
 * Event description: Clicking on review contacts.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boSettingsReviewContactsClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boSettingsReviewContactsClicked = function (params) {
    return { evid: 37, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appNewLiveAddTitleClickParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
**/
/**
 * Name: app.newLive.addTitle.click. Evid: 632.
 * Event description: User click on "tap to add a title..".

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 * @param {appNewLiveAddTitleClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appNewLiveAddTitleClick = function (params) {
    return { evid: 632, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetVidSelectedDisplayedParams
* @property {boolean} buyBtn - is there a buy button
* @property {string} buyType - rent/from/none
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {boolean} overQuoted - is video id under OverQuota, true / false
* @property {boolean} playBtn - is there a play button
* @property {string} compId - player_id
* @property {boolean} trailerBtn - is there a trailer button
* @property {string} trailerType - preview/trailer
* @property {string} videoID - videoID
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.VidSelected.displayed. Evid: 203.
 * Event description: Video selected displayed.

 * buyBtn - Type: bool. Desc: is there a buy button
 *
 * buyType - Type: string. Desc: rent/from/none
 *
 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * overQuoted - Type: bool. Desc: is video id under OverQuota, true / false
 *
 * playBtn - Type: bool. Desc: is there a play button
 *
 * compId - Type: string. Desc: player_id
 *
 * trailerBtn - Type: bool. Desc: is there a trailer button
 *
 * trailerType - Type: string. Desc: preview/trailer
 *
 * videoID - Type: string. Desc: videoID
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetVidSelectedDisplayedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetVidSelectedDisplayed = function (params) {
    return { evid: 203, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} siteBaseMigrationFinishedParams
* @property {string} errorType - error
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isSuccess - did the migration succeed
* @property {number} loadingTime - ms, migration process duration
* @property {GUID} biToken - msid
* @property {boolean} overQuoted - is overQuoted before migration (at least one video marked as OQ)
* @property {string} compId - null
* @property {number} sitesCount - sites_count
* @property {number} uploadedVideosDuration - ms, uploaded_videos_duration to see overquota
* @property {GUID} uuid - uuid
* @property {number} videosCount - videos_count
**/
/**
 * Name: siteBaseMigration.finished. Evid: 799.
 * Event description: Site Base Migration for reg users triggered by Video BO open finished.

 * errorType - Type: string. Desc: error
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isSuccess - Type: bool. Desc: did the migration succeed
 *
 * loadingTime - Type: numeric. Desc: ms, migration process duration
 *
 * biToken - Type: guid. Desc: msid
 *
 * overQuoted - Type: bool. Desc: is overQuoted before migration (at least one video marked as OQ)
 *
 * compId - Type: string.
 *
 * sitesCount - Type: numeric. Desc: sites_count
 *
 * uploadedVideosDuration - Type: numeric. Desc: ms, uploaded_videos_duration to see overquota
 *
 * uuid - Type: guid. Desc: uuid
 *
 * videosCount - Type: numeric. Desc: videos_count
 * @param {siteBaseMigrationFinishedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteBaseMigrationFinished = function (params) {
    return { evid: 799, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetEmbedVidPlayClickedParams
* @property {string} channelID - channelID
* @property {string} correlationId - ID for one unique view connection
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {boolean} overQuoted - is video id under OverQuota, true / false
* @property {string} compId - player_id
* @property {string} siteUrl - site url (only when embed video)
* @property {number} videoHeight - Actual height of video source
* @property {string} videoID - videoID
* @property {string} videoType - facebook/youtube/computer/vimeo
* @property {number} videoWidth - Actual width of video source
* @property {GUID} visitorID - visitor_id
**/
/**
 * Name: widget.embed.vid.play.clicked. Evid: 242.
 * Event description: play video clicked.

 * channelID - Type: string. Desc: channelID
 *
 * correlationId - Type: string. Desc: ID for one unique view connection
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * overQuoted - Type: bool. Desc: is video id under OverQuota, true / false
 *
 * compId - Type: string. Desc: player_id
 *
 * siteUrl - Type: string. Desc: site url (only when embed video)
 *
 * videoHeight - Type: numeric. Desc: Actual height of video source
 *
 * videoID - Type: string. Desc: videoID
 *
 * videoType - Type: string. Desc: facebook/youtube/computer/vimeo
 *
 * videoWidth - Type: numeric. Desc: Actual width of video source
 *
 * visitorID - Type: guid. Desc: visitor_id
 * @param {widgetEmbedVidPlayClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetEmbedVidPlayClicked = function (params) {
    return { evid: 242, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boOnboardingOpendParams
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isFirst - first time open the back office
* @property {number} loading_time - loading time
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.onboarding.opend. Evid: 127.
 * Event description: Sent when new onboarding open for user in the first time the app opened.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isFirst - Type: bool. Desc: first time open the back office
 *
 * loading_time - Type: numeric. Desc: loading time
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boOnboardingOpendParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boOnboardingOpend = function (params) {
    return { evid: 127, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidChangeVideoClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {boolean} overQuoted - is video id under OverQuota, true / false
* @property {string} compId - player_id
* @property {string} source - computer/vimeo/facebook/youtube
* @property {string} videoID - old_videoID
**/
/**
 * Name: bo.vid.changeVideo.click. Evid: 61.
 * Event description: Clicking change video.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * overQuoted - Type: bool. Desc: is video id under OverQuota, true / false
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: computer/vimeo/facebook/youtube
 *
 * videoID - Type: string. Desc: old_videoID
 * @param {boVidChangeVideoClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidChangeVideoClick = function (params) {
    return { evid: 61, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditConnectFeedEnterUrlParsingCompletedParams
* @property {number} errorCode - Error code
* @property {string} errorMsg - Error message
* @property {string} errorType - client-parse-error/client-unknown-source-error/server-error/unknown-error
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isSuccess - If the parsing complete successfully
* @property {GUID} biToken - msid
* @property {string} origin - new_feed/change_feed
* @property {string} url - The URL  user insert if parsing failed
* @property {string} compId - player_id
* @property {string} source - youtube
**/
/**
 * Name: bo.chEdit.connectFeed.enterUrl.parsingCompleted. Evid: 117.
 * Event description: Sent when url is parsed  successfully when adding feed.

 * errorCode - Type: numeric. Desc: Error code
 *
 * errorMsg - Type: string. Desc: Error message
 *
 * errorType - Type: string. Desc: client-parse-error/client-unknown-source-error/server-error/unknown-error
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isSuccess - Type: bool. Desc: If the parsing complete successfully
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: new_feed/change_feed
 *
 * url - Type: string. Desc: The URL  user insert if parsing failed
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: youtube
 * @param {boChEditConnectFeedEnterUrlParsingCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditConnectFeedEnterUrlParsingCompleted = function (params) {
    return { evid: 117, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetActionBarOpenClickParams
* @property {string} channelID - channel id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.actionBar.open.click. Evid: 231.
 * Event description: UoU click on "hamburger" to open action bar.

 * channelID - Type: string. Desc: channel id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetActionBarOpenClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetActionBarOpenClick = function (params) {
    return { evid: 231, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetSettingsShareVidsChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isShareVids - Choosing to let viewers share my videos
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} playVideo - in_the_frame/expanded_view
* @property {string} compId - player_id
**/
/**
 * Name: appSet.settings.shareVids.changed. Evid: 13.
 * Event description: Choosing to let viewers share my videos.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isShareVids - Type: bool. Desc: Choosing to let viewers share my videos
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * playVideo - Type: string. Desc: in_the_frame/expanded_view
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetSettingsShareVidsChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetSettingsShareVidsChanged = function (params) {
    return { evid: 13, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetMainConnectPaypalClickedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isFirst - is_first
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: appSet.main.connectPaypal.clicked. Evid: 400.
 * Event description: User click on "connect" word in the bottom of appSet.main to connect paypal.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isFirst - Type: bool. Desc: is_first
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetMainConnectPaypalClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetMainConnectPaypalClicked = function (params) {
    return { evid: 400, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibAddLogoPopUpCancelClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoId - video_id
**/
/**
 * Name: bo.lib.addLogoPopUp.cancel.click. Evid: 183.
 * Event description: click on cancel in "add a custom logo" popup.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoId - Type: string. Desc: video_id
 * @param {boLibAddLogoPopUpCancelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibAddLogoPopUpCancelClick = function (params) {
    return { evid: 183, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibAddToChannelCancelBtnClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.lib.addToChannel.cancelBtn.clicked. Evid: 58.
 * Event description: Clicking cancel add to channel.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boLibAddToChannelCancelBtnClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibAddToChannelCancelBtnClicked = function (params) {
    return { evid: 58, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsChannelPickerGotItClickParams
* @property {string} cardType - promote_video/feature_channel
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.channelPicker.gotIt.click. Evid: 343.
 * Event description: click on got it in "choose a channel" page in promote video modal (When chosen video is not connected to any channel).

 * cardType - Type: string. Desc: promote_video/feature_channel
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsChannelPickerGotItClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsChannelPickerGotItClick = function (params) {
    return { evid: 343, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetSubscriptionDisplayedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {GUID} visitorID - visitorID
* @property {string} whereDisplayed - widget/cover
**/
/**
 * Name: widget.subscription.displayed. Evid: 206.
 * Event description: The subscription button displayed.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * visitorID - Type: guid. Desc: visitorID
 *
 * whereDisplayed - Type: string. Desc: widget/cover
 * @param {widgetSubscriptionDisplayedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetSubscriptionDisplayed = function (params) {
    return { evid: 206, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibSearchClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.lib.search.clicked. Evid: 47.
 * Event description: Clicking on search video.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boLibSearchClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibSearchClicked = function (params) {
    return { evid: 47, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsGetSocialFollowersPopUpDismissClickParams
* @property {string} buttonName - close/cancel
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.GetSocialFollowersPopUp.dismiss.click. Evid: 353.
 * Event description: click on close/cancel in "Get Social Followers" pop up.

 * buttonName - Type: string. Desc: close/cancel
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsGetSocialFollowersPopUpDismissClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsGetSocialFollowersPopUpDismissClick = function (params) {
    return { evid: 353, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibUpgradeStateParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - editor/ADI
* @property {string} compId - player_id
* @property {string} upgradeState - free_more_than_10/free_more_30_min_package/exceeds_package_limit
* @property {string} videoID - videoID
**/
/**
 * Name: bo.lib.upgrade.state. Evid: 92.
 * Event description: Exceeding free or payed package limitations.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * upgradeState - Type: string. Desc: free_more_than_10/free_more_30_min_package/exceeds_package_limit
 *
 * videoID - Type: string. Desc: videoID
 * @param {boLibUpgradeStateParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibUpgradeState = function (params) {
    return { evid: 92, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetVidShowCommentShownParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isShown - when shown is true / else false
* @property {boolean} isSingleVideo - true for single / false for channel
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {string} source - live/computer/drive/dropbox
* @property {string} videoID - videoID
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.vid.showComment.shown. Evid: 285.
 * Event description: Show comment site bar (Annoto).

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isShown - Type: bool. Desc: when shown is true / else false
 *
 * isSingleVideo - Type: bool. Desc: true for single / false for channel
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: live/computer/drive/dropbox
 *
 * videoID - Type: string. Desc: videoID
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetVidShowCommentShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetVidShowCommentShown = function (params) {
    return { evid: 285, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appLiveStartParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
* @property {string} videoID - video_id
**/
/**
 * Name: app.live.start. Evid: 650.
 * Event description: When live video recording start.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 *
 * videoID - Type: string. Desc: video_id
 * @param {appLiveStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appLiveStart = function (params) {
    return { evid: 650, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetPlayerShowPublisherChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isEnabled - toggle on/off
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: appSet.player.showPublisher.changed. Evid: 195.
 * Event description: User change in appSet.player "show video list"  toggle.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isEnabled - Type: bool. Desc: toggle on/off
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetPlayerShowPublisherChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetPlayerShowPublisherChanged = function (params) {
    return { evid: 195, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageSaveClickParams
* @property {string} audience - (all/mature)
* @property {boolean} audienceChanged - did the audience changed
* @property {boolean} categoryExists - did categories added
* @property {boolean} coverUploaded - did cover uploaded
* @property {DateTime} dateStartLive - go live on date & hour
* @property {boolean} dateStartLiveChanged - go live on date or hour changed
* @property {boolean} descriptionExists - did description added
* @property {boolean} downloadChanged - If user changed the download option
* @property {boolean} embed - embed toggle on/off
* @property {boolean} embedChanged - if the user change the embed toggle
* @property {boolean} embedInfo - info button in embed option on/off
* @property {boolean} embedInfoChanged - info button in embed option changed
* @property {boolean} embedLogo - embed custom logo checkbox on/off
* @property {boolean} embedLogoChanged - embed custom logo changed
* @property {string} embedLogoOption - custom logo in embed options value (control_bar/always)
* @property {boolean} embedLogoOptionChanged - custom logo options changed (show on control bar/ always)
* @property {boolean} embedShare - share button in embed options on/off
* @property {boolean} embedShareChanged - share button in embed options changed
* @property {boolean} embedVideoTitle - video title on/off in embed options
* @property {boolean} embedVideoTitleChanged - video title in embed options changed
* @property {string} genre - genre
* @property {boolean} genreChanged - did the genre changed
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isDownload - if uou can download the video
* @property {boolean} isPurchasable - is the videos for purchase
* @property {boolean} isRental - is the videos for rental
* @property {GUID} biToken - msid
* @property {number} numOfCastMembers - number of cast members
* @property {number} numOfCrewMembers - number of crew members
* @property {number} numOfTags - number of tags
* @property {number} numVideoEdit - number of videos user edit
* @property {string} origin - my_account/editor/ADI
* @property {boolean} overQuoted - is video id under OverQuota, true / false
* @property {string} compId - player_id
* @property {boolean} posterExists - did poster uploaded
* @property {string} pricingSelection - free/paid
* @property {boolean} pricingSelectionChange - did the pricing selection changed
* @property {boolean} publisherExists - did publisher added
* @property {boolean} purchasableChange - did the purchase option changed
* @property {number} purchasePricinig - doubled by 10000
* @property {boolean} purchasePricinigChange - did the purchase price changed
* @property {boolean} rentalChange - did the rental option changed
* @property {string} rentalPeriod - 24/48/72
* @property {boolean} rentalPeriodChange - did the rental period changed
* @property {number} rentalPricinig - doubled by 10000
* @property {boolean} rentalPricinigChange - did the rental price changed
* @property {boolean} showTrailer - show trailer toggle on/off
* @property {boolean} showTrailerChanged - show trailer toggle changed
* @property {boolean} signUpToWatch - sign up to watch toggle on/off
* @property {boolean} signUpToWatchChanged - user changed sign up to watch toggle
* @property {string} source - computer/vimeo/facebook/youtube
* @property {boolean} titleChanged - user changed the video title
* @property {string} trailer - preview/traliler/auto_generated/DontShow
* @property {boolean} trailerChanged - did the trailer changed
* @property {boolean} videoChanged - user changed the video from video library
* @property {string} videoID - new_videoID
* @property {string} videoType - video type
* @property {boolean} videoTypeChanged - did the video type changed
**/
/**
 * Name: bo.vidPage.save.click. Evid: 67.
 * Event description: Save clicked at the video page.

 * audience - Type: string. Desc: (all/mature)
 *
 * audienceChanged - Type: bool. Desc: did the audience changed
 *
 * categoryExists - Type: bool. Desc: did categories added
 *
 * coverUploaded - Type: bool. Desc: did cover uploaded
 *
 * dateStartLive - Type: datetime. Desc: go live on date & hour
 *
 * dateStartLiveChanged - Type: bool. Desc: go live on date or hour changed
 *
 * descriptionExists - Type: bool. Desc: did description added
 *
 * downloadChanged - Type: bool. Desc: If user changed the download option
 *
 * embed - Type: bool. Desc: embed toggle on/off
 *
 * embedChanged - Type: bool. Desc: if the user change the embed toggle
 *
 * embedInfo - Type: bool. Desc: info button in embed option on/off
 *
 * embedInfoChanged - Type: bool. Desc: info button in embed option changed
 *
 * embedLogo - Type: bool. Desc: embed custom logo checkbox on/off
 *
 * embedLogoChanged - Type: bool. Desc: embed custom logo changed
 *
 * embedLogoOption - Type: string. Desc: custom logo in embed options value (control_bar/always)
 *
 * embedLogoOptionChanged - Type: bool. Desc: custom logo options changed (show on control bar/ always)
 *
 * embedShare - Type: bool. Desc: share button in embed options on/off
 *
 * embedShareChanged - Type: bool. Desc: share button in embed options changed
 *
 * embedVideoTitle - Type: bool. Desc: video title on/off in embed options
 *
 * embedVideoTitleChanged - Type: bool. Desc: video title in embed options changed
 *
 * genre - Type: string. Desc: genre
 *
 * genreChanged - Type: bool. Desc: did the genre changed
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isDownload - Type: bool. Desc: if uou can download the video
 *
 * isPurchasable - Type: bool. Desc: is the videos for purchase
 *
 * isRental - Type: bool. Desc: is the videos for rental
 *
 * biToken - Type: guid. Desc: msid
 *
 * numOfCastMembers - Type: numeric. Desc: number of cast members
 *
 * numOfCrewMembers - Type: numeric. Desc: number of crew members
 *
 * numOfTags - Type: numeric. Desc: number of tags
 *
 * numVideoEdit - Type: numeric. Desc: number of videos user edit
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * overQuoted - Type: bool. Desc: is video id under OverQuota, true / false
 *
 * compId - Type: string. Desc: player_id
 *
 * posterExists - Type: bool. Desc: did poster uploaded
 *
 * pricingSelection - Type: string. Desc: free/paid
 *
 * pricingSelectionChange - Type: bool. Desc: did the pricing selection changed
 *
 * publisherExists - Type: bool. Desc: did publisher added
 *
 * purchasableChange - Type: bool. Desc: did the purchase option changed
 *
 * purchasePricinig - Type: numeric. Desc: doubled by 10000
 *
 * purchasePricinigChange - Type: bool. Desc: did the purchase price changed
 *
 * rentalChange - Type: bool. Desc: did the rental option changed
 *
 * rentalPeriod - Type: string. Desc: 24/48/72
 *
 * rentalPeriodChange - Type: bool. Desc: did the rental period changed
 *
 * rentalPricinig - Type: numeric. Desc: doubled by 10000
 *
 * rentalPricinigChange - Type: bool. Desc: did the rental price changed
 *
 * showTrailer - Type: bool. Desc: show trailer toggle on/off
 *
 * showTrailerChanged - Type: bool. Desc: show trailer toggle changed
 *
 * signUpToWatch - Type: bool. Desc: sign up to watch toggle on/off
 *
 * signUpToWatchChanged - Type: bool. Desc: user changed sign up to watch toggle
 *
 * source - Type: string. Desc: computer/vimeo/facebook/youtube
 *
 * titleChanged - Type: bool. Desc: user changed the video title
 *
 * trailer - Type: string. Desc: preview/traliler/auto_generated/DontShow
 *
 * trailerChanged - Type: bool. Desc: did the trailer changed
 *
 * videoChanged - Type: bool. Desc: user changed the video from video library
 *
 * videoID - Type: string. Desc: new_videoID
 *
 * videoType - Type: string. Desc: video type
 *
 * videoTypeChanged - Type: bool. Desc: did the video type changed
 * @param {boVidPageSaveClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageSaveClick = function (params) {
    return { evid: 67, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidDeleteVidBtnClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - videoID
**/
/**
 * Name: bo.vid.deleteVidBtn.clicked. Evid: 59.
 * Event description: Clicking delete video.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: videoID
 * @param {boVidDeleteVidBtnClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidDeleteVidBtnClicked = function (params) {
    return { evid: 59, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetSettingsLanguageChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {string} language - language
* @property {string} layoutType - classic / stripe / grid etc
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} prevLanguage - previous language
**/
/**
 * Name: appSet.settings.language.changed. Evid: 149.
 * Event description: User change the widget language.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * language - Type: string. Desc: language
 *
 * layoutType - Type: string. Desc: classic / stripe / grid etc
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * prevLanguage - Type: string. Desc: previous language
 * @param {appSetSettingsLanguageChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetSettingsLanguageChanged = function (params) {
    return { evid: 149, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLiveGoLiveMobilePopUpOpenedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.live.goLiveMobilePopUp.opened. Evid: 469.
 * Event description: 'Go live from your mobile'  pop up open.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boLiveGoLiveMobilePopUpOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLiveGoLiveMobilePopUpOpened = function (params) {
    return { evid: 469, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boUploadAddVideosFacebookProfileErrorParams
* @property {GUID} videoInstanceID - InstanceID
* @property {string} errorMsg - error message
* @property {GUID} biToken - msid
* @property {string} origin - first_video/add_videos_menu
* @property {string} compId - player_id
**/
/**
 * Name: bo.upload.addVideos.facebookProfile.error. Evid: 161.
 * Event description: Sent after user add URL of video from Facebook profile and try to login and get error message.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * errorMsg - Type: string. Desc: error message
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: first_video/add_videos_menu
 *
 * compId - Type: string. Desc: player_id
 * @param {boUploadAddVideosFacebookProfileErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boUploadAddVideosFacebookProfileError = function (params) {
    return { evid: 161, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetEmbedVidPlayedParams
* @property {string} channelID - channelID
* @property {string} correlationId - ID for one unique view connection
* @property {number} duration - duration of full video in ms
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isAutoplay - If video start autoplay or user click on play
* @property {boolean} isLive - If video is live
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {string} siteUrl - site url (only when embed video)
* @property {string} videoID - videoID
* @property {string} videoType - computer/vimeo/facebook/youtube
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.embed.vid.played. Evid: 272.
 * Event description: Embedded Video played.

 * channelID - Type: string. Desc: channelID
 *
 * correlationId - Type: string. Desc: ID for one unique view connection
 *
 * duration - Type: numeric. Desc: duration of full video in ms
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isAutoplay - Type: bool. Desc: If video start autoplay or user click on play
 *
 * isLive - Type: bool. Desc: If video is live
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * siteUrl - Type: string. Desc: site url (only when embed video)
 *
 * videoID - Type: string. Desc: videoID
 *
 * videoType - Type: string. Desc: computer/vimeo/facebook/youtube
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetEmbedVidPlayedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetEmbedVidPlayed = function (params) {
    return { evid: 272, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} mediaShareVideoErrorParams
* @property {string} correlationId - ID for one unique view connection
* @property {string} errorMessage - error_message
* @property {GUID} videoInstanceID - null
* @property {GUID} biToken - biToken
* @property {string} parameters - parameters
* @property {string} compId - compId
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: mediaShare.video.error. Evid: 398.
 * Event description: Server events for Facebook & Twitter share params.

 * correlationId - Type: string. Desc: ID for one unique view connection
 *
 * errorMessage - Type: string. Desc: error_message
 *
 * videoInstanceID - Type: guid.
 *
 * biToken - Type: guid. Desc: biToken
 *
 * parameters - Type: string. Desc: parameters
 *
 * compId - Type: string. Desc: compId
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {mediaShareVideoErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mediaShareVideoError = function (params) {
    return { evid: 398, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetShowTitleAndPublisherChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isEnabled - toggle on/off
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: appSet.showTitleAndPublisher.changed. Evid: 310.
 * Event description: User change in appSet(currently only in ADI) the "Title & Publisher" button.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isEnabled - Type: bool. Desc: toggle on/off
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetShowTitleAndPublisherChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetShowTitleAndPublisherChanged = function (params) {
    return { evid: 310, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibLiveAddClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} type - live_stream_tab / onboarding etc
**/
/**
 * Name: bo.live.scheduled.add.click. Evid: 131.
 * Event description: Click on "+ Live Stram" button in video library, on onboarding screen or on Live stream tab.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * type - Type: string. Desc: live_stream_tab / onboarding etc
 * @param {boLibLiveAddClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibLiveAddClick = function (params) {
    return { evid: 131, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetUpgradeClickedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isFirst - is first time clicking on upgrade
* @property {GUID} biToken - msid
* @property {string} compId - player_id
**/
/**
 * Name: appSet.Upgrade.clicked. Evid: 15.
 * Event description: Upgrade clicked.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isFirst - Type: bool. Desc: is first time clicking on upgrade
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetUpgradeClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetUpgradeClicked = function (params) {
    return { evid: 15, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boSettingsDefaultPriceOpenParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.settings.defaultPrice.open. Evid: 29.
 * Event description: Clicking difolt price.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boSettingsDefaultPriceOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boSettingsDefaultPriceOpen = function (params) {
    return { evid: 29, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boSettingsLogoAddClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {number} numberOfLogos - # of existing logos before upload
* @property {string} origin - my account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.settings.logo.add.click. Evid: 187.
 * Event description: Click on add logo in settings.logo.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * numberOfLogos - Type: numeric. Desc: # of existing logos before upload
 *
 * origin - Type: string. Desc: my account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boSettingsLogoAddClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boSettingsLogoAddClick = function (params) {
    return { evid: 187, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetMenuClickedParams
* @property {string} channelID - channel
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.menu.clicked. Evid: 266.
 * Event description: Click on layout menu (3 dots) from widget.

 * channelID - Type: string. Desc: channel
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetMenuClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetMenuClicked = function (params) {
    return { evid: 266, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boUploadAddVideosVideoSourceClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - first_video/add_videos_menu
* @property {string} compId - player_id
* @property {string} source - computer/youtube/vimeo/drive/dropbox/facebook/live
* @property {string} type - upload/embed
**/
/**
 * Name: bo.upload.addVideos.videoSource.clicked. Evid: 109.
 * Event description: Sent when user chooses the video source (computer,youtube,vimeo etc.).

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: first_video/add_videos_menu
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: computer/youtube/vimeo/drive/dropbox/facebook/live
 *
 * type - Type: string. Desc: upload/embed
 * @param {boUploadAddVideosVideoSourceClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boUploadAddVideosVideoSourceClicked = function (params) {
    return { evid: 109, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLiveStreamKeyExpiredPopUpOpenedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.live.streamKeyExpiredPopUp.opened. Evid: 480.
 * Event description: 'Your stream key has expired'  pop up open.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boLiveStreamKeyExpiredPopUpOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLiveStreamKeyExpiredPopUpOpened = function (params) {
    return { evid: 480, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetPlayerShowVideoTitleChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isEnabled - toggle on/off
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} playVideo - in_the_frame/expanded_view
* @property {string} compId - player_id
**/
/**
 * Name: appSet.player.showVideoTitle.changed. Evid: 303.
 * Event description: User change in appSet.player show video title  toggle.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isEnabled - Type: bool. Desc: toggle on/off
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * playVideo - Type: string. Desc: in_the_frame/expanded_view
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetPlayerShowVideoTitleChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetPlayerShowVideoTitleChanged = function (params) {
    return { evid: 303, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetPlayerShowChannelTitleChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isEnabled - toggle on/off
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} type - before_playing / while_playing
**/
/**
 * Name: appSet.player.showChannelTitle.changed. Evid: 301.
 * Event description: User change in appSet.player "show channel title"  toggle.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isEnabled - Type: bool. Desc: toggle on/off
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * type - Type: string. Desc: before_playing / while_playing
 * @param {appSetPlayerShowChannelTitleChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetPlayerShowChannelTitleChanged = function (params) {
    return { evid: 301, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLiveEditNextClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.live.edit.next.click. Evid: 455.
 * Event description: Click on Next to go to Connect Stream tab, live stream edit process.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boLiveEditNextClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLiveEditNextClick = function (params) {
    return { evid: 455, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLiveEditConnectStreamCopyClickParams
* @property {string} button - server / stream
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.live.edit.connectStream.copy.click. Evid: 456.
 * Event description: Click to copy key / url to connect encoder.

 * button - Type: string. Desc: server / stream
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boLiveEditConnectStreamCopyClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLiveEditConnectStreamCopyClick = function (params) {
    return { evid: 456, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageTrailerCreationStartParams
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isFirst - first time uploading
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - null
* @property {string} source - upload/drive/dropbox
**/
/**
 * Name: bo.vidPage.trailer.creation.start. Evid: 812.
 * Event description: Auto-generated trailer creation started..

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isFirst - Type: bool. Desc: first time uploading
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string.
 *
 * source - Type: string. Desc: upload/drive/dropbox
 * @param {boVidPageTrailerCreationStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageTrailerCreationStart = function (params) {
    return { evid: 812, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boGeneralUpgradeBtnClickedParams
* @property {string} ctaId - upgrade/contactUs
* @property {string} fromTab - email-marketing", "navigation", "settings-counter", "video-library", "video-page", "video-page-embed", "settings-embed
* @property {GUID} videoInstanceID - InstanceID
* @property {string} location - From where in the bo the user clicked on upgrade button (menu/upgradeCounter)
* @property {GUID} biToken - msid
* @property {string} origin - my account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.general.upgradeBtn.clicked. Evid: 94.
 * Event description: Clicking a button Upgrade Now in BO menu.

 * ctaId - Type: string. Desc: upgrade/contactUs
 *
 * fromTab - Type: string. Desc: email-marketing", "navigation", "settings-counter", "video-library", "video-page", "video-page-embed", "settings-embed
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * location - Type: string. Desc: From where in the bo the user clicked on upgrade button (menu/upgradeCounter)
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boGeneralUpgradeBtnClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boGeneralUpgradeBtnClicked = function (params) {
    return { evid: 94, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appPageCloseClickParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} pageName - page name
* @property {string} compId - null
**/
/**
 * Name: app.page.close.click. Evid: 608.
 * Event description: user click on close in live app.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * pageName - Type: string. Desc: page name
 *
 * compId - Type: string.
 * @param {appPageCloseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appPageCloseClick = function (params) {
    return { evid: 608, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boTrailerClickOnFailToastParams
* @property {string} button - go_to_video / x
* @property {string} errorType - indication of why auto-generation didn't succeed
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - null
**/
/**
 * Name: bo.trailer.clickOnFailToast. Evid: 820.
 * Event description: Fired when user has interaction with auto-generated trailer's fail toast.

 * button - Type: string. Desc: go_to_video / x
 *
 * errorType - Type: string. Desc: indication of why auto-generation didn't succeed
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string.
 * @param {boTrailerClickOnFailToastParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boTrailerClickOnFailToast = function (params) {
    return { evid: 820, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetOpenedParams
* @property {string} editorMode - editorMode
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isFirst - first time open the app settings
* @property {string} layoutType - classic/strip/compact
* @property {number} loading_time - loading time
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: appSet.opened. Evid: 100.
 * Event description: Opened app settings.

 * editorMode - Type: string. Desc: editorMode
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isFirst - Type: bool. Desc: first time open the app settings
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * loading_time - Type: numeric. Desc: loading time
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetOpened = function (params) {
    return { evid: 100, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetPopupErrorPayPalParams
* @property {string} channelID - channelID
* @property {string} errorType - Video is not available/Video is processing
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {string} videoID - videoID
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.popup.errorPayPal. Evid: 230.
 * Event description: Error state display when payment wasn't successful.

 * channelID - Type: string. Desc: channelID
 *
 * errorType - Type: string. Desc: Video is not available/Video is processing
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: videoID
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetPopupErrorPayPalParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetPopupErrorPayPal = function (params) {
    return { evid: 230, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appGoLiveOnboardingMoreInfoClickParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
**/
/**
 * Name: app.goLive.onboarding.moreInfo.click. Evid: 644.
 * Event description: User click on more info button in go live screen (onboarding  screen).

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 * @param {appGoLiveOnboardingMoreInfoClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appGoLiveOnboardingMoreInfoClick = function (params) {
    return { evid: 644, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetLogOutClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.logOut.clicked. Evid: 235.
 * Event description: logOut button clicked.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetLogOutClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetLogOutClicked = function (params) {
    return { evid: 235, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetEmbedVidGoToSiteClickParams
* @property {string} buttonName - logo/title/more
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {string} siteUrl - site url (only when embed video)
* @property {string} videoID - video_id
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.embed.vid.goToSite.click. Evid: 135.
 * Event description: click on user logo/title/more to watch on site.

 * buttonName - Type: string. Desc: logo/title/more
 *
 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * siteUrl - Type: string. Desc: site url (only when embed video)
 *
 * videoID - Type: string. Desc: video_id
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetEmbedVidGoToSiteClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetEmbedVidGoToSiteClick = function (params) {
    return { evid: 135, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditVideoPricingActionsClickParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - player_id
* @property {string} selection - on / off
* @property {string} target - add_plan / disable_single_video_purchase
**/
/**
 * Name: bo.chEdit.VideoPricing.actions.click. Evid: 260.
 * Event description: bo.chEdit.VideoPricing.actions.click.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string. Desc: player_id
 *
 * selection - Type: string. Desc: on / off
 *
 * target - Type: string. Desc: add_plan / disable_single_video_purchase
 * @param {boChEditVideoPricingActionsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditVideoPricingActionsClick = function (params) {
    return { evid: 260, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetCommentsToggleUploadedVideosClickParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isEnabled - Comments on/off on uploaded videos
* @property {boolean} isSingleVideo - true for single / false for channel
* @property {GUID} biToken - msid
* @property {string} compId - player_id
**/
/**
 * Name: appSet.comments.toggleUploadedVideos.click. Evid: 237.
 * Event description: Click on "On uploaded videos" toggle on Comments tab in app setting.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isEnabled - Type: bool. Desc: Comments on/off on uploaded videos
 *
 * isSingleVideo - Type: bool. Desc: true for single / false for channel
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetCommentsToggleUploadedVideosClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetCommentsToggleUploadedVideosClick = function (params) {
    return { evid: 237, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boUploadSuccessPopUpTriggeredParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.uploadSuccessPopUp.triggered. Evid: 43.
 * Event description: Upload success popup opened.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boUploadSuccessPopUpTriggeredParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boUploadSuccessPopUpTriggered = function (params) {
    return { evid: 43, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetPaymentProviderClickedParams
* @property {string} buyType - buy/rent/subscription
* @property {string} channelID - channel id
* @property {string} currency - currency
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} paymentProvider - pay_pal/credit_card/alipay etc.
* @property {string} compId - player_id
* @property {number} price - price
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.paymentProvider.clicked. Evid: 236.
 * Event description: Click on payment method button in proceed to check out window.

 * buyType - Type: string. Desc: buy/rent/subscription
 *
 * channelID - Type: string. Desc: channel id
 *
 * currency - Type: string. Desc: currency
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * paymentProvider - Type: string. Desc: pay_pal/credit_card/alipay etc.
 *
 * compId - Type: string. Desc: player_id
 *
 * price - Type: numeric. Desc: price
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetPaymentProviderClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetPaymentProviderClicked = function (params) {
    return { evid: 236, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLiveLearnMoreClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} type - onboarding / encoder / reconnecting / library
**/
/**
 * Name: bo.live.learnMore.click. Evid: 450.
 * Event description: Click on learn more on live stream tab.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * type - Type: string. Desc: onboarding / encoder / reconnecting / library
 * @param {boLiveLearnMoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLiveLearnMoreClick = function (params) {
    return { evid: 450, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boUploadAddVideosEmbedVideoButtonClickedParams
* @property {string} button_name - add_to_library/cancel/close
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - first_video/add_videos_menu
* @property {string} compId - player_id
* @property {string} source - youtube/vimeo/facebook
**/
/**
 * Name: bo.upload.addVideos.embedVideo.button.clicked. Evid: 111.
 * Event description: Sent when user clicks on button in embed video window.

 * button_name - Type: string. Desc: add_to_library/cancel/close
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: first_video/add_videos_menu
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: youtube/vimeo/facebook
 * @param {boUploadAddVideosEmbedVideoButtonClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boUploadAddVideosEmbedVideoButtonClicked = function (params) {
    return { evid: 111, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditOpenedParams
* @property {string} channelID - channelID
* @property {string} channelType - channel/youtube-feed
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - player_id
**/
/**
 * Name: bo.chEdit.opened. Evid: 73.
 * Event description: Open edit channel.

 * channelID - Type: string. Desc: channelID
 *
 * channelType - Type: string. Desc: channel/youtube-feed
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string. Desc: player_id
 * @param {boChEditOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditOpened = function (params) {
    return { evid: 73, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibVidClickedParams
* @property {string} editMode - batch/single
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {boolean} overQuoted - is video id under OverQuota, true / false
* @property {string} compId - player_id
* @property {string} source - youtube/vimeo/facebook/computer/batch/live
* @property {string} videoID - videoID
**/
/**
 * Name: bo.lib.vid.clicked. Evid: 46.
 * Event description: Clicking on video opening the edit video.

 * editMode - Type: string. Desc: batch/single
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * overQuoted - Type: bool. Desc: is video id under OverQuota, true / false
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: youtube/vimeo/facebook/computer/batch/live
 *
 * videoID - Type: string. Desc: videoID
 * @param {boLibVidClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibVidClicked = function (params) {
    return { evid: 46, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetSettingsShowChannelTitleChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isEnabled - toggle on/off
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: appSet.settings.showChannelTitle.changed. Evid: 196.
 * Event description: User change in appSet.settings "show channel title"  toggle.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isEnabled - Type: bool. Desc: toggle on/off
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetSettingsShowChannelTitleChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetSettingsShowChannelTitleChanged = function (params) {
    return { evid: 196, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetLayoutVideosInRowChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} selection - 2,3,4
**/
/**
 * Name: appSet.layout.videosInRow.changed. Evid: 311.
 * Event description: User change in appSet the number of videos in row.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * selection - Type: string. Desc: 2,3,4
 * @param {appSetLayoutVideosInRowChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetLayoutVideosInRowChanged = function (params) {
    return { evid: 311, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boSettingsDefaultPriceSaveButtonClickedParams
* @property {boolean} downloadChanged - If user changed the download option
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isDownload - if uou can download the video
* @property {boolean} isPurchasable - is the videos for purchase
* @property {boolean} isRental - is the videos for rental
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} pricingSelection - free/paid
* @property {boolean} pricingSelectionChange - did the pricing selection changed
* @property {boolean} purchasableChange - did the purchase option changed
* @property {number} purchasePricinig - the price for purchase doubled by 10000
* @property {boolean} purchasePricinigChange - did the rental purchase changed
* @property {boolean} rentalChange - did the rental option changed
* @property {string} rentalPeriod - 24/48/72
* @property {boolean} rentalPeriodChange - did the rental period changed
* @property {number} rentalPricinig - the price of renting  doubled by 10000
* @property {boolean} rentalPricinigChange - did the rental price changed
**/
/**
 * Name: bo.settings.defaultPrice.saveButton.clicked. Evid: 31.
 * Event description: Clicking save in default price edit.

 * downloadChanged - Type: bool. Desc: If user changed the download option
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isDownload - Type: bool. Desc: if uou can download the video
 *
 * isPurchasable - Type: bool. Desc: is the videos for purchase
 *
 * isRental - Type: bool. Desc: is the videos for rental
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * pricingSelection - Type: string. Desc: free/paid
 *
 * pricingSelectionChange - Type: bool. Desc: did the pricing selection changed
 *
 * purchasableChange - Type: bool. Desc: did the purchase option changed
 *
 * purchasePricinig - Type: numeric. Desc: the price for purchase doubled by 10000
 *
 * purchasePricinigChange - Type: bool. Desc: did the rental purchase changed
 *
 * rentalChange - Type: bool. Desc: did the rental option changed
 *
 * rentalPeriod - Type: string. Desc: 24/48/72
 *
 * rentalPeriodChange - Type: bool. Desc: did the rental period changed
 *
 * rentalPricinig - Type: numeric. Desc: the price of renting  doubled by 10000
 *
 * rentalPricinigChange - Type: bool. Desc: did the rental price changed
 * @param {boSettingsDefaultPriceSaveButtonClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boSettingsDefaultPriceSaveButtonClicked = function (params) {
    return { evid: 31, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boSettingsEmailPreviewClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.settings.emailPreview.clicked. Evid: 35.
 * Event description: Clicking on email preview.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boSettingsEmailPreviewClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boSettingsEmailPreviewClicked = function (params) {
    return { evid: 35, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetVidShareDisplayedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - on_site/embed
* @property {string} compId - player_id
* @property {string} siteUrl - site url (only when embed video)
* @property {string} videoID - videoID
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.vid.share.displayed. Evid: 224.
 * Event description: Share buttens displayed.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: on_site/embed
 *
 * compId - Type: string. Desc: player_id
 *
 * siteUrl - Type: string. Desc: site url (only when embed video)
 *
 * videoID - Type: string. Desc: videoID
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetVidShareDisplayedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetVidShareDisplayed = function (params) {
    return { evid: 224, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsCardTimingChangedParams
* @property {string} cardName - promote_video/feature_channel/promote_product/get_social_followers/custom
* @property {string} changeBy - seek/manual
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} timeFrame - start/end
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.card.timing.changed. Evid: 321.
 * Event description: Timing (start/end time) for video card changed.

 * cardName - Type: string. Desc: promote_video/feature_channel/promote_product/get_social_followers/custom
 *
 * changeBy - Type: string. Desc: seek/manual
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * timeFrame - Type: string. Desc: start/end
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsCardTimingChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsCardTimingChanged = function (params) {
    return { evid: 321, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boTrailerPreviewParams
* @property {GUID} videoInstanceID - null
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoId - .
**/
/**
 * Name: bo.trailer.preview. Evid: 818.
 * Event description: Fired when clicks on 'Preview' on an auto-generated trailer..

 * videoInstanceID - Type: guid.
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoId - Type: string. Desc: .
 * @param {boTrailerPreviewParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boTrailerPreview = function (params) {
    return { evid: 818, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLiveBeforeStartPopUpOpenedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.live.beforeStartPopUp.opened. Evid: 452.
 * Event description: Before you start pop up opened (live stream tab).

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boLiveBeforeStartPopUpOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLiveBeforeStartPopUpOpened = function (params) {
    return { evid: 452, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLiveConnectStreamClosePopupOpenedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.live.connectStream.closePopup.opened. Evid: 464.
 * Event description: 'You're still Live'  pop up open.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boLiveConnectStreamClosePopupOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLiveConnectStreamClosePopupOpened = function (params) {
    return { evid: 464, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLiveStreamScheduledPopUpClickParams
* @property {string} button - close / got_it / wix_app / encoder
* @property {boolean} dontShow - true / false
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.live.streamScheduledPopUp.click. Evid: 477.
 * Event description: Click on 'Your live stream has been scheduled'  pop up.

 * button - Type: string. Desc: close / got_it / wix_app / encoder
 *
 * dontShow - Type: bool. Desc: true / false
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boLiveStreamScheduledPopUpClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLiveStreamScheduledPopUpClick = function (params) {
    return { evid: 477, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetVidBuySuccessParams
* @property {string} buyType - buy/rent/buyFrom/recurring
* @property {string} channelID - channelID
* @property {string} currency - currency
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {GUID} orderid - orderId
* @property {string} compId - player_id
* @property {number} price - doubled by 10000
* @property {string} videoID - videoID
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.vid.buy.success. Evid: 221.
 * Event description: Buy succeeded.

 * buyType - Type: string. Desc: buy/rent/buyFrom/recurring
 *
 * channelID - Type: string. Desc: channelID
 *
 * currency - Type: string. Desc: currency
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * orderid - Type: guid. Desc: orderId
 *
 * compId - Type: string. Desc: player_id
 *
 * price - Type: numeric. Desc: doubled by 10000
 *
 * videoID - Type: string. Desc: videoID
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetVidBuySuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetVidBuySuccess = function (params) {
    return { evid: 221, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetPollRequestSentParams
* @property {string} channelID - channelID
* @property {string} errorMessage - error message
* @property {GUID} videoInstanceID - instance_id
* @property {boolean} isError - If we recive error from request
* @property {GUID} biToken - msid
* @property {string} origin - on_site/embed
* @property {string} compId - player_id
* @property {string} siteUrl - site url (only when embed video)
* @property {string} videoID - videoID
* @property {string} videoType - live/scheduale
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.poll.request.sent. Evid: 282.
 * Event description: When we send poll request to see if live video started.

 * channelID - Type: string. Desc: channelID
 *
 * errorMessage - Type: string. Desc: error message
 *
 * videoInstanceID - Type: guid. Desc: instance_id
 *
 * isError - Type: bool. Desc: If we recive error from request
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: on_site/embed
 *
 * compId - Type: string. Desc: player_id
 *
 * siteUrl - Type: string. Desc: site url (only when embed video)
 *
 * videoID - Type: string. Desc: videoID
 *
 * videoType - Type: string. Desc: live/scheduale
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetPollRequestSentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetPollRequestSent = function (params) {
    return { evid: 282, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetPlayerShowVideoListTitleChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} selection - hover/never/always
**/
/**
 * Name: appSet.player.showVideoListTitle.changed. Evid: 191.
 * Event description: User change  "show video list titles" in appSet.player.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * selection - Type: string. Desc: hover/never/always
 * @param {appSetPlayerShowVideoListTitleChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetPlayerShowVideoListTitleChanged = function (params) {
    return { evid: 191, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditToggleFeaturedVideoClickParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isFeatured - featured video on/off
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {boolean} overQuoted - is video id under OverQuota, true / false
* @property {string} compId - player_id
* @property {string} source - computer/dropbox/drive/youtube/vimeo/facebook
* @property {string} videoID - videoID
**/
/**
 * Name: bo.chEdit.toggleFeaturedVideo.click. Evid: 145.
 * Event description: Click on "star"button in channel page.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isFeatured - Type: bool. Desc: featured video on/off
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * overQuoted - Type: bool. Desc: is video id under OverQuota, true / false
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: computer/dropbox/drive/youtube/vimeo/facebook
 *
 * videoID - Type: string. Desc: videoID
 * @param {boChEditToggleFeaturedVideoClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditToggleFeaturedVideoClick = function (params) {
    return { evid: 145, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLiveReschedulePopUpOpenedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.live.reschedulePopUp.opened. Evid: 462.
 * Event description: 'Reschedule this live stream for later'  pop up open.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boLiveReschedulePopUpOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLiveReschedulePopUpOpened = function (params) {
    return { evid: 462, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boUploadAddVideosEmbedVideoEnterUrlParsingCompletedParams
* @property {number} errorCode - Error code
* @property {string} errorMsg - Error message
* @property {string} errorType - client-parse-error/client-unknown-source-error/server-error/unknown-error
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isSuccess - If the parsing complete successfully
* @property {GUID} biToken - msid
* @property {string} origin - first_video/add_videos_menu
* @property {string} url - The URL  user insert if parsing failed
* @property {string} compId - player_id
* @property {string} source - youtube/vimeo/facebook
**/
/**
 * Name: bo.upload.addVideos.embedVideo.enterUrl.parsingCompleted. Evid: 113.
 * Event description: Sent when url is parsed  successfully.

 * errorCode - Type: numeric. Desc: Error code
 *
 * errorMsg - Type: string. Desc: Error message
 *
 * errorType - Type: string. Desc: client-parse-error/client-unknown-source-error/server-error/unknown-error
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isSuccess - Type: bool. Desc: If the parsing complete successfully
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: first_video/add_videos_menu
 *
 * url - Type: string. Desc: The URL  user insert if parsing failed
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: youtube/vimeo/facebook
 * @param {boUploadAddVideosEmbedVideoEnterUrlParsingCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boUploadAddVideosEmbedVideoEnterUrlParsingCompleted = function (params) {
    return { evid: 113, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsSaveClickParams
* @property {string} cardsOrientation - vertical/horizontal
* @property {string} cardsPosition - top_left/top_right/bottom_left/bottom_right
* @property {boolean} embed - embed toggle on/off
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isPurchasable - is the videos for purchase
* @property {boolean} isRental - is the videos for rental
* @property {GUID} biToken - msid
* @property {string} numberOfBoostSales - number of boost sales cards
* @property {number} numberOfCards - number of cards after this session
* @property {string} numberOfCardsUpdated - number of cards updated in this session
* @property {string} numberOfCardsCreated - number of cards created in this session
* @property {string} numberOfCardsDeleted - number of cards deleted in this session
* @property {string} numberOfCustomText - number of custom texts
* @property {string} numberOfIncreaseSocial - number of get increase social followers
* @property {string} numberOfPromoteChannel - number of promote channel cards
* @property {string} numberOfPromoteVideo - number of promote video cards
* @property {string} origin - my_account/editor/ADI
* @property {boolean} overQuoted - is video id under OverQuota, true / false
* @property {string} compId - player_id
* @property {string} pricingSelection - free/paid
* @property {string} saveOrigin - popup/cards_page
* @property {string} videoID - new_videoID
**/
/**
 * Name: bo.vidPage.videoCards.save.click. Evid: 329.
 * Event description: Save clicked at the video cards section / unsaved changes popup.

 * cardsOrientation - Type: string. Desc: vertical/horizontal
 *
 * cardsPosition - Type: string. Desc: top_left/top_right/bottom_left/bottom_right
 *
 * embed - Type: bool. Desc: embed toggle on/off
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isPurchasable - Type: bool. Desc: is the videos for purchase
 *
 * isRental - Type: bool. Desc: is the videos for rental
 *
 * biToken - Type: guid. Desc: msid
 *
 * numberOfBoostSales - Type: string. Desc: number of boost sales cards
 *
 * numberOfCards - Type: numeric. Desc: number of cards after this session
 *
 * numberOfCardsUpdated - Type: string. Desc: number of cards updated in this session
 *
 * numberOfCardsCreated - Type: string. Desc: number of cards created in this session
 *
 * numberOfCardsDeleted - Type: string. Desc: number of cards deleted in this session
 *
 * numberOfCustomText - Type: string. Desc: number of custom texts
 *
 * numberOfIncreaseSocial - Type: string. Desc: number of get increase social followers
 *
 * numberOfPromoteChannel - Type: string. Desc: number of promote channel cards
 *
 * numberOfPromoteVideo - Type: string. Desc: number of promote video cards
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * overQuoted - Type: bool. Desc: is video id under OverQuota, true / false
 *
 * compId - Type: string. Desc: player_id
 *
 * pricingSelection - Type: string. Desc: free/paid
 *
 * saveOrigin - Type: string. Desc: popup/cards_page
 *
 * videoID - Type: string. Desc: new_videoID
 * @param {boVidPageVideoCardsSaveClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsSaveClick = function (params) {
    return { evid: 329, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetCommentsLearnMoreClickParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isSingleVideo - true for single / false for channel
* @property {GUID} biToken - msid
* @property {string} compId - player_id
**/
/**
 * Name: appSet.comments.learnMore.click. Evid: 239.
 * Event description: Click on "Learn more" on Comments tab in app setting.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isSingleVideo - Type: bool. Desc: true for single / false for channel
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetCommentsLearnMoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetCommentsLearnMoreClick = function (params) {
    return { evid: 239, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsChannelPickerChannelsClickParams
* @property {string} cardType - promote_video/feature_channel
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.channelPicker.channels.click. Evid: 344.
 * Event description: click on "channels" in "choose a channel" page in promote video modal (When chosen video is not connected to any channel).

 * cardType - Type: string. Desc: promote_video/feature_channel
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsChannelPickerChannelsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsChannelPickerChannelsClick = function (params) {
    return { evid: 344, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetLayoutDisplayInfoDescriptionChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {string} layoutType - small_slider/big_slider
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {boolean} toggle - on / off
**/
/**
 * Name: appSet.layout.displayInfo.description.changed. Evid: 404.
 * Event description: User toggles to show Video description.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * layoutType - Type: string. Desc: small_slider/big_slider
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * toggle - Type: bool. Desc: on / off
 * @param {appSetLayoutDisplayInfoDescriptionChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetLayoutDisplayInfoDescriptionChanged = function (params) {
    return { evid: 404, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetLayoutStretchToWidthChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {string} layoutType - small_slider/big_slider
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {boolean} toggle - on / off
**/
/**
 * Name: appSet.layout.stretchToWidth.changed. Evid: 317.
 * Event description: Users changes toggle 'Stretch to full width' in AppSet.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * layoutType - Type: string. Desc: small_slider/big_slider
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * toggle - Type: bool. Desc: on / off
 * @param {appSetLayoutStretchToWidthChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetLayoutStretchToWidthChanged = function (params) {
    return { evid: 317, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibDeleteVideoClickedParams
* @property {string} button - batch/video-page
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {number} numberVideos - number of videos chosen
* @property {string} origin - my_account/editor/ADI
* @property {number} overQuotaVideosCount - how many of the videos are OverQ
* @property {string} compId - player_id
* @property {string} videoID - json of video_id
**/
/**
 * Name: bo.lib.deleteVideo.clicked. Evid: 51.
 * Event description: Clicking  on delete video.

 * button - Type: string. Desc: batch/video-page
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * numberVideos - Type: numeric. Desc: number of videos chosen
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * overQuotaVideosCount - Type: numeric. Desc: how many of the videos are OverQ
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: json of video_id
 * @param {boLibDeleteVideoClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibDeleteVideoClicked = function (params) {
    return { evid: 51, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boStatsTimeframeChangedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - ADI / editor / МА
* @property {string} compId - player_id
* @property {string} tabName - QuickStats/Channels/Videos
* @property {string} timeFrame - All time / Last year / Last month / Last week / Today (hours)
**/
/**
 * Name: bo.stats.timeframe.changed. Evid: 20.
 * Event description: Changing the time frame on the different tabs QuickStats/Channels/Videos.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string. Desc: player_id
 *
 * tabName - Type: string. Desc: QuickStats/Channels/Videos
 *
 * timeFrame - Type: string. Desc: All time / Last year / Last month / Last week / Today (hours)
 * @param {boStatsTimeframeChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boStatsTimeframeChanged = function (params) {
    return { evid: 20, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boSettingsLogoUploadLogoCompleteParams
* @property {string} errorDec - error message if upload failed
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {number} numberOfLogosAfter - # of logos after upload complete
* @property {string} origin - my account/editor/ADI
* @property {string} compId - player_id
* @property {boolean} isSuccess - true/false
**/
/**
 * Name: bo.settings.logo.uploadLogo.complete. Evid: 186.
 * Event description: sent when logo upload complete (success or not).

 * errorDec - Type: string. Desc: error message if upload failed
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * numberOfLogosAfter - Type: numeric. Desc: # of logos after upload complete
 *
 * origin - Type: string. Desc: my account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * isSuccess - Type: bool. Desc: true/false
 * @param {boSettingsLogoUploadLogoCompleteParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boSettingsLogoUploadLogoComplete = function (params) {
    return { evid: 186, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibChooseLogoPopUpOpenedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoId - video_id
**/
/**
 * Name: bo.lib.chooseLogoPopUp.opened. Evid: 178.
 * Event description: choose logo pop up opened.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoId - Type: string. Desc: video_id
 * @param {boLibChooseLogoPopUpOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibChooseLogoPopUpOpened = function (params) {
    return { evid: 178, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetSettingsShowChannelInfoChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isEnabled - toggle on/off
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: appSet.settings.showChannelInfo.changed. Evid: 188.
 * Event description: User change in appSet.settings "show channel info"  toggle.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isEnabled - Type: bool. Desc: toggle on/off
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetSettingsShowChannelInfoChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetSettingsShowChannelInfoChanged = function (params) {
    return { evid: 188, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetLayoutActionBarShowVideoListTypeChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} selection - when_clicked/never/always
**/
/**
 * Name: appSet.layout.actionBar.showVideoListType.changed. Evid: 174.
 * Event description: User change  show video list in appSet.layout.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * selection - Type: string. Desc: when_clicked/never/always
 * @param {appSetLayoutActionBarShowVideoListTypeChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetLayoutActionBarShowVideoListTypeChanged = function (params) {
    return { evid: 174, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditDeleteChPopUpBtnClickedParams
* @property {string} button - delete/cancel
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - player_id
**/
/**
 * Name: bo.chEdit.deleteCh.popUpBtn.clicked. Evid: 75.
 * Event description: Delete or cancel clicked in the delete channel popup.

 * button - Type: string. Desc: delete/cancel
 *
 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string. Desc: player_id
 * @param {boChEditDeleteChPopUpBtnClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditDeleteChPopUpBtnClicked = function (params) {
    return { evid: 75, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetSettingsShowVideoTitleChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isEnabled - on / off
* @property {string} layoutType - small_slider/big_slider
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: appSet.settings.showVideoTitle.changed. Evid: 262.
 * Event description: User toggles to show Video title.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isEnabled - Type: bool. Desc: on / off
 *
 * layoutType - Type: string. Desc: small_slider/big_slider
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetSettingsShowVideoTitleChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetSettingsShowVideoTitleChanged = function (params) {
    return { evid: 262, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appLiveEndSaveStartParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} path - path
* @property {string} compId - null
* @property {string} videoID - video_id
**/
/**
 * Name: app.live.end.save.start. Evid: 660.
 * Event description: After live ends user  click on save to device, save start.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * path - Type: string. Desc: path
 *
 * compId - Type: string.
 *
 * videoID - Type: string. Desc: video_id
 * @param {appLiveEndSaveStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appLiveEndSaveStart = function (params) {
    return { evid: 660, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appLiveEndSaveEndParams
* @property {string} channelID - channel_id
* @property {string} errorMessage - error message if save fail
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
* @property {boolean} isSuccess - if save success
* @property {string} videoID - video_id
**/
/**
 * Name: app.live.end.save.end. Evid: 661.
 * Event description: Video save end after live.

 * channelID - Type: string. Desc: channel_id
 *
 * errorMessage - Type: string. Desc: error message if save fail
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 *
 * isSuccess - Type: bool. Desc: if save success
 *
 * videoID - Type: string. Desc: video_id
 * @param {appLiveEndSaveEndParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appLiveEndSaveEnd = function (params) {
    return { evid: 661, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibGoToChannelsClickedParams
* @property {GUID} videoInstanceID - null
* @property {GUID} biToken - null
* @property {string} origin - ADI / editor / МА
* @property {string} compId - null
**/
/**
 * Name: bo.lib.goToChannels.clicked. Evid: 140.
 * Event description: Click on head to channels in video library tab.

 * videoInstanceID - Type: guid.
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string.
 * @param {boLibGoToChannelsClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibGoToChannelsClicked = function (params) {
    return { evid: 140, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appGoLiveOnboardingStartLiveClickParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
* @property {string} type - user type free/premium
**/
/**
 * Name: app.goLive.onboarding.startLive.click. Evid: 643.
 * Event description: User click on start live button in go live screen (onboarding  screen) - first/second time for free users and first time for premium user.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 *
 * type - Type: string. Desc: user type free/premium
 * @param {appGoLiveOnboardingStartLiveClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appGoLiveOnboardingStartLiveClick = function (params) {
    return { evid: 643, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boEmailMarketingShoutOutDashboardClickedParams
* @property {GUID} videoInstanceID - null
* @property {GUID} biToken - null
* @property {string} origin - ADI / editor / МА
* @property {string} compId - null
**/
/**
 * Name: bo.emailMarketing.shoutOutDashboard.clicked. Evid: 153.
 * Event description: Click on "head to Wix ShoutOut dashboard" button in email marketing tab.

 * videoInstanceID - Type: guid.
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string.
 * @param {boEmailMarketingShoutOutDashboardClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boEmailMarketingShoutOutDashboardClicked = function (params) {
    return { evid: 153, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsGetSocialFollowersPopUpConnectClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} source - Facebook/Twitter/YouTube/NULL
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.GetSocialFollowersPopUp.connect.click. Evid: 352.
 * Event description: click on connect in "Get Social Followers" pop up.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: Facebook/Twitter/YouTube/NULL
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsGetSocialFollowersPopUpConnectClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsGetSocialFollowersPopUpConnectClick = function (params) {
    return { evid: 352, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boSettingsPayPalDisconnectClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.settings.PayPalDisconnect.clicked. Evid: 26.
 * Event description: Clicking on the disconnect paypal button.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boSettingsPayPalDisconnectClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boSettingsPayPalDisconnectClicked = function (params) {
    return { evid: 26, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditFindVidClickedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - player_id
**/
/**
 * Name: bo.chEdit.findVid.clicked. Evid: 88.
 * Event description: Find video clicked.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string. Desc: player_id
 * @param {boChEditFindVidClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditFindVidClicked = function (params) {
    return { evid: 88, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetVidNewCommentAddedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isSingleVideo - true for single / false for channel
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {string} source - live/computer/drive/dropbox
* @property {string} videoID - videoID
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.vid.newComment.added. Evid: 283.
 * Event description: user of user added new comment to Annoto video widget. triggered by orange pimple appearance.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isSingleVideo - Type: bool. Desc: true for single / false for channel
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: live/computer/drive/dropbox
 *
 * videoID - Type: string. Desc: videoID
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetVidNewCommentAddedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetVidNewCommentAdded = function (params) {
    return { evid: 283, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsPromoteProductPopUpDismissClickParams
* @property {string} buttonName - close/cancel
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.promoteProductPopUp.dismiss.click. Evid: 324.
 * Event description: click on close (X) button in "Choose A channel" pop up or on cancel button.

 * buttonName - Type: string. Desc: close/cancel
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsPromoteProductPopUpDismissClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsPromoteProductPopUpDismissClick = function (params) {
    return { evid: 324, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLiveGoLiveMobilePopUpClickParams
* @property {string} button - close / got_it / download
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.live.goLiveMobilePopUp.click. Evid: 470.
 * Event description: Click on 'Go live from your mobile'  pop.

 * button - Type: string. Desc: close / got_it / download
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boLiveGoLiveMobilePopUpClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLiveGoLiveMobilePopUpClick = function (params) {
    return { evid: 470, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appFlashButtonClickParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - from where user click on the button (new_video/schedualed_video,live)
* @property {string} compId - null
**/
/**
 * Name: app.flashButton.click. Evid: 607.
 * Event description: User click on flash button in go live screen.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: from where user click on the button (new_video/schedualed_video,live)
 *
 * compId - Type: string.
 * @param {appFlashButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appFlashButtonClick = function (params) {
    return { evid: 607, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boStatsNosStatsDisplayParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - ADI / editor / МА
* @property {string} compId - player_id
**/
/**
 * Name: bo.stats.nosStats.display. Evid: 95.
 * Event description: No stats state display.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string. Desc: player_id
 * @param {boStatsNosStatsDisplayParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boStatsNosStatsDisplay = function (params) {
    return { evid: 95, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLiveEditDeletePopUpClickParams
* @property {string} button - close / delete / keep_editing
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.live.edit.deletePopUp.click. Evid: 475.
 * Event description: Click on 'Delete this live stream' pop up.

 * button - Type: string. Desc: close / delete / keep_editing
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boLiveEditDeletePopUpClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLiveEditDeletePopUpClick = function (params) {
    return { evid: 475, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetSettingsShowSearchChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isEnabled - toggle on/off
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: appSet.settings.showSearch.changed. Evid: 197.
 * Event description: User change in appSet.settings "show search"  toggle.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isEnabled - Type: bool. Desc: toggle on/off
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetSettingsShowSearchChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetSettingsShowSearchChanged = function (params) {
    return { evid: 197, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetVideoCardsAllCardsOpenClickParams
* @property {GUID} videoInstanceID - instance_id
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {string} siteUrl - site url when video embeded
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.videoCards.allCards.open.click. Evid: 251.
 * Event description: UoU click on 4th button on video.

 * videoInstanceID - Type: guid. Desc: instance_id
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * siteUrl - Type: string. Desc: site url when video embeded
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetVideoCardsAllCardsOpenClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetVideoCardsAllCardsOpenClick = function (params) {
    return { evid: 251, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boSettingsDefaultPriceSaveCompletedParams
* @property {boolean} downloadChanged - If user changed the download option
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isDownload - if uou can download the video
* @property {boolean} isPurchasable - is the videos for purchase
* @property {boolean} isRental - is the videos for rental
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} pricingSelection - free/paid
* @property {boolean} pricingSelectionChange - did the pricing selection changed
* @property {boolean} purchasableChange - did the purchase option changed
* @property {number} purchasePricinig - the price for purchase doubled by 10000
* @property {boolean} purchasePricinigChange - did the purchase price changed
* @property {boolean} rentalChange - did the rental option changed
* @property {string} rentalPeriod - 24/48/72
* @property {boolean} rentalPeriodChange - did the rental period changed
* @property {number} rentalPricinig - the price of renting doubled by 10000
* @property {boolean} rentalPricinigChange - did the rental price changed
**/
/**
 * Name: bo.settings.defaultPrice.saveCompleted. Evid: 32.
 * Event description: Saving the default price completed.

 * downloadChanged - Type: bool. Desc: If user changed the download option
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isDownload - Type: bool. Desc: if uou can download the video
 *
 * isPurchasable - Type: bool. Desc: is the videos for purchase
 *
 * isRental - Type: bool. Desc: is the videos for rental
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * pricingSelection - Type: string. Desc: free/paid
 *
 * pricingSelectionChange - Type: bool. Desc: did the pricing selection changed
 *
 * purchasableChange - Type: bool. Desc: did the purchase option changed
 *
 * purchasePricinig - Type: numeric. Desc: the price for purchase doubled by 10000
 *
 * purchasePricinigChange - Type: bool. Desc: did the purchase price changed
 *
 * rentalChange - Type: bool. Desc: did the rental option changed
 *
 * rentalPeriod - Type: string. Desc: 24/48/72
 *
 * rentalPeriodChange - Type: bool. Desc: did the rental period changed
 *
 * rentalPricinig - Type: numeric. Desc: the price of renting doubled by 10000
 *
 * rentalPricinigChange - Type: bool. Desc: did the rental price changed
 * @param {boSettingsDefaultPriceSaveCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boSettingsDefaultPriceSaveCompleted = function (params) {
    return { evid: 32, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLiveOnboardingButtonClickParams
* @property {string} button - schedule / go_live_mobile / go_live_desktop
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - player_id
**/
/**
 * Name: bo.live.onboardingButton.click. Evid: 451.
 * Event description: Click on schedule event / go live now buttons on live stream tab.

 * button - Type: string. Desc: schedule / go_live_mobile / go_live_desktop
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string. Desc: player_id
 * @param {boLiveOnboardingButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLiveOnboardingButtonClick = function (params) {
    return { evid: 451, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetVidFullScreenClickedParams
* @property {string} channelID - channelID
* @property {string} correlationId - ID for one unique view connection
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {string} videoID - videoID
* @property {string} videoType - live/upload/youtube/vimeo/facebook
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.vid.fullScreen.clicked. Evid: 226.
 * Event description: Full screen butten clicked.

 * channelID - Type: string. Desc: channelID
 *
 * correlationId - Type: string. Desc: ID for one unique view connection
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: videoID
 *
 * videoType - Type: string. Desc: live/upload/youtube/vimeo/facebook
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetVidFullScreenClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetVidFullScreenClicked = function (params) {
    return { evid: 226, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibSignUpToWatchClickedParams
* @property {string} buttonOrigin - from where the user click on it (settings/on video/set pricing/video info)
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {number} numberVideos - number of videos chosen
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {boolean} toggle - on/off
* @property {string} videoID - json of video_id
**/
/**
 * Name: bo.lib.signUpToWatch.clicked. Evid: 114.
 * Event description: click on sign up to watch full video toggle.
only for free videos..

 * buttonOrigin - Type: string. Desc: from where the user click on it (settings/on video/set pricing/video info)
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * numberVideos - Type: numeric. Desc: number of videos chosen
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * toggle - Type: bool. Desc: on/off
 *
 * videoID - Type: string. Desc: json of video_id
 * @param {boLibSignUpToWatchClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibSignUpToWatchClicked = function (params) {
    return { evid: 114, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boStatsTopVidsListSortingChangedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - ADI / editor / МА
* @property {string} compId - player_id
* @property {string} sortingParameter - Views/Sales (units)
**/
/**
 * Name: bo.stats.topVidsList.sorting.changed. Evid: 19.
 * Event description: Changing sorting parameter on the top video list.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string. Desc: player_id
 *
 * sortingParameter - Type: string. Desc: Views/Sales (units)
 * @param {boStatsTopVidsListSortingChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boStatsTopVidsListSortingChanged = function (params) {
    return { evid: 19, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageErrorParams
* @property {string} errorType - No title/Missing trailer
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - ADI / editor / МА
* @property {string} compId - player_id
* @property {string} source - computer/vimeo/facebook/youtube
* @property {string} videoID - videoID
**/
/**
 * Name: bo.vidPage.error. Evid: 96.
 * Event description: Showing error state display in video page.

 * errorType - Type: string. Desc: No title/Missing trailer
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: computer/vimeo/facebook/youtube
 *
 * videoID - Type: string. Desc: videoID
 * @param {boVidPageErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageError = function (params) {
    return { evid: 96, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetSubscriptionPopUpCompletedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {string} errorMsg - error message
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {string} result - success/canceled/failed
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.subscriptionPopUp.Completed. Evid: 207.
 * Event description: Subscription  popup completed.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * errorMsg - Type: string. Desc: error message
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * result - Type: string. Desc: success/canceled/failed
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetSubscriptionPopUpCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetSubscriptionPopUpCompleted = function (params) {
    return { evid: 207, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetLayoutDisplayInfoPublisherChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isEnabled - on/off
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: appSet.layout.displayInfo.publisher.changed. Evid: 194.
 * Event description: User click on publisher on/off in appSet.layout.displayInfo.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isEnabled - Type: bool. Desc: on/off
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetLayoutDisplayInfoPublisherChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetLayoutDisplayInfoPublisherChanged = function (params) {
    return { evid: 194, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appOrientationChangedParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isLive - If user change orientation before live or when live streaming
* @property {GUID} biToken - msid
* @property {string} orientation - portrait/landscape
* @property {string} compId - null
* @property {string} videoType - scheduled/new
**/
/**
 * Name: app.orientation.changed. Evid: 609.
 * Event description: User changed orientation.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isLive - Type: bool. Desc: If user change orientation before live or when live streaming
 *
 * biToken - Type: guid. Desc: msid
 *
 * orientation - Type: string. Desc: portrait/landscape
 *
 * compId - Type: string.
 *
 * videoType - Type: string. Desc: scheduled/new
 * @param {appOrientationChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appOrientationChanged = function (params) {
    return { evid: 609, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetVideosSingleVideoSelectedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: appSet.videos.singleVideo.selected. Evid: 305.
 * Event description: When user choose which single video he want to present in player.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {appSetVideosSingleVideoSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetVideosSingleVideoSelected = function (params) {
    return { evid: 305, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibPricingSaveCompletedParams
* @property {boolean} downloadChanged - If user changed the download option
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isDownload - if uou can download the video
* @property {boolean} isPurchasable - is the videos for purchase
* @property {boolean} isRental - is the videos for rental
* @property {GUID} biToken - msid
* @property {number} numberVideos - number of videos chosen
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} pricingSelection - free/paid
* @property {boolean} pricingSelectionChange - did the pricing selection changed
* @property {boolean} purchasableChange - did the purchase option changed
* @property {number} purchasePricinig - the price for purchase doubled by 10000
* @property {boolean} purchasePricinigChange - did the purchase price changed
* @property {boolean} rentalChange - did the rental option changed
* @property {string} rentalPeriod - 24/48/72
* @property {boolean} rentalPeriodChange - did the rental period changed
* @property {number} rentalPricinig - the price of renting doubled by 10000
* @property {boolean} rentalPricinigChange - did the rental price changed
* @property {string} videoID - json of video_id
**/
/**
 * Name: bo.lib.pricing.saveCompleted. Evid: 50.
 * Event description: Saving the set pricing completed.

 * downloadChanged - Type: bool. Desc: If user changed the download option
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isDownload - Type: bool. Desc: if uou can download the video
 *
 * isPurchasable - Type: bool. Desc: is the videos for purchase
 *
 * isRental - Type: bool. Desc: is the videos for rental
 *
 * biToken - Type: guid. Desc: msid
 *
 * numberVideos - Type: numeric. Desc: number of videos chosen
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * pricingSelection - Type: string. Desc: free/paid
 *
 * pricingSelectionChange - Type: bool. Desc: did the pricing selection changed
 *
 * purchasableChange - Type: bool. Desc: did the purchase option changed
 *
 * purchasePricinig - Type: numeric. Desc: the price for purchase doubled by 10000
 *
 * purchasePricinigChange - Type: bool. Desc: did the purchase price changed
 *
 * rentalChange - Type: bool. Desc: did the rental option changed
 *
 * rentalPeriod - Type: string. Desc: 24/48/72
 *
 * rentalPeriodChange - Type: bool. Desc: did the rental period changed
 *
 * rentalPricinig - Type: numeric. Desc: the price of renting doubled by 10000
 *
 * rentalPricinigChange - Type: bool. Desc: did the rental price changed
 *
 * videoID - Type: string. Desc: json of video_id
 * @param {boLibPricingSaveCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibPricingSaveCompleted = function (params) {
    return { evid: 50, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetPlayerAutoplayChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - null
* @property {string} layoutType - compact / strip etc
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {boolean} toggle - on / off
**/
/**
 * Name: appSet.player.autoplay.changed. Evid: 269.
 * Event description: User changes Autoplay toggle in App settings.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid.
 *
 * layoutType - Type: string. Desc: compact / strip etc
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * toggle - Type: bool. Desc: on / off
 * @param {appSetPlayerAutoplayChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetPlayerAutoplayChanged = function (params) {
    return { evid: 269, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditGoToInfoClickParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - player_id
* @property {string} source - edit_button/cover_image
**/
/**
 * Name: bo.chEdit.goToInfo.click. Evid: 147.
 * Event description: Click on edit channel info button or channel cover.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: edit_button/cover_image
 * @param {boChEditGoToInfoClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditGoToInfoClick = function (params) {
    return { evid: 147, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetTagsSelectedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.tags.selected. Evid: 211.
 * Event description: Tag selected from list.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetTagsSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetTagsSelected = function (params) {
    return { evid: 211, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibUploadErrorParams
* @property {number} auto_resumed - count how many times (in current correlation_id) upload was resumed automatically
* @property {string} correlationId - id to find one upload process (same as 71:52)
* @property {string} errorType - Unsupported format/Invalid video file/File exceeds max size/Unsupported code/Network connection issue/Unknown error resume_error / technical_issue / connectivity_issue
* @property {string} fileFormat - file extension
* @property {number} fileSize - file size in KB
* @property {string} fileType - image / video / audio / doc / folder
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} is_resumable - is download resume available for this file
* @property {number} manual_resumed - count how many times upload was resumed manually
* @property {GUID} biToken - msid
* @property {string} origin - ADI / editor / МА
* @property {string} compId - player_id
* @property {string} videoID - videoID
**/
/**
 * Name: bo.lib.upload.error. Evid: 90.
 * Event description: Uploading  error  display.

 * auto_resumed - Type: numeric. Desc: count how many times (in current correlation_id) upload was resumed automatically
 *
 * correlationId - Type: string. Desc: id to find one upload process (same as 71:52)
 *
 * errorType - Type: string. Desc: Unsupported format/Invalid video file/File exceeds max size/Unsupported code/Network connection issue/Unknown error resume_error / technical_issue / connectivity_issue
 *
 * fileFormat - Type: string. Desc: file extension
 *
 * fileSize - Type: numeric. Desc: file size in KB
 *
 * fileType - Type: string. Desc: image / video / audio / doc / folder
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * is_resumable - Type: bool. Desc: is download resume available for this file
 *
 * manual_resumed - Type: numeric. Desc: count how many times upload was resumed manually
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: videoID
 * @param {boLibUploadErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibUploadError = function (params) {
    return { evid: 90, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetPlayerPreviewExpandedViewClickParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: appSet.player.previewExpandedView.click. Evid: 192.
 * Event description: User click on "Preview Expanded View" in appSet.player.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetPlayerPreviewExpandedViewClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetPlayerPreviewExpandedViewClick = function (params) {
    return { evid: 192, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditChCoverFailedParams
* @property {string} button - drag-n-drop/upload
* @property {string} channelID - channelID
* @property {string} errorType - error type
* @property {GUID} videoInstanceID - InstanceID
* @property {string} mediaType - picture/video
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - player_id
**/
/**
 * Name: bo.chEdit.chCover.Failed. Evid: 130.
 * Event description: Upload cover error event (picture/video).

 * button - Type: string. Desc: drag-n-drop/upload
 *
 * channelID - Type: string. Desc: channelID
 *
 * errorType - Type: string. Desc: error type
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * mediaType - Type: string. Desc: picture/video
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string. Desc: player_id
 * @param {boChEditChCoverFailedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditChCoverFailed = function (params) {
    return { evid: 130, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetVidFullScreenEnteredParams
* @property {string} channelID - channelID
* @property {string} correlationId - ID for one unique view connection
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - on_site/embed
* @property {string} compId - player_id
* @property {string} siteUrl - site url (only when embed video)
* @property {string} videoID - videoID
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.vid.fullScreen.entered. Evid: 234.
 * Event description: User entered (see) video in full screen.

 * channelID - Type: string. Desc: channelID
 *
 * correlationId - Type: string. Desc: ID for one unique view connection
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: on_site/embed
 *
 * compId - Type: string. Desc: player_id
 *
 * siteUrl - Type: string. Desc: site url (only when embed video)
 *
 * videoID - Type: string. Desc: videoID
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetVidFullScreenEnteredParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetVidFullScreenEntered = function (params) {
    return { evid: 234, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageUploadImageSuccessParams
* @property {string} buttonName - upload/change
* @property {string} errorType - error message the user get when uploading image
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {boolean} isSuccess - change/upload image success or not
* @property {string} videoID - videoID
**/
/**
 * Name: bo.vidPage.uploadImage.success. Evid: 142.
 * Event description: upload/change image in video page finish success or not.

 * buttonName - Type: string. Desc: upload/change
 *
 * errorType - Type: string. Desc: error message the user get when uploading image
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * isSuccess - Type: bool. Desc: change/upload image success or not
 *
 * videoID - Type: string. Desc: videoID
 * @param {boVidPageUploadImageSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageUploadImageSuccess = function (params) {
    return { evid: 142, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appNewLiveScheduledStartSoonYesClickParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
**/
/**
 * Name: app.newLive.scheduledStartSoon.yes.click. Evid: 633.
 * Event description: user click on "Yes" button when want to start new live in "Your scheduled video <video name> to start soon" page.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 * @param {appNewLiveScheduledStartSoonYesClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appNewLiveScheduledStartSoonYesClick = function (params) {
    return { evid: 633, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boUploadSuccessPopUpButtonClickParams
* @property {string} button - rmanageChannels/notNow
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.uploadSuccessPopUp.buttonClick. Evid: 44.
 * Event description: Button click in the upload success popup.

 * button - Type: string. Desc: rmanageChannels/notNow
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boUploadSuccessPopUpButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boUploadSuccessPopUpButtonClick = function (params) {
    return { evid: 44, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boUploadAddVideosClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - ADI / editor / МА
* @property {string} compId - player_id
**/
/**
 * Name: bo.upload.addVideos.clicked. Evid: 107.
 * Event description: Sent when user clicks add videos button.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string. Desc: player_id
 * @param {boUploadAddVideosClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boUploadAddVideosClicked = function (params) {
    return { evid: 107, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appLiveEndDeleteVideoGotItClickParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
* @property {string} videoID - video_id
**/
/**
 * Name: app.live.end.deleteVideo.gotIt.click. Evid: 663.
 * Event description: After user delete video that ended and clicking on Got It button.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 *
 * videoID - Type: string. Desc: video_id
 * @param {appLiveEndDeleteVideoGotItClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appLiveEndDeleteVideoGotItClick = function (params) {
    return { evid: 663, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boSettingsPayPalDisconnectCompletedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {GUID} uuid - uuid
**/
/**
 * Name: bo.settings.PayPalDisconnect.Completed. Evid: 89.
 * Event description: Disconnection from paypal has been completed.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * uuid - Type: guid. Desc: uuid
 * @param {boSettingsPayPalDisconnectCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boSettingsPayPalDisconnectCompleted = function (params) {
    return { evid: 89, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibUploadErrorBtnClickParams
* @property {string} button - Replace file/Clear/Try again
* @property {string} correlationId - id to find one upload process (same as 71:52)
* @property {string} errorType - Unsupported format/Invalid video file/File exceeds max size/Unsupported codec/Network connection issue/Unknown error
* @property {string} fileFormat - file extension
* @property {number} fileSize - file size in KB
* @property {string} fileType - image / video / audio / doc / folder
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - ADI / editor / МА
* @property {string} compId - player_id
* @property {string} target - resume / clear / replace file / retry
* @property {string} videoID - videoID
**/
/**
 * Name: bo.lib.upload.error.btn.click. Evid: 91.
 * Event description: Clicking a button (Replace file/Clear/Try again) after uploading  error  displayed.

 * button - Type: string. Desc: Replace file/Clear/Try again
 *
 * correlationId - Type: string. Desc: id to find one upload process (same as 71:52)
 *
 * errorType - Type: string. Desc: Unsupported format/Invalid video file/File exceeds max size/Unsupported codec/Network connection issue/Unknown error
 *
 * fileFormat - Type: string. Desc: file extension
 *
 * fileSize - Type: numeric. Desc: file size in KB
 *
 * fileType - Type: string. Desc: image / video / audio / doc / folder
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string. Desc: player_id
 *
 * target - Type: string. Desc: resume / clear / replace file / retry
 *
 * videoID - Type: string. Desc: videoID
 * @param {boLibUploadErrorBtnClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibUploadErrorBtnClick = function (params) {
    return { evid: 91, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibStateParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - MA/Editor/ADI
* @property {number} overQuotaVideosCount - how many uploaded but over-quoted videos user has (live and upload)
* @property {number} overQuotaVideosDuration - sum of all uploaded and over-quoted videos duration, sec
* @property {string} compId - null
* @property {number} uploadedVideosCount - how many uploaded videos user has (live and upload)
* @property {number} uploadedVideosDuration - sum of all uploaded videos duration, sec
* @property {number} videosCount - how many videos user has
**/
/**
 * Name: bo.lib.state. Evid: 362.
 * Event description: Event with current user video library state, shoot on library open.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: MA/Editor/ADI
 *
 * overQuotaVideosCount - Type: numeric. Desc: how many uploaded but over-quoted videos user has (live and upload)
 *
 * overQuotaVideosDuration - Type: numeric. Desc: sum of all uploaded and over-quoted videos duration, sec
 *
 * compId - Type: string.
 *
 * uploadedVideosCount - Type: numeric. Desc: how many uploaded videos user has (live and upload)
 *
 * uploadedVideosDuration - Type: numeric. Desc: sum of all uploaded videos duration, sec
 *
 * videosCount - Type: numeric. Desc: how many videos user has
 * @param {boLibStateParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibState = function (params) {
    return { evid: 362, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appLearnHowClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
**/
/**
 * Name: app.learnHow.click. Evid: 613.
 * Event description: User click on "Learn How" when there is no channels on the selected site.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 * @param {appLearnHowClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appLearnHowClick = function (params) {
    return { evid: 613, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetSettingsShowSignInChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isEnabled - toggle on/off
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: appSet.settings.showSignIn.changed. Evid: 189.
 * Event description: User change in appSet.settings "show sign in"  toggle.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isEnabled - Type: bool. Desc: toggle on/off
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetSettingsShowSignInChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetSettingsShowSignInChanged = function (params) {
    return { evid: 189, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLiveReschedulePopUpClickParams
* @property {string} button - close / cancel / reschedule
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {boolean} scheduleChanged - true / false
**/
/**
 * Name: bo.live.reschedulePopUp.click. Evid: 463.
 * Event description: Click on 'Reschedule this live stream for later' pop up.

 * button - Type: string. Desc: close / cancel / reschedule
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * scheduleChanged - Type: bool. Desc: true / false
 * @param {boLiveReschedulePopUpClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLiveReschedulePopUpClick = function (params) {
    return { evid: 463, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetMainChooseVideoClickedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isFirst - first time clicking on Choose Video
* @property {string} layoutType - classic, strip or compact
* @property {GUID} biToken - msid
* @property {string} origin - 'my_account' | 'editor' | 'ADI'
* @property {string} compId - player_id
**/
/**
 * Name: appSet.main.chooseVideo.clicked. Evid: 307.
 * Event description: Clicking on "Choose Video" in app settings.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isFirst - Type: bool. Desc: first time clicking on Choose Video
 *
 * layoutType - Type: string. Desc: classic, strip or compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: 'my_account' | 'editor' | 'ADI'
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetMainChooseVideoClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetMainChooseVideoClicked = function (params) {
    return { evid: 307, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appVideoListDeleteClickParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
* @property {string} videoId - video_id
**/
/**
 * Name: app.videoList.delete.click. Evid: 642.
 * Event description: user click on delete button.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 *
 * videoId - Type: string. Desc: video_id
 * @param {appVideoListDeleteClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appVideoListDeleteClick = function (params) {
    return { evid: 642, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetLayoutShowNavigArrowsChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {string} layoutType - small_slider/big_slider
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} selection - on_hover / always
**/
/**
 * Name: appSet.layout.showNavigArrows.changed. Evid: 308.
 * Event description: Users changes "Show navigation arrows" (slider layout).

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * layoutType - Type: string. Desc: small_slider/big_slider
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * selection - Type: string. Desc: on_hover / always
 * @param {appSetLayoutShowNavigArrowsChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetLayoutShowNavigArrowsChanged = function (params) {
    return { evid: 308, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditConnectFeedEnterUrlButtonClickedParams
* @property {string} button_name - connect/cancel/close/change_feed
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - new_feed/change_feed
* @property {string} compId - player_id
* @property {string} source - youtube
**/
/**
 * Name: bo.chEdit.connectFeed.enterUrl.button.clicked. Evid: 118.
 * Event description: Sent when user clicks on button in feed video window.

 * button_name - Type: string. Desc: connect/cancel/close/change_feed
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: new_feed/change_feed
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: youtube
 * @param {boChEditConnectFeedEnterUrlButtonClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditConnectFeedEnterUrlButtonClicked = function (params) {
    return { evid: 118, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetVidInfoClickedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - on_site/embed
* @property {string} compId - player_id
* @property {string} siteUrl - site url (only when embed video)
* @property {string} videoID - videoID
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.vid.info.clicked. Evid: 223.
 * Event description: Info butten clicked.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: on_site/embed
 *
 * compId - Type: string. Desc: player_id
 *
 * siteUrl - Type: string. Desc: site url (only when embed video)
 *
 * videoID - Type: string. Desc: videoID
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetVidInfoClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetVidInfoClicked = function (params) {
    return { evid: 223, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boCloseClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - ADI / editor / МА
* @property {string} compId - player_id
**/
/**
 * Name: bo.close.clicked. Evid: 123.
 * Event description: Clicking on  back office close button.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string. Desc: player_id
 * @param {boCloseClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boCloseClicked = function (params) {
    return { evid: 123, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appLiveEndShareClickParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
* @property {string} videoID - video_id
**/
/**
 * Name: app.live.end.share.click. Evid: 657.
 * Event description: After live ends user click on share  button.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 *
 * videoID - Type: string. Desc: video_id
 * @param {appLiveEndShareClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appLiveEndShareClick = function (params) {
    return { evid: 657, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditChCoverCompletedParams
* @property {string} button - drag-n-drop/upload/change
* @property {string} channelID - channelID
* @property {string} coverID - coverID
* @property {GUID} videoInstanceID - InstanceID
* @property {string} mediaType - picture/video
* @property {string} errorMsg - error message if fail
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - player_id
* @property {boolean} isSuccess - is_success
**/
/**
 * Name: bo.chEdit.chCover.Completed. Evid: 86.
 * Event description: Upload cover completed.

 * button - Type: string. Desc: drag-n-drop/upload/change
 *
 * channelID - Type: string. Desc: channelID
 *
 * coverID - Type: string. Desc: coverID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * mediaType - Type: string. Desc: picture/video
 *
 * errorMsg - Type: string. Desc: error message if fail
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string. Desc: player_id
 *
 * isSuccess - Type: bool. Desc: is_success
 * @param {boChEditChCoverCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditChCoverCompleted = function (params) {
    return { evid: 86, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetAboutChDisplayedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.aboutCh.displayed. Evid: 214.
 * Event description: About channel  button displayed.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetAboutChDisplayedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetAboutChDisplayed = function (params) {
    return { evid: 214, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boPricingPlanSectionPricingPlanchannelsSettingsParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} planIDs - list of plan_id
* @property {string} compId - player_id
**/
/**
 * Name: bo.PricingPlanSection.PricingPlan.channelsSettings. Evid: 268.
 * Event description: "save" in Pricing Plan settings - only when user connected video channel to one of the pricing plans.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * planIDs - Type: string. Desc: list of plan_id
 *
 * compId - Type: string. Desc: player_id
 * @param {boPricingPlanSectionPricingPlanchannelsSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boPricingPlanSectionPricingPlanchannelsSettings = function (params) {
    return { evid: 268, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appLiveStopClickParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
* @property {string} videoID - video_id
**/
/**
 * Name: app.live.stop.click. Evid: 652.
 * Event description: User click on stop after start live.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 *
 * videoID - Type: string. Desc: video_id
 * @param {appLiveStopClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appLiveStopClick = function (params) {
    return { evid: 652, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boSettingsCurrencyChangedParams
* @property {string} currency - new defined currency
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isFirst - first time paypal connection made
* @property {boolean} isSiteBased - true - if VOD2, false - user-based (VOD1)
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.settings.currency.changed. Evid: 28.
 * Event description: Changing difolt currency.

 * currency - Type: string. Desc: new defined currency
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isFirst - Type: bool. Desc: first time paypal connection made
 *
 * isSiteBased - Type: bool. Desc: true - if VOD2, false - user-based (VOD1)
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boSettingsCurrencyChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boSettingsCurrencyChanged = function (params) {
    return { evid: 28, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} playerPlayDoneParams
* @property {string} channelID - channelID
* @property {string} correlationId - one uniq view
* @property {GUID} videoInstanceID - videoInstaceID
* @property {boolean} isAutoplay - If video start autoplay or user click on play
* @property {GUID} biToken - biToken
* @property {string} compId - compId
* @property {string} siteUrl - site_url when embed
* @property {string} videoID - ID of video in term of Wix VOD
* @property {string} videoUrl - Url of video
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: player.play.done. Evid: 246.
 * Event description: Video player playing.

 * channelID - Type: string. Desc: channelID
 *
 * correlationId - Type: string. Desc: one uniq view
 *
 * videoInstanceID - Type: guid. Desc: videoInstaceID
 *
 * isAutoplay - Type: bool. Desc: If video start autoplay or user click on play
 *
 * biToken - Type: guid. Desc: biToken
 *
 * compId - Type: string. Desc: compId
 *
 * siteUrl - Type: string. Desc: site_url when embed
 *
 * videoID - Type: string. Desc: ID of video in term of Wix VOD
 *
 * videoUrl - Type: string. Desc: Url of video
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {playerPlayDoneParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var playerPlayDone = function (params) {
    return { evid: 246, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidChangeVideoCompletedParams
* @property {string} errorType - error message if change not success
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} source - computer/vimeo/facebook/youtube
* @property {boolean} isSuccess - user changed the video success
* @property {string} videoID - new_videoID
**/
/**
 * Name: bo.vid.changeVideo.completed. Evid: 62.
 * Event description: Changing video completed.

 * errorType - Type: string. Desc: error message if change not success
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: computer/vimeo/facebook/youtube
 *
 * isSuccess - Type: bool. Desc: user changed the video success
 *
 * videoID - Type: string. Desc: new_videoID
 * @param {boVidChangeVideoCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidChangeVideoCompleted = function (params) {
    return { evid: 62, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boBreadcrumbClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} name - breadcrumb name
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.breadcrumb.click. Evid: 138.
 * Event description: click on breadcrumb for navigation.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * name - Type: string. Desc: breadcrumb name
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boBreadcrumbClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boBreadcrumbClick = function (params) {
    return { evid: 138, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetDefaultChCreatedParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - editor / ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.defaultCh.created. Evid: 252.
 * Event description: Default channel in widget created automatically after adding a first video.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: editor / ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {widgetDefaultChCreatedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetDefaultChCreated = function (params) {
    return { evid: 252, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLiveEditConnectStreamKeyAndUrlDisplayedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} serverUrl - server url
* @property {string} streamId - stream id
* @property {string} streamKey - stream key
**/
/**
 * Name: bo.live.edit.connectStream.keyAndUrl.displayed. Evid: 460.
 * Event description: Which stream key and url user has. Send on Connect tab view or after Renew key click.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * serverUrl - Type: string. Desc: server url
 *
 * streamId - Type: string. Desc: stream id
 *
 * streamKey - Type: string. Desc: stream key
 * @param {boLiveEditConnectStreamKeyAndUrlDisplayedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLiveEditConnectStreamKeyAndUrlDisplayed = function (params) {
    return { evid: 460, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boSettingsPayPalConnectBtnClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isFirst - first time connecting to paypal
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.settings.PayPalConnectBtn.clicked. Evid: 39.
 * Event description: Clicking on the connect paypal button.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isFirst - Type: bool. Desc: first time connecting to paypal
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boSettingsPayPalConnectBtnClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boSettingsPayPalConnectBtnClicked = function (params) {
    return { evid: 39, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetPlayerShowVideoListChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isEnabled - toggle on/off
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: appSet.player.showVideoList.changed. Evid: 300.
 * Event description: User change in appSet.player "show video list"  toggle.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isEnabled - Type: bool. Desc: toggle on/off
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetPlayerShowVideoListChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetPlayerShowVideoListChanged = function (params) {
    return { evid: 300, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditDeleteChClickedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - player_id
**/
/**
 * Name: bo.chEdit.deleteCh.clicked. Evid: 74.
 * Event description: Delete channel clicked.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string. Desc: player_id
 * @param {boChEditDeleteChClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditDeleteChClicked = function (params) {
    return { evid: 74, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boEmailMarketingUseThisTemplateChooseCancelClickParams
* @property {GUID} videoInstanceID - null
* @property {GUID} biToken - null
* @property {string} origin - ADI / editor / МА
* @property {string} compId - null
* @property {string} templateType - Share Video/Promote Channel/Send Newsletter
**/
/**
 * Name: bo.emailMarketing.useThisTemplate.choose.cancel.click. Evid: 155.
 * Event description: Click on cancel in choose a channel/video box from use this template button in email marketing tab.

 * videoInstanceID - Type: guid.
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string.
 *
 * templateType - Type: string. Desc: Share Video/Promote Channel/Send Newsletter
 * @param {boEmailMarketingUseThisTemplateChooseCancelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boEmailMarketingUseThisTemplateChooseCancelClick = function (params) {
    return { evid: 155, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditAddVidsClickParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - player_id
**/
/**
 * Name: bo.chEdit.addVids.click. Evid: 83.
 * Event description: Add video button click.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string. Desc: player_id
 * @param {boChEditAddVidsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditAddVidsClick = function (params) {
    return { evid: 83, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} siteBaseMigrationPopUpLearnMoreClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: siteBaseMigration.popUp.learnMore.click. Evid: 797.
 * Event description: Click on learn more on Site Base Migration success pop up.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {siteBaseMigrationPopUpLearnMoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteBaseMigrationPopUpLearnMoreClick = function (params) {
    return { evid: 797, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetVidErrorParams
* @property {string} channelID - channelID
* @property {string} correlationId - ID for one unique view connection
* @property {string} errorType - Video is not available/Video is processing
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - on_site/embed
* @property {string} compId - player_id
* @property {string} siteUrl - site url (only when embed video)
* @property {string} videoID - videoID
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.vid.error. Evid: 229.
 * Event description: Error state display on video.

 * channelID - Type: string. Desc: channelID
 *
 * correlationId - Type: string. Desc: ID for one unique view connection
 *
 * errorType - Type: string. Desc: Video is not available/Video is processing
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: on_site/embed
 *
 * compId - Type: string. Desc: player_id
 *
 * siteUrl - Type: string. Desc: site url (only when embed video)
 *
 * videoID - Type: string. Desc: videoID
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetVidErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetVidError = function (params) {
    return { evid: 229, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boSettingsDefaultChChangedParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.settings.defaultCh.changed. Evid: 33.
 * Event description: Default channel changed.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boSettingsDefaultChChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boSettingsDefaultChChanged = function (params) {
    return { evid: 33, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsActionCardsHowToPopUpOpenedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - null
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.actionCardsHowToPopUp.opened. Evid: 349.
 * Event description: How to action cards pop up opened.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string.
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsActionCardsHowToPopUpOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsActionCardsHowToPopUpOpened = function (params) {
    return { evid: 349, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boGeneralHelpBtnClickedParams
* @property {string} buttonPosition - left_sidebar/top_right
* @property {string} fromTab - video-library/channels/stats/settings
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.general.helpBtn.clicked. Evid: 40.
 * Event description: Help button clicked.

 * buttonPosition - Type: string. Desc: left_sidebar/top_right
 *
 * fromTab - Type: string. Desc: video-library/channels/stats/settings
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boGeneralHelpBtnClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boGeneralHelpBtnClicked = function (params) {
    return { evid: 40, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boEmailMarketingStartFromScratchClickedParams
* @property {GUID} videoInstanceID - null
* @property {GUID} biToken - null
* @property {string} origin - ADI / editor / МА
* @property {string} compId - null
**/
/**
 * Name: bo.emailMarketing.startFromScratch.clicked. Evid: 152.
 * Event description: Click on start from scratch button in email marketing tab.

 * videoInstanceID - Type: guid.
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string.
 * @param {boEmailMarketingStartFromScratchClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boEmailMarketingStartFromScratchClicked = function (params) {
    return { evid: 152, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLiveEditTabClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} tabName - connect_stream / add_info
**/
/**
 * Name: bo.live.edit.tab.click. Evid: 454.
 * Event description: Click on Connect Stream tab or Add info tab, live stream edit process.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * tabName - Type: string. Desc: connect_stream / add_info
 * @param {boLiveEditTabClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLiveEditTabClick = function (params) {
    return { evid: 454, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChConnectFeedCompletedParams
* @property {string} channelID - channel_id
* @property {number} errorCode - Error code
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isFirst - first time uploading
* @property {string} errorMsg - Error message
* @property {GUID} biToken - msid
* @property {string} origin - new_feed/change_feed
* @property {string} url - the URL address the user entered if add failed
* @property {string} compId - player_id
* @property {string} source - youtube
* @property {boolean} isSuccess - if the connect feed finished successfully
**/
/**
 * Name: bo.ch.connectFeed.completed. Evid: 124.
 * Event description: Sent when feed added to user channels.

 * channelID - Type: string. Desc: channel_id
 *
 * errorCode - Type: numeric. Desc: Error code
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isFirst - Type: bool. Desc: first time uploading
 *
 * errorMsg - Type: string. Desc: Error message
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: new_feed/change_feed
 *
 * url - Type: string. Desc: the URL address the user entered if add failed
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: youtube
 *
 * isSuccess - Type: bool. Desc: if the connect feed finished successfully
 * @param {boChConnectFeedCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChConnectFeedCompleted = function (params) {
    return { evid: 124, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsCardQuickActionClickParams
* @property {string} actionType - delete/duplicate
* @property {string} cardName - promote_video/feature_channel/promote_product/get_social_followers/custom
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.card.quickAction.click. Evid: 328.
 * Event description: click on card quick actions (duplicate/delete).

 * actionType - Type: string. Desc: delete/duplicate
 *
 * cardName - Type: string. Desc: promote_video/feature_channel/promote_product/get_social_followers/custom
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsCardQuickActionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsCardQuickActionClick = function (params) {
    return { evid: 328, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetDesignLoadMoreButtonStyleChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} selection - text_button / text_and_button
**/
/**
 * Name: appSet.design.loadMoreButtonStyle.changed. Evid: 169.
 * Event description: User change load more button style.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * selection - Type: string. Desc: text_button / text_and_button
 * @param {appSetDesignLoadMoreButtonStyleChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetDesignLoadMoreButtonStyleChanged = function (params) {
    return { evid: 169, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boSettingsPayPalConnectBtnConnectedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isFirst - first time paypal connection made
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {GUID} uuid - uuid
**/
/**
 * Name: bo.settings.PayPalConnectBtn.connected. Evid: 38.
 * Event description: Connect paypal Succeed.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isFirst - Type: bool. Desc: first time paypal connection made
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * uuid - Type: guid. Desc: uuid
 * @param {boSettingsPayPalConnectBtnConnectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boSettingsPayPalConnectBtnConnected = function (params) {
    return { evid: 38, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetActionParams
* @property {string} eventName - [Namespace].[UI type].[Action type]
* @property {GUID} videoInstanceID - null
* @property {GUID} biToken - null
* @property {string} compId - null
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: Widget Action. Evid: 232.
 * Event description: Common Event for all UoU actions in widget.

 * eventName - Type: string. Desc: [Namespace].[UI type].[Action type]
 *
 * videoInstanceID - Type: guid.
 *
 * biToken - Type: guid.
 *
 * compId - Type: string.
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetAction = function (params) {
    return { evid: 232, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsCustomCardPopUpUploadImageActionClickParams
* @property {string} buttonName - upload/change/delete
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.customCardPopUp.uploadImage.action.click. Evid: 357.
 * Event description: upload image action (upload/change/delete) clicked in   "Custom Card" pop up.

 * buttonName - Type: string. Desc: upload/change/delete
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsCustomCardPopUpUploadImageActionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsCustomCardPopUpUploadImageActionClick = function (params) {
    return { evid: 357, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetLoadedParams
* @property {string} editorMode - editorMode
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: appSet.loaded. Evid: 99.
 * Event description: The existing appSet.opened (evid=100) event sends when the app starts (aka js inits), this one would send right from the html load.

 * editorMode - Type: string. Desc: editorMode
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetLoaded = function (params) {
    return { evid: 99, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsPromoteVideoPopUpChooseVideoChooseClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.promoteVideoPopUp.chooseVideo.choose.click. Evid: 341.
 * Event description: click on choose in "choose a video" page in promote video modal.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsPromoteVideoPopUpChooseVideoChooseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsPromoteVideoPopUpChooseVideoChooseClick = function (params) {
    return { evid: 341, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetLoadedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {string} viewMode - editor/viewer
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.loaded. Evid: 199.
 * Event description: The existing widget.opened (evid=200) event sends when the app starts (aka js inits), this one would send right from the html load.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * viewMode - Type: string. Desc: editor/viewer
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetLoaded = function (params) {
    return { evid: 199, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boUploadReadyParams
* @property {string} button - drag&drop /upload
* @property {number} status_code - status code
* @property {string} correlationId - correlation_id
* @property {string} errorKey - wmp error key
* @property {string} errorScope - OK/failedChecking/failedRequirement/failedTransmission/failedByUseAction/failedProcessing
* @property {string} errorType - OK/networkError/serverError/unknownError/userClosedDashboard/quotaExceeded/invalidFile/notSupported/exceedsMaxSize
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isFirst - first time uploading
* @property {boolean} isSuccess - did the upload succesed
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} path - url path of a http call that caused the error
* @property {string} compId - player_id
* @property {string} source - upload/drive/dropbox
* @property {string} tracksUploaded - number of files, what was selected to upload including current
**/
/**
 * Name: bo.upload.ready. Evid: 254.
 * Event description: Single video upload and post processing completed. Sent from server when video is transcoded and ready to use in application..

 * button - Type: string. Desc: drag&drop /upload
 *
 * status_code - Type: numeric. Desc: status code
 *
 * correlationId - Type: string. Desc: correlation_id
 *
 * errorKey - Type: string. Desc: wmp error key
 *
 * errorScope - Type: string. Desc: OK/failedChecking/failedRequirement/failedTransmission/failedByUseAction/failedProcessing
 *
 * errorType - Type: string. Desc: OK/networkError/serverError/unknownError/userClosedDashboard/quotaExceeded/invalidFile/notSupported/exceedsMaxSize
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isFirst - Type: bool. Desc: first time uploading
 *
 * isSuccess - Type: bool. Desc: did the upload succesed
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * path - Type: string. Desc: url path of a http call that caused the error
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: upload/drive/dropbox
 *
 * tracksUploaded - Type: string. Desc: number of files, what was selected to upload including current
 * @param {boUploadReadyParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boUploadReady = function (params) {
    return { evid: 254, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appLiveConnectionIssueEndParams
* @property {string} channelID - channel_id
* @property {string} errorType - storage/connection_lost etc.
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
* @property {string} videoID - video_id
**/
/**
 * Name: app.live.connectionIssue.end. Evid: 666.
 * Event description: When connection issue end.

 * channelID - Type: string. Desc: channel_id
 *
 * errorType - Type: string. Desc: storage/connection_lost etc.
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 *
 * videoID - Type: string. Desc: video_id
 * @param {appLiveConnectionIssueEndParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appLiveConnectionIssueEnd = function (params) {
    return { evid: 666, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boSettingsEmailLangChangedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} selectedLang - the language changed to
**/
/**
 * Name: bo.settings.emailLang.changed. Evid: 34.
 * Event description: Default email language changed.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * selectedLang - Type: string. Desc: the language changed to
 * @param {boSettingsEmailLangChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boSettingsEmailLangChanged = function (params) {
    return { evid: 34, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetLayoutLayoutWidthChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - null
* @property {string} compId - player_id
* @property {string} selection - full_width/page_width
**/
/**
 * Name: appSet.layout.layoutWidth.changed. Evid: 7.
 * Event description: Choosing layout width between full or strip
(a strip layout event).

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid.
 *
 * compId - Type: string. Desc: player_id
 *
 * selection - Type: string. Desc: full_width/page_width
 * @param {appSetLayoutLayoutWidthChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetLayoutLayoutWidthChanged = function (params) {
    return { evid: 7, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boPopUpShownParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {string} message - old_subs_to_free etc
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - player_id
**/
/**
 * Name: bo.popUp.Shown. Evid: 265.
 * Event description: any pop up shoown.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * message - Type: string. Desc: old_subs_to_free etc
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string. Desc: player_id
 * @param {boPopUpShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boPopUpShown = function (params) {
    return { evid: 265, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibVidArrowClickedParams
* @property {string} button - next / previous
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} source - youtube/vimeo/facebook/computer/live
* @property {string} videoID - videoID
**/
/**
 * Name: bo.lib.vid.arrow.clicked. Evid: 270.
 * Event description: Click on navigation arrows on video edit page.

 * button - Type: string. Desc: next / previous
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: youtube/vimeo/facebook/computer/live
 *
 * videoID - Type: string. Desc: videoID
 * @param {boLibVidArrowClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibVidArrowClicked = function (params) {
    return { evid: 270, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} playerPlayRequestedParams
* @property {string} channelID - channelID
* @property {string} correlationId - one unique view
* @property {GUID} videoInstanceID - videoInstaceID
* @property {boolean} isAutoplay - If video start autoplay or user click on play
* @property {GUID} biToken - biToken
* @property {string} compId - compId
* @property {string} siteUrl - site_url when embed
* @property {string} videoID - ID of video in terms of Wix VOD
* @property {string} videoUrl - Url of video
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: player.play.requested. Evid: 245.
 * Event description: Video player play requested.

 * channelID - Type: string. Desc: channelID
 *
 * correlationId - Type: string. Desc: one unique view
 *
 * videoInstanceID - Type: guid. Desc: videoInstaceID
 *
 * isAutoplay - Type: bool. Desc: If video start autoplay or user click on play
 *
 * biToken - Type: guid. Desc: biToken
 *
 * compId - Type: string. Desc: compId
 *
 * siteUrl - Type: string. Desc: site_url when embed
 *
 * videoID - Type: string. Desc: ID of video in terms of Wix VOD
 *
 * videoUrl - Type: string. Desc: Url of video
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {playerPlayRequestedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var playerPlayRequested = function (params) {
    return { evid: 245, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetSearchClickedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.search.clicked. Evid: 209.
 * Event description: Search click from widget.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetSearchClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetSearchClicked = function (params) {
    return { evid: 209, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLiveBeforeStartPopUpClickParams
* @property {string} button - cancel / close / i_have_an_encoder / guide
* @property {boolean} dontShow - true / false
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.live.beforeStartPopUp.click. Evid: 453.
 * Event description: Click on 'Before you start pop up' (live stream tab).

 * button - Type: string. Desc: cancel / close / i_have_an_encoder / guide
 *
 * dontShow - Type: bool. Desc: true / false
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boLiveBeforeStartPopUpClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLiveBeforeStartPopUpClick = function (params) {
    return { evid: 453, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetWelcomeScreenClickedParams
* @property {string} editorMode - editorMode
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - editor/adi
* @property {string} compId - player_id
* @property {string} selection - DesignMyChannel/StartNow
**/
/**
 * Name: appSet.welcomeScreen.clicked. Evid: 17.
 * Event description: Witch button did you clicked on the welcome screen.

 * editorMode - Type: string. Desc: editorMode
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: editor/adi
 *
 * compId - Type: string. Desc: player_id
 *
 * selection - Type: string. Desc: DesignMyChannel/StartNow
 * @param {appSetWelcomeScreenClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetWelcomeScreenClicked = function (params) {
    return { evid: 17, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsFeatureChannelPopUpSaveClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.featureChannelPopUp.save.click. Evid: 348.
 * Event description: click on save in "Feature a Channel" page.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsFeatureChannelPopUpSaveClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsFeatureChannelPopUpSaveClick = function (params) {
    return { evid: 348, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibPricingClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {number} numberVideos - number of videos chosen
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - json of video_id
**/
/**
 * Name: bo.lib.pricing.clicked. Evid: 48.
 * Event description: Clicking on set pricing.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * numberVideos - Type: numeric. Desc: number of videos chosen
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: json of video_id
 * @param {boLibPricingClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibPricingClicked = function (params) {
    return { evid: 48, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsVideoCardsButtonClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {number} numberOfCards - number of cards in video (all cards)
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - new_videoID
**/
/**
 * Name: bo.vidPage.videoCards.video.cardsButton.clicked. Evid: 336.
 * Event description: Click on 4th button (cards button - star) in player (only on video cards BO).

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * numberOfCards - Type: numeric. Desc: number of cards in video (all cards)
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: new_videoID
 * @param {boVidPageVideoCardsVideoCardsButtonClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsVideoCardsButtonClicked = function (params) {
    return { evid: 336, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boUploadAddVideosFacebookVideoCancelButtonClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - first_video/add_videos_menu
* @property {string} compId - player_id
**/
/**
 * Name: bo.upload.addVideos.facebookVideo.cancel.button.clicked. Evid: 162.
 * Event description: Sent when user clicks on cancelbutton in embed video window.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: first_video/add_videos_menu
 *
 * compId - Type: string. Desc: player_id
 * @param {boUploadAddVideosFacebookVideoCancelButtonClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boUploadAddVideosFacebookVideoCancelButtonClicked = function (params) {
    return { evid: 162, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetVidSelectedBtnClickedParams
* @property {string} button - playVid/buy/rent/buyFrom/trailer/preview
* @property {string} buttonType - thumbnail/main
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {boolean} overQuoted - is video id under OverQuota, true / false
* @property {string} compId - player_id
* @property {string} videoID - videoID
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.VidSelected.btn.clicked. Evid: 204.
 * Event description: Clicked video button (playVid ,buy, rent, buy From, trailer or preview).

 * button - Type: string. Desc: playVid/buy/rent/buyFrom/trailer/preview
 *
 * buttonType - Type: string. Desc: thumbnail/main
 *
 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * overQuoted - Type: bool. Desc: is video id under OverQuota, true / false
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: videoID
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetVidSelectedBtnClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetVidSelectedBtnClicked = function (params) {
    return { evid: 204, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditChCoverUploadParams
* @property {string} button - drag-n-drop/upload/change
* @property {string} channelID - channelID
* @property {string} coverID - coverID
* @property {GUID} videoInstanceID - InstanceID
* @property {string} mediaType - picture/video
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - player_id
**/
/**
 * Name: bo.chEdit.chCover.upload. Evid: 85.
 * Event description: Upload cover.

 * button - Type: string. Desc: drag-n-drop/upload/change
 *
 * channelID - Type: string. Desc: channelID
 *
 * coverID - Type: string. Desc: coverID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * mediaType - Type: string. Desc: picture/video
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string. Desc: player_id
 * @param {boChEditChCoverUploadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditChCoverUpload = function (params) {
    return { evid: 85, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditDefaultChannelTooltipSettingsClickParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor
* @property {string} compId - player_id
**/
/**
 * Name: bo.chEdit.defaultChannel.tooltip.settings.click. Evid: 134.
 * Event description: click on settings in default channel tooltip.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor
 *
 * compId - Type: string. Desc: player_id
 * @param {boChEditDefaultChannelTooltipSettingsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditDefaultChannelTooltipSettingsClick = function (params) {
    return { evid: 134, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsPromoteVideoPopUpChannelPickerSaveClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} previousStep - from which page the user "came" to choose a channel page
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.promoteVideoPopUp.channelPicker.save.click. Evid: 342.
 * Event description: click on save in "choose a channel" page in promote video modal.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * previousStep - Type: string. Desc: from which page the user "came" to choose a channel page
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsPromoteVideoPopUpChannelPickerSaveClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsPromoteVideoPopUpChannelPickerSaveClick = function (params) {
    return { evid: 342, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsCustomCardPopUpDismissClickParams
* @property {string} buttonName - close/cancel
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.customCardPopUp.dismiss.click. Evid: 356.
 * Event description: click on close (X) button in "Custom Card" pop up.

 * buttonName - Type: string. Desc: close/cancel
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsCustomCardPopUpDismissClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsCustomCardPopUpDismissClick = function (params) {
    return { evid: 356, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appNewLiveScheduledStartSoonNotNowClickParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
**/
/**
 * Name: app.newLive.scheduledStartSoon.notNow.click. Evid: 634.
 * Event description: user click on "not now" button when want to start new live in "Your scheduled video <video name> to start soon" page.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 * @param {appNewLiveScheduledStartSoonNotNowClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appNewLiveScheduledStartSoonNotNowClick = function (params) {
    return { evid: 634, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidChangeCoverClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - new_videoID
**/
/**
 * Name: bo.vid.changeCover.clicked. Evid: 63.
 * Event description: Changing on change cover.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: new_videoID
 * @param {boVidChangeCoverClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidChangeCoverClicked = function (params) {
    return { evid: 63, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetChooseChannelChangedParams
* @property {string} channelID - channel_id
* @property {string} channelType - channel/youtube-feed
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isFirst - first time choosing a channel
* @property {string} layoutType - compact/strip/classic
* @property {GUID} biToken - msid
* @property {string} origin - editor / ADI (null is editor)
* @property {string} compId - player_id
**/
/**
 * Name: appSet.chooseChannel.changed. Evid: 3.
 * Event description: Choosing a channel from the channel list drop down.

 * channelID - Type: string. Desc: channel_id
 *
 * channelType - Type: string. Desc: channel/youtube-feed
 *
 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isFirst - Type: bool. Desc: first time choosing a channel
 *
 * layoutType - Type: string. Desc: compact/strip/classic
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: editor / ADI (null is editor)
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetChooseChannelChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetChooseChannelChanged = function (params) {
    return { evid: 3, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetLayoutDisplayInfoTitleChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isEnabled - on/off
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: appSet.layout.displayInfo.title.changed. Evid: 193.
 * Event description: User click on title on/off in appSet.layout.displayInfo.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isEnabled - Type: bool. Desc: on/off
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetLayoutDisplayInfoTitleChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetLayoutDisplayInfoTitleChanged = function (params) {
    return { evid: 193, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageUploadImageClickParams
* @property {string} buttonName - upload/change
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - videoID
**/
/**
 * Name: bo.vidPage.uploadImage.click. Evid: 141.
 * Event description: click on upload/change image in video page.

 * buttonName - Type: string. Desc: upload/change
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: videoID
 * @param {boVidPageUploadImageClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageUploadImageClick = function (params) {
    return { evid: 141, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boUploadAddVideosEmbedVideoCompletedParams
* @property {number} errorCode - Error code
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isFirst - first time uploading
* @property {string} errorMsg - Error message
* @property {GUID} biToken - msid
* @property {number} num_videos_embedded - number of videos embedded together
* @property {string} origin - first_video/add_videos_menu
* @property {string} url - the URL address the user entered if add failed
* @property {string} compId - player_id
* @property {string} source - youtube/vimeo/facebook
* @property {boolean} isSuccess - if the upload finished successfully
**/
/**
 * Name: bo.upload.addVideos.embedVideo.completed. Evid: 112.
 * Event description: Sent when embedded video added to video library.

 * errorCode - Type: numeric. Desc: Error code
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isFirst - Type: bool. Desc: first time uploading
 *
 * errorMsg - Type: string. Desc: Error message
 *
 * biToken - Type: guid. Desc: msid
 *
 * num_videos_embedded - Type: numeric. Desc: number of videos embedded together
 *
 * origin - Type: string. Desc: first_video/add_videos_menu
 *
 * url - Type: string. Desc: the URL address the user entered if add failed
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: youtube/vimeo/facebook
 *
 * isSuccess - Type: bool. Desc: if the upload finished successfully
 * @param {boUploadAddVideosEmbedVideoCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boUploadAddVideosEmbedVideoCompleted = function (params) {
    return { evid: 112, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLiveGoLiveNowClickParams
* @property {string} button - main / scheduled_event
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} type - desktop / mobile
* @property {string} videoID - video
**/
/**
 * Name: bo.live.goLiveNow.click. Evid: 468.
 * Event description: Click on 'Go live now' button on 'Live Stream' tab.

 * button - Type: string. Desc: main / scheduled_event
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * type - Type: string. Desc: desktop / mobile
 *
 * videoID - Type: string. Desc: video
 * @param {boLiveGoLiveNowClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLiveGoLiveNowClick = function (params) {
    return { evid: 468, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boSettingsLogoLearnMoreClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.settings.logo.learnMore.click. Evid: 184.
 * Event description: Click on learn more button from logo section in bo.settings.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boSettingsLogoLearnMoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boSettingsLogoLearnMoreClick = function (params) {
    return { evid: 184, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} mediaShareVideoSucceedParams
* @property {string} channelID - channel_id
* @property {string} correlationId - ID for one unique view connection
* @property {GUID} videoInstanceID - instance_id
* @property {GUID} biToken - biToken
* @property {string} pageId - page_id
* @property {string} compId - compId
* @property {string} videoID - ID of video in terms of Wix VOD
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: mediaShare.video.succeed. Evid: 399.
 * Event description: Server events for Facebook & Twitter share params.

 * channelID - Type: string. Desc: channel_id
 *
 * correlationId - Type: string. Desc: ID for one unique view connection
 *
 * videoInstanceID - Type: guid. Desc: instance_id
 *
 * biToken - Type: guid. Desc: biToken
 *
 * pageId - Type: string. Desc: page_id
 *
 * compId - Type: string. Desc: compId
 *
 * videoID - Type: string. Desc: ID of video in terms of Wix VOD
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {mediaShareVideoSucceedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mediaShareVideoSucceed = function (params) {
    return { evid: 399, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetMainManageVideosClickedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isFirst - first time clicking on manage videos
* @property {string} layoutType - classic, strip or compact
* @property {GUID} biToken - msid
* @property {string} origin - 'my_account' | 'editor' | 'ADI'
* @property {string} compId - player_id
**/
/**
 * Name: appSet.main.manageVideos.clicked. Evid: 5.
 * Event description: Clicking on manage videos button.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isFirst - Type: bool. Desc: first time clicking on manage videos
 *
 * layoutType - Type: string. Desc: classic, strip or compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: 'my_account' | 'editor' | 'ADI'
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetMainManageVideosClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetMainManageVideosClicked = function (params) {
    return { evid: 5, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetVideoCardsCardClickParams
* @property {string} cardName - promote_video/promote_channel/get_social_followers/boost_sales/custom_text
* @property {GUID} videoInstanceID - instance_id
* @property {GUID} biToken - msid
* @property {string} origin - video/all_cards
* @property {string} compId - player_id
* @property {string} siteUrl - site url when video embeded
* @property {string} socialNetwork - If it's increase social card Facebook/YouTube/Twitter
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.videoCards.card.click. Evid: 249.
 * Event description: UoU clicking on action in card.

 * cardName - Type: string. Desc: promote_video/promote_channel/get_social_followers/boost_sales/custom_text
 *
 * videoInstanceID - Type: guid. Desc: instance_id
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: video/all_cards
 *
 * compId - Type: string. Desc: player_id
 *
 * siteUrl - Type: string. Desc: site url when video embeded
 *
 * socialNetwork - Type: string. Desc: If it's increase social card Facebook/YouTube/Twitter
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetVideoCardsCardClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetVideoCardsCardClick = function (params) {
    return { evid: 249, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibBatchEditSaveClickParams
* @property {string} audience - (all/mature)
* @property {boolean} audienceChanged - did the audience changed
* @property {boolean} categoryExists - did categories added
* @property {string} genre - genre
* @property {boolean} genreChanged - did the genre changed
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {number} numOfCastMembers - number of cast members
* @property {number} numOfCrewMembers - number of crew members
* @property {number} numOfTags - number of tags
* @property {number} numVideoEdit - number of videos user edit
* @property {string} origin - my_account/editor/ADI
* @property {number} overQuotaVideosCount - how many of the videos are OverQ
* @property {string} compId - player_id
* @property {boolean} publisherExists - did publisher added
* @property {string} source - computer/vimeo/facebook/youtube
* @property {string} videoID - new_videoID
* @property {string} videoType - video type
* @property {boolean} videoTypeChanged - did the video type changed
**/
/**
 * Name: bo.lib.batchEdit.save.click. Evid: 143.
 * Event description: Save clicked at the video library (batch edit).

 * audience - Type: string. Desc: (all/mature)
 *
 * audienceChanged - Type: bool. Desc: did the audience changed
 *
 * categoryExists - Type: bool. Desc: did categories added
 *
 * genre - Type: string. Desc: genre
 *
 * genreChanged - Type: bool. Desc: did the genre changed
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * numOfCastMembers - Type: numeric. Desc: number of cast members
 *
 * numOfCrewMembers - Type: numeric. Desc: number of crew members
 *
 * numOfTags - Type: numeric. Desc: number of tags
 *
 * numVideoEdit - Type: numeric. Desc: number of videos user edit
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * overQuotaVideosCount - Type: numeric. Desc: how many of the videos are OverQ
 *
 * compId - Type: string. Desc: player_id
 *
 * publisherExists - Type: bool. Desc: did publisher added
 *
 * source - Type: string. Desc: computer/vimeo/facebook/youtube
 *
 * videoID - Type: string. Desc: new_videoID
 *
 * videoType - Type: string. Desc: video type
 *
 * videoTypeChanged - Type: bool. Desc: did the video type changed
 * @param {boLibBatchEditSaveClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibBatchEditSaveClick = function (params) {
    return { evid: 143, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPagePriceErrorParams
* @property {string} buyType - subscription/video
* @property {string} errorType - Price too high/Price too low
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - ADI / editor / МА
* @property {string} compId - player_id
* @property {string} videoID - videoID
**/
/**
 * Name: bo.vidPage.priceError. Evid: 97.
 * Event description: Showing price error state display in video page, default price page and channel info page.

 * buyType - Type: string. Desc: subscription/video
 *
 * errorType - Type: string. Desc: Price too high/Price too low
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: videoID
 * @param {boVidPagePriceErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPagePriceError = function (params) {
    return { evid: 97, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLiveEmptyStateScheduleClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.live.emptyState.schedule.click. Evid: 466.
 * Event description: Schedule event click on live stream library (when empty).

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boLiveEmptyStateScheduleClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLiveEmptyStateScheduleClick = function (params) {
    return { evid: 466, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibChooseLogoPopUpChooseLogoClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoId - video_id
**/
/**
 * Name: bo.lib.chooseLogoPopUp.chooseLogo.click. Evid: 179.
 * Event description: click on "choose logo" in logo pop up.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoId - Type: string. Desc: video_id
 * @param {boLibChooseLogoPopUpChooseLogoClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibChooseLogoPopUpChooseLogoClick = function (params) {
    return { evid: 179, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibEmbedOptionsLogoClickParams
* @property {string} button_name - add/choose/change
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoId - video_id
**/
/**
 * Name: bo.lib.embedOptions.logo.click. Evid: 177.
 * Event description: click on add/choose/change logo in embed section.

 * button_name - Type: string. Desc: add/choose/change
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoId - Type: string. Desc: video_id
 * @param {boLibEmbedOptionsLogoClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibEmbedOptionsLogoClick = function (params) {
    return { evid: 177, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetSettingsChannelOptionsTagsChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isTags - Choosing to offer tags in search or not
* @property {string} layoutType - compact / strip / etc
* @property {GUID} biToken - msid
* @property {string} compId - player_id
**/
/**
 * Name: appSet.settings.channelOptions.tags.changed. Evid: 12.
 * Event description: Choosing to offer tags in search or not.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isTags - Type: bool. Desc: Choosing to offer tags in search or not
 *
 * layoutType - Type: string. Desc: compact / strip / etc
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetSettingsChannelOptionsTagsChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetSettingsChannelOptionsTagsChanged = function (params) {
    return { evid: 12, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibAddLogoPopUpGoToSettingsClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoId - video_id
**/
/**
 * Name: bo.lib.addLogoPopUp.goToSettings.click. Evid: 182.
 * Event description: click on "go to settings" in "add a custom logo" popup.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoId - Type: string. Desc: video_id
 * @param {boLibAddLogoPopUpGoToSettingsClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibAddLogoPopUpGoToSettingsClick = function (params) {
    return { evid: 182, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsPromoteProductPopUpUploadImageActionClickParams
* @property {string} buttonName - upload/change/delete
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.promoteProductPopUp.uploadImage.action.click. Evid: 325.
 * Event description: upload image action (upload/change/delete) clicked in   "Promote A Product" pop up.

 * buttonName - Type: string. Desc: upload/change/delete
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsPromoteProductPopUpUploadImageActionClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsPromoteProductPopUpUploadImageActionClick = function (params) {
    return { evid: 325, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetShareClickedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {string} typeShare - facebook/twitter/pinterest/tumblr
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.share.clicked. Evid: 217.
 * Event description: Share button clicked.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * typeShare - Type: string. Desc: facebook/twitter/pinterest/tumblr
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetShareClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetShareClicked = function (params) {
    return { evid: 217, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetEmbedVidStartPlayParams
* @property {string} channelID - channelID
* @property {string} correlationId - ID for one unique view connection
* @property {GUID} videoInstanceID - instance_id
* @property {boolean} isAutoplay - If video start autoplay or user click on play
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {string} siteUrl - site url (only when embed video)
* @property {number} videoHeight - Actual height of video source
* @property {string} videoID - videoID
* @property {string} videoType - computer/vimeo/facebook/youtube
* @property {number} videoWidth - Actual width of video source
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.embed.vid.start.play. Evid: 243.
 * Event description: when video start play after user click (242).

 * channelID - Type: string. Desc: channelID
 *
 * correlationId - Type: string. Desc: ID for one unique view connection
 *
 * videoInstanceID - Type: guid. Desc: instance_id
 *
 * isAutoplay - Type: bool. Desc: If video start autoplay or user click on play
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * siteUrl - Type: string. Desc: site url (only when embed video)
 *
 * videoHeight - Type: numeric. Desc: Actual height of video source
 *
 * videoID - Type: string. Desc: videoID
 *
 * videoType - Type: string. Desc: computer/vimeo/facebook/youtube
 *
 * videoWidth - Type: numeric. Desc: Actual width of video source
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetEmbedVidStartPlayParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetEmbedVidStartPlay = function (params) {
    return { evid: 243, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetSettingsMainItemTypeChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} selection - channel_cover/featured_video
**/
/**
 * Name: appSet.settings.mainItemType.changed. Evid: 170.
 * Event description: User change in appSet.settings at main Item section to channel cover or featured video.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * selection - Type: string. Desc: channel_cover/featured_video
 * @param {appSetSettingsMainItemTypeChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetSettingsMainItemTypeChanged = function (params) {
    return { evid: 170, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditRemoveClickedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - player_id
* @property {string} videoID - videoID
**/
/**
 * Name: bo.chEdit.remove.clicked. Evid: 81.
 * Event description: Remove video form channel clicked.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: videoID
 * @param {boChEditRemoveClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditRemoveClicked = function (params) {
    return { evid: 81, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetLayoutDisplayInfoChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {string} layoutType - small_slider/big_slider
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {boolean} toggle - on / off
**/
/**
 * Name: appSet.layout.displayInfo.changed. Evid: 402.
 * Event description: User toggles to show Video info on a player tab (before playing part).

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * layoutType - Type: string. Desc: small_slider/big_slider
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * toggle - Type: bool. Desc: on / off
 * @param {appSetLayoutDisplayInfoChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetLayoutDisplayInfoChanged = function (params) {
    return { evid: 402, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetVideosChannelCreateNewChannelClickParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {string} layoutType - classic, strip or compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account, editor, ADI
* @property {string} compId - player_id
**/
/**
 * Name: appSet.videos.channel.createNewChannel.click. Evid: 248.
 * Event description: When user click on create a new channel from appSet.videos.channels.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * layoutType - Type: string. Desc: classic, strip or compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account, editor, ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetVideosChannelCreateNewChannelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetVideosChannelCreateNewChannelClick = function (params) {
    return { evid: 248, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boClosePopupUpgradedChannelClickedParams
* @property {string} button - No, Thanks/Yes Cancel Changes
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.close.popup.upgradedChannel.clicked. Evid: 104.
 * Event description: Clicking in the back office close
while editing channel without saving changes popup
on button 'No, Thanks'  or 'Yes Cancel Changes'.

 * button - Type: string. Desc: No, Thanks/Yes Cancel Changes
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boClosePopupUpgradedChannelClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boClosePopupUpgradedChannelClicked = function (params) {
    return { evid: 104, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibAddToChannelBtnClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {number} numberVideos - number of videos chosen
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - json of video_id
**/
/**
 * Name: bo.lib.addToChannel.Btn.clicked. Evid: 56.
 * Event description: Clicking add to channel.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * numberVideos - Type: numeric. Desc: number of videos chosen
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: json of video_id
 * @param {boLibAddToChannelBtnClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibAddToChannelBtnClicked = function (params) {
    return { evid: 56, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditUpdateChangesCompletedParams
* @property {string} button - popup/button/library
* @property {string} channelID - channelID
* @property {boolean} coverAdded - cover added
* @property {boolean} descriptionExists - description channel exists
* @property {boolean} featuredSelected - featured video selected
* @property {boolean} hasCustomCover - has channel custom cover
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isYouTubeFeed - if channel is youtube feed
* @property {string} errorMsg - the error message if save failed
* @property {GUID} biToken - msid
* @property {number} numOfTags - num of tags
* @property {number} numberVideos - number videos in the channel
* @property {string} origin - origin
* @property {number} overQuotaVideosCount - how many of the videos are OverQ
* @property {string} compId - player_id
* @property {boolean} scheduledExists - scheduled video exists
* @property {boolean} subscriptionEnabledChange - did you change the subscription option
* @property {boolean} subscriptionEnabled - subscription enabled
* @property {boolean} subscriptionOnly - "make paid videos on this channel subscription only" on/off
* @property {boolean} subscriptionOnlyChange - "make paid videos on this channel subscription only" changed
* @property {number} subscriptionPricing - doubled by 10000
* @property {boolean} subscriptionPricingChange - did the price of the subscription change
* @property {boolean} isSuccess - save success or not
* @property {boolean} titleAdded - title added
* @property {string} videoID - JSON video_id
**/
/**
 * Name: bo.chEdit.updateChanges.Completed. Evid: 77.
 * Event description: Update Changes completed or channel created from library, clicking "add to new channel".

 * button - Type: string. Desc: popup/button/library
 *
 * channelID - Type: string. Desc: channelID
 *
 * coverAdded - Type: bool. Desc: cover added
 *
 * descriptionExists - Type: bool. Desc: description channel exists
 *
 * featuredSelected - Type: bool. Desc: featured video selected
 *
 * hasCustomCover - Type: bool. Desc: has channel custom cover
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isYouTubeFeed - Type: bool. Desc: if channel is youtube feed
 *
 * errorMsg - Type: string. Desc: the error message if save failed
 *
 * biToken - Type: guid. Desc: msid
 *
 * numOfTags - Type: numeric. Desc: num of tags
 *
 * numberVideos - Type: numeric. Desc: number videos in the channel
 *
 * origin - Type: string. Desc: origin
 *
 * overQuotaVideosCount - Type: numeric. Desc: how many of the videos are OverQ
 *
 * compId - Type: string. Desc: player_id
 *
 * scheduledExists - Type: bool. Desc: scheduled video exists
 *
 * subscriptionEnabledChange - Type: bool. Desc: did you change the subscription option
 *
 * subscriptionEnabled - Type: bool. Desc: subscription enabled
 *
 * subscriptionOnly - Type: bool. Desc: "make paid videos on this channel subscription only" on/off
 *
 * subscriptionOnlyChange - Type: bool. Desc: "make paid videos on this channel subscription only" changed
 *
 * subscriptionPricing - Type: numeric. Desc: doubled by 10000
 *
 * subscriptionPricingChange - Type: bool. Desc: did the price of the subscription change
 *
 * isSuccess - Type: bool. Desc: save success or not
 *
 * titleAdded - Type: bool. Desc: title added
 *
 * videoID - Type: string. Desc: JSON video_id
 * @param {boChEditUpdateChangesCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditUpdateChangesCompleted = function (params) {
    return { evid: 77, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetAdiDisplayElementsChannelDetailsChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isEnabled - true/false
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: appSet.adi.displayElements.channelDetails.changed. Evid: 314.
 * Event description: User click on "channel Details" in ADI.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isEnabled - Type: bool. Desc: true/false
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetAdiDisplayElementsChannelDetailsChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetAdiDisplayElementsChannelDetailsChanged = function (params) {
    return { evid: 314, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetDesignOptimalFontToggleChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isEnabled - on / off
* @property {string} layoutType - small_slider/big_slider
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: appSet.design.optimalFontToggle.changed. Evid: 406.
 * Event description: User changed toggle 'Use optimal font sizes'.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isEnabled - Type: bool. Desc: on / off
 *
 * layoutType - Type: string. Desc: small_slider/big_slider
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetDesignOptimalFontToggleChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetDesignOptimalFontToggleChanged = function (params) {
    return { evid: 406, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetTabClickedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {string} layoutType - layout type
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {string} newTabName - main/channel/settings/layout/design
**/
/**
 * Name: appSet.tab.clicked. Evid: 18.
 * Event description: Clicking on tab layout or design or settings.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * layoutType - Type: string. Desc: layout type
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * newTabName - Type: string. Desc: main/channel/settings/layout/design
 * @param {appSetTabClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetTabClicked = function (params) {
    return { evid: 18, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageTrailerCreationCompletedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isFirst - first time uploading
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - null
* @property {string} source - upload/drive/dropbox
* @property {boolean} success - true = trailer created successfully
**/
/**
 * Name: bo.vidPage.trailer.creation.completed. Evid: 813.
 * Event description: Auto-generated trailer creation completed..

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isFirst - Type: bool. Desc: first time uploading
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string.
 *
 * source - Type: string. Desc: upload/drive/dropbox
 *
 * success - Type: bool. Desc: true = trailer created successfully
 * @param {boVidPageTrailerCreationCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageTrailerCreationCompleted = function (params) {
    return { evid: 813, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boMeetChannelsPopUpOpenedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.meetChannelsPopUp.opened. Evid: 45.
 * Event description: Channel introduction popup open.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boMeetChannelsPopUpOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boMeetChannelsPopUpOpened = function (params) {
    return { evid: 45, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetLayoutArrowsPositionChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {string} layoutType - small_slider/big_slider
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} selection - on / outside
**/
/**
 * Name: appSet.layout.arrowsPosition.changed. Evid: 309.
 * Event description: Users changes "Arrows position" (slider layout).

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * layoutType - Type: string. Desc: small_slider/big_slider
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * selection - Type: string. Desc: on / outside
 * @param {appSetLayoutArrowsPositionChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetLayoutArrowsPositionChanged = function (params) {
    return { evid: 309, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetSettingsLastPlayPositionChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isEnabled - toggle on/off
* @property {string} layoutType - null
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: appSet.settings.lastPlayPosition.changed. Evid: 273.
 * Event description: User change in appSet.settings "last play position"  toggle.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isEnabled - Type: bool. Desc: toggle on/off
 *
 * layoutType - Type: string.
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetSettingsLastPlayPositionChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetSettingsLastPlayPositionChanged = function (params) {
    return { evid: 273, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appLearnMoreClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} pageName - from where user click on learn more (start_page,video_list etc.)
* @property {string} compId - null
**/
/**
 * Name: app.learnMore.click. Evid: 601.
 * Event description: User click on"Learn More" button.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * pageName - Type: string. Desc: from where user click on learn more (start_page,video_list etc.)
 *
 * compId - Type: string.
 * @param {appLearnMoreClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appLearnMoreClick = function (params) {
    return { evid: 601, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLiveEditCancelButtonClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoId - video_id
**/
/**
 * Name: bo.live.edit.cancelButton.click. Evid: 459.
 * Event description: Clicking cancel in live editing page.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoId - Type: string. Desc: video_id
 * @param {boLiveEditCancelButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLiveEditCancelButtonClick = function (params) {
    return { evid: 459, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetSignupClickedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.signup.clicked. Evid: 216.
 * Event description: Signup button clicked.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetSignupClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetSignupClicked = function (params) {
    return { evid: 216, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boUploadAddVideosEmbedVideoEnterUrlParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - first_video/add_videos_menu
* @property {string} compId - player_id
* @property {string} source - youtube/vimeo/facebook
**/
/**
 * Name: bo.upload.addVideos.embedVideo.enterUrl. Evid: 110.
 * Event description: Sent when user enters video URL.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: first_video/add_videos_menu
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: youtube/vimeo/facebook
 * @param {boUploadAddVideosEmbedVideoEnterUrlParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boUploadAddVideosEmbedVideoEnterUrl = function (params) {
    return { evid: 110, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsCustomCardPopUpUploadImageCompletedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isSuccess - image upload success or not
* @property {string} errorMsg - error message if upload fail
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.customCardPopUp.uploadImage.completed. Evid: 358.
 * Event description: upload image in  "Custom Card" pop up finished.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isSuccess - Type: bool. Desc: image upload success or not
 *
 * errorMsg - Type: string. Desc: error message if upload fail
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsCustomCardPopUpUploadImageCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsCustomCardPopUpUploadImageCompleted = function (params) {
    return { evid: 358, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetVideoCardsCardCloseClickParams
* @property {string} cardName - promote_video/promote_channel/get_social_followers/boost_sales/custom_text
* @property {GUID} videoInstanceID - instance_id
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {string} siteUrl - site url when video embeded
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.videoCards.card.close.click. Evid: 250.
 * Event description: UoU click close on card.

 * cardName - Type: string. Desc: promote_video/promote_channel/get_social_followers/boost_sales/custom_text
 *
 * videoInstanceID - Type: guid. Desc: instance_id
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * siteUrl - Type: string. Desc: site url when video embeded
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetVideoCardsCardCloseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetVideoCardsCardCloseClick = function (params) {
    return { evid: 250, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibAddLogoPopUpOpenedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoId - video_id
**/
/**
 * Name: bo.lib.addLogoPopUp.opened. Evid: 181.
 * Event description: "add a custom logo" popup opened.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoId - Type: string. Desc: video_id
 * @param {boLibAddLogoPopUpOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibAddLogoPopUpOpened = function (params) {
    return { evid: 181, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetEmbedOpenedParams
* @property {string} buyTypeDisplayed - rent/buyFrom/buy/none
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {number} loadingTime - loading time
* @property {GUID} biToken - msid
* @property {boolean} overQuoted - is video id under OverQuota, true / false
* @property {string} compId - player_id
* @property {string} siteUrl - site url (only when embed video)
* @property {string} trailerType - preview/trailer
* @property {number} videoHeight - Actual height of video source
* @property {string} videoID - video_id
* @property {number} videoWidth - Actual width of video source
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.embed.opened. Evid: 241.
 * Event description: Video embed widget opened.

 * buyTypeDisplayed - Type: string. Desc: rent/buyFrom/buy/none
 *
 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * loadingTime - Type: numeric. Desc: loading time
 *
 * biToken - Type: guid. Desc: msid
 *
 * overQuoted - Type: bool. Desc: is video id under OverQuota, true / false
 *
 * compId - Type: string. Desc: player_id
 *
 * siteUrl - Type: string. Desc: site url (only when embed video)
 *
 * trailerType - Type: string. Desc: preview/trailer
 *
 * videoHeight - Type: numeric. Desc: Actual height of video source
 *
 * videoID - Type: string. Desc: video_id
 *
 * videoWidth - Type: numeric. Desc: Actual width of video source
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetEmbedOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetEmbedOpened = function (params) {
    return { evid: 241, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} mediaShareVideoRequestParams
* @property {string} correlationId - ID for one unique view connection
* @property {GUID} videoInstanceID - null
* @property {GUID} biToken - biToken
* @property {string} parameters - parameters
* @property {string} compId - player_id
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: mediaShare.video.request. Evid: 397.
 * Event description: Server events for Facebook & Twitter share params.

 * correlationId - Type: string. Desc: ID for one unique view connection
 *
 * videoInstanceID - Type: guid.
 *
 * biToken - Type: guid. Desc: biToken
 *
 * parameters - Type: string. Desc: parameters
 *
 * compId - Type: string. Desc: player_id
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {mediaShareVideoRequestParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mediaShareVideoRequest = function (params) {
    return { evid: 397, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetPlayerThemeChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} theme_type - dark/light
**/
/**
 * Name: appSet.player.theme.changed. Evid: 198.
 * Event description: User change theme in appSet.player.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * theme_type - Type: string. Desc: dark/light
 * @param {appSetPlayerThemeChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetPlayerThemeChanged = function (params) {
    return { evid: 198, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appLiveEndSaveToDeviceClickParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - buttton/notification
* @property {string} compId - null
* @property {string} videoID - video_id
**/
/**
 * Name: app.live.end.saveToDevice.click. Evid: 656.
 * Event description: After live end user click on save to device button / notification (When some of this video recorded offline).

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: buttton/notification
 *
 * compId - Type: string.
 *
 * videoID - Type: string. Desc: video_id
 * @param {appLiveEndSaveToDeviceClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appLiveEndSaveToDeviceClick = function (params) {
    return { evid: 656, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChStatsBtnClickedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - player_id
**/
/**
 * Name: bo.ch.statsBtn.clicked. Evid: 71.
 * Event description: Stats button clicked.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string. Desc: player_id
 * @param {boChStatsBtnClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChStatsBtnClicked = function (params) {
    return { evid: 71, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsAddVideoCardClickParams
* @property {string} cardName - promote_video/feature_channel/promote_product/get_social_followers/custom
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.addVideoCard.click. Evid: 320.
 * Event description: add video card click in video cards section (promote a video/Promote a channel/Increase social followers/Boost sales/Custom test).

 * cardName - Type: string. Desc: promote_video/feature_channel/promote_product/get_social_followers/custom
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsAddVideoCardClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsAddVideoCardClick = function (params) {
    return { evid: 320, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetShareEmbedCopyClickedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - on_site/embed
* @property {string} compId - player_id
* @property {string} shareType - video/channel
* @property {string} siteUrl - site url (only when embed video)
* @property {string} videoID - videoID
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.share.embed.copy.clicked. Evid: 247.
 * Event description: click on copy in widget.share.embed.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: on_site/embed
 *
 * compId - Type: string. Desc: player_id
 *
 * shareType - Type: string. Desc: video/channel
 *
 * siteUrl - Type: string. Desc: site url (only when embed video)
 *
 * videoID - Type: string. Desc: videoID
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetShareEmbedCopyClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetShareEmbedCopyClicked = function (params) {
    return { evid: 247, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boStatsGraphTabClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - ADI / editor / МА
* @property {string} compId - player_id
* @property {string} newTabName - Views/Shares/Sales
**/
/**
 * Name: bo.stats.graph.tab.clicked. Evid: 24.
 * Event description: Clicking on tab Views/Shares/Sales in the stats graph.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string. Desc: player_id
 *
 * newTabName - Type: string. Desc: Views/Shares/Sales
 * @param {boStatsGraphTabClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boStatsGraphTabClicked = function (params) {
    return { evid: 24, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boClosePopupCancelUploadClickedParams
* @property {string} button - Go back/Cancel Uploads
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.close.popup.cancelUpload.clicked. Evid: 103.
 * Event description: Clicking in the back office close  while uploading popup  on button
'Go back'  or 'Cancel Uploads'.

 * button - Type: string. Desc: Go back/Cancel Uploads
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boClosePopupCancelUploadClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boClosePopupCancelUploadClicked = function (params) {
    return { evid: 103, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetPlayerAfterPlayingWhenVideoEndsChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - null
* @property {string} layoutType - small_slider/big_slider
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} previousSelection - show_video_cover/play_next_video/open_action_cards
* @property {string} selection - show_video_cover/play_next_video/open_action_cards
**/
/**
 * Name: appSet.player.afterPlaying.whenVideoEnds.changed. Evid: 367.
 * Event description: User change in appSet.player.afterPlaying when video ends dropdown.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid.
 *
 * layoutType - Type: string. Desc: small_slider/big_slider
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * previousSelection - Type: string. Desc: show_video_cover/play_next_video/open_action_cards
 *
 * selection - Type: string. Desc: show_video_cover/play_next_video/open_action_cards
 * @param {appSetPlayerAfterPlayingWhenVideoEndsChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetPlayerAfterPlayingWhenVideoEndsChanged = function (params) {
    return { evid: 367, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChYtlistNextButtonClickedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isFirst - true/false
* @property {GUID} biToken - msid
* @property {string} origin - ADI / editor / МА
* @property {string} compId - player_id
* @property {string} source - youtube/vimeo/facebook
**/
/**
 * Name: bo.ch.ytlist.next.button.clicked. Evid: 126.
 * Event description: Sent when user clicks on next button when adding YouTube list or channel in first on boarding experience.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isFirst - Type: bool. Desc: true/false
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: youtube/vimeo/facebook
 * @param {boChYtlistNextButtonClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChYtlistNextButtonClicked = function (params) {
    return { evid: 126, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditVidEditParams
* @property {string} button - button / double_click
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {boolean} overQuoted - is video id under OverQuota, true / false
* @property {string} compId - null
* @property {string} source - computer / live / youtube / vimeo etc
* @property {string} videoID - videoID
**/
/**
 * Name: bo.chEdit.vid.edit. Evid: 271.
 * Event description: User clicks on edit video from channel edit page.

 * button - Type: string. Desc: button / double_click
 *
 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * overQuoted - Type: bool. Desc: is video id under OverQuota, true / false
 *
 * compId - Type: string.
 *
 * source - Type: string. Desc: computer / live / youtube / vimeo etc
 *
 * videoID - Type: string. Desc: videoID
 * @param {boChEditVidEditParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditVidEdit = function (params) {
    return { evid: 271, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetSignInPopUpBtnClickedParams
* @property {string} button - proceed/cancel
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.signInPopUp.BtnClicked. Evid: 202.
 * Event description: Button clicked (proceed or cancel) in the signIn popup.

 * button - Type: string. Desc: proceed/cancel
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetSignInPopUpBtnClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetSignInPopUpBtnClicked = function (params) {
    return { evid: 202, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetSignInClickedParams
* @property {string} channelID - channel
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.signIn.clicked. Evid: 201.
 * Event description: SignIn button clicked.

 * channelID - Type: string. Desc: channel
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetSignInClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetSignInClicked = function (params) {
    return { evid: 201, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boOpenedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isFirst - first time open the back office
* @property {number} loading_time - loading time
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} source - back_office / business_manager
**/
/**
 * Name: bo.opened. Evid: 120.
 * Event description: Opened back office.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isFirst - Type: bool. Desc: first time open the back office
 *
 * loading_time - Type: numeric. Desc: loading time
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: back_office / business_manager
 * @param {boOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boOpened = function (params) {
    return { evid: 120, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetVidBuyDisplayedParams
* @property {string} button - thumbnail/main
* @property {string} buyType - buy/rent/buyFrom
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - on_site/embed
* @property {string} compId - player_id
* @property {string} siteUrl - site url (only when embed video)
* @property {string} videoID - videoID
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.vid.buy.displayed. Evid: 219.
 * Event description: Buy button displayed on video.

 * button - Type: string. Desc: thumbnail/main
 *
 * buyType - Type: string. Desc: buy/rent/buyFrom
 *
 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: on_site/embed
 *
 * compId - Type: string. Desc: player_id
 *
 * siteUrl - Type: string. Desc: site url (only when embed video)
 *
 * videoID - Type: string. Desc: videoID
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetVidBuyDisplayedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetVidBuyDisplayed = function (params) {
    return { evid: 219, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsVideoPlayRequestedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} playSource - keyboard/play_button/screen_click
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.video.play.requested. Evid: 334.
 * Event description: click on video play button in video cards section.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * playSource - Type: string. Desc: keyboard/play_button/screen_click
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsVideoPlayRequestedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsVideoPlayRequested = function (params) {
    return { evid: 334, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetVidStartPlayParams
* @property {string} button - thumbnail/main
* @property {string} channelID - channelID
* @property {string} correlationId - ID for one unique view connection
* @property {number} duration - duration of full video in ms
* @property {GUID} videoInstanceID - null
* @property {boolean} isAutoplay - If video start autoplay or user click on play
* @property {GUID} biToken - null
* @property {string} compId - null
* @property {string} videoID - videoID
* @property {string} videoType - computer/vimeo/facebook/youtube/live
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.vid.start.play. Evid: 129.
 * Event description: when video start play after user click (128).

 * button - Type: string. Desc: thumbnail/main
 *
 * channelID - Type: string. Desc: channelID
 *
 * correlationId - Type: string. Desc: ID for one unique view connection
 *
 * duration - Type: numeric. Desc: duration of full video in ms
 *
 * videoInstanceID - Type: guid.
 *
 * isAutoplay - Type: bool. Desc: If video start autoplay or user click on play
 *
 * biToken - Type: guid.
 *
 * compId - Type: string.
 *
 * videoID - Type: string. Desc: videoID
 *
 * videoType - Type: string. Desc: computer/vimeo/facebook/youtube/live
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetVidStartPlayParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetVidStartPlay = function (params) {
    return { evid: 129, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appLiveCancelClickParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - Form where user click cancel (after_live/before_live etc.)
* @property {string} compId - null
**/
/**
 * Name: app.live.cancel.click. Evid: 651.
 * Event description: User click on cancel after start live when live is lading or countdown.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: Form where user click cancel (after_live/before_live etc.)
 *
 * compId - Type: string.
 * @param {appLiveCancelClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appLiveCancelClick = function (params) {
    return { evid: 651, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageTrailerUploadStartParams
* @property {string} button - drag-n-drop/upload
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} trailerID - trailerID
* @property {string} videoID - videoID
**/
/**
 * Name: bo.vidPage.trailer.upload.start. Evid: 65.
 * Event description: Clicking upload trailer.

 * button - Type: string. Desc: drag-n-drop/upload
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * trailerID - Type: string. Desc: trailerID
 *
 * videoID - Type: string. Desc: videoID
 * @param {boVidPageTrailerUploadStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageTrailerUploadStart = function (params) {
    return { evid: 65, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsActionCardsHowToPopUpButtonClickParams
* @property {string} button - add_action_card/close
* @property {boolean} dontShow - don't show on/off
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - null
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.actionCardsHowToPopUp.button.click. Evid: 359.
 * Event description: Button click on "how to" action cards pop up.

 * button - Type: string. Desc: add_action_card/close
 *
 * dontShow - Type: bool. Desc: don't show on/off
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string.
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsActionCardsHowToPopUpButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsActionCardsHowToPopUpButtonClick = function (params) {
    return { evid: 359, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLiveStreamKeyExpiredPopUpClickParams
* @property {string} button - close / got_it
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.live.streamKeyExpiredPopUp.click. Evid: 481.
 * Event description: Click on 'Your stream key has expired'  pop up.

 * button - Type: string. Desc: close / got_it
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boLiveStreamKeyExpiredPopUpClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLiveStreamKeyExpiredPopUpClick = function (params) {
    return { evid: 481, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boEmailMarketingUseThisTemplateClickedParams
* @property {GUID} videoInstanceID - null
* @property {GUID} biToken - null
* @property {string} origin - ADI / editor / МА
* @property {string} compId - null
* @property {string} templateType - Share Video/Promote Channel/Send Newsletter
**/
/**
 * Name: bo.emailMarketing.useThisTemplate.clicked. Evid: 150.
 * Event description: Click on use this template button in email marketing tab.

 * videoInstanceID - Type: guid.
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string.
 *
 * templateType - Type: string. Desc: Share Video/Promote Channel/Send Newsletter
 * @param {boEmailMarketingUseThisTemplateClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boEmailMarketingUseThisTemplateClicked = function (params) {
    return { evid: 150, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetLayoutShowButtonChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {string} layoutType - small_slider/big_slider
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} selection - on_hover / always
**/
/**
 * Name: appSet.layout.showButton.changed. Evid: 315.
 * Event description: Users changes "Show button" for video thumbnails (layout).

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * layoutType - Type: string. Desc: small_slider/big_slider
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * selection - Type: string. Desc: on_hover / always
 * @param {appSetLayoutShowButtonChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetLayoutShowButtonChanged = function (params) {
    return { evid: 315, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditConnectFeedEnterUrlParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - new_feed/change_feed
* @property {string} compId - player_id
* @property {string} source - youtube
**/
/**
 * Name: bo.chEdit.connectFeed.enterUrl. Evid: 116.
 * Event description: Sent when user enters video URL for feed.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: new_feed/change_feed
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: youtube
 * @param {boChEditConnectFeedEnterUrlParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditConnectFeedEnterUrl = function (params) {
    return { evid: 116, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageLivePopUpGotItClickParams
* @property {boolean} dontShow - don't show this again checkbox
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.livePopUp.gotIt.click. Evid: 382.
 * Event description: click on got it  in the live pop up.

 * dontShow - Type: bool. Desc: don't show this again checkbox
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageLivePopUpGotItClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageLivePopUpGotItClick = function (params) {
    return { evid: 382, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageTrailerUploadCompletedParams
* @property {string} button - drag-n-drop/upload
* @property {string} errorType - error message user get if not success
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isSuccess - did the upload succesed
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} trailerID - trailerID
* @property {string} videoID - videoID
**/
/**
 * Name: bo.vidPage.trailer.upload.completed. Evid: 66.
 * Event description: Upload trailer completed.

 * button - Type: string. Desc: drag-n-drop/upload
 *
 * errorType - Type: string. Desc: error message user get if not success
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isSuccess - Type: bool. Desc: did the upload succesed
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * trailerID - Type: string. Desc: trailerID
 *
 * videoID - Type: string. Desc: videoID
 * @param {boVidPageTrailerUploadCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageTrailerUploadCompleted = function (params) {
    return { evid: 66, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} siteBaseMigrationStartedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: siteBaseMigration.started. Evid: 798.
 * Event description: Site Base Migration for reg users triggered by Video BO open started.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {siteBaseMigrationStartedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteBaseMigrationStarted = function (params) {
    return { evid: 798, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageUnsavedChangesPopUpOpenedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.unsavedChangesPopUp.opened. Evid: 331.
 * Event description: unsaved changes  pop up opened.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageUnsavedChangesPopUpOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageUnsavedChangesPopUpOpened = function (params) {
    return { evid: 331, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boEmailMarketingUseThisTemplateChooseContinueClickParams
* @property {string} entityId - entity_id
* @property {GUID} videoInstanceID - null
* @property {GUID} biToken - null
* @property {string} origin - ADI / editor / МА
* @property {string} compId - null
* @property {string} templateType - Share Video/Promote Channel/Send Newsletter
**/
/**
 * Name: bo.emailMarketing.useThisTemplate.choose.continue.click. Evid: 154.
 * Event description: Click on continue in choose a channel/video box from use this template button in email marketing tab.

 * entityId - Type: string. Desc: entity_id
 *
 * videoInstanceID - Type: guid.
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string.
 *
 * templateType - Type: string. Desc: Share Video/Promote Channel/Send Newsletter
 * @param {boEmailMarketingUseThisTemplateChooseContinueClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boEmailMarketingUseThisTemplateChooseContinueClick = function (params) {
    return { evid: 154, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLibUploadYourOwnVideoBannerCloseClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.lib.uploadYourOwnVideoBanner.close.click. Evid: 364.
 * Event description: User close  "Upload your own videos banner"
example: https://www.screencast.com/t/3EG1pmmqbMb.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boLibUploadYourOwnVideoBannerCloseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLibUploadYourOwnVideoBannerCloseClick = function (params) {
    return { evid: 364, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boUploadAttemptedParams
* @property {string} button - drag-n-drop/upload
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isFirst - first time uploading
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} source - upload/drive/dropbox
* @property {string} tracksUploaded - how meay files are send to upload
**/
/**
 * Name: bo.upload.attempted. Evid: 106.
 * Event description: User attempted to upload one or few files. For few files, will be sent once. It includes only Drag&drop and upload by clicking on a button for videos library and wellcome screens.

 * button - Type: string. Desc: drag-n-drop/upload
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isFirst - Type: bool. Desc: first time uploading
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: upload/drive/dropbox
 *
 * tracksUploaded - Type: string. Desc: how meay files are send to upload
 * @param {boUploadAttemptedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boUploadAttempted = function (params) {
    return { evid: 106, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} siteBaseMigrationPopUpShownParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - null
* @property {GUID} uuid - uuid
**/
/**
 * Name: siteBaseMigration.popUp.shown. Evid: 796.
 * Event description: Site Base Migration success pop up has been shown.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string.
 *
 * uuid - Type: guid. Desc: uuid
 * @param {siteBaseMigrationPopUpShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var siteBaseMigrationPopUpShown = function (params) {
    return { evid: 796, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageVideoCardsPromoteVideoPopUpNextClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} selection - recent_video/choose_video
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.videoCards.promoteVideoPopUp.next.click. Evid: 338.
 * Event description: click on next in "Promote A Video" modal after choosing to promote latest video or to choose video to promote.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * selection - Type: string. Desc: recent_video/choose_video
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageVideoCardsPromoteVideoPopUpNextClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageVideoCardsPromoteVideoPopUpNextClick = function (params) {
    return { evid: 338, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boSyndicLoadStartedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - new_videoID
**/
/**
 * Name: bo.syndic.load.started. Evid: 366.
 * Event description: Syndication load start (event to track syndication success rate).

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: new_videoID
 * @param {boSyndicLoadStartedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boSyndicLoadStarted = function (params) {
    return { evid: 366, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetVideosSelectWhatToPlayChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {string} selection - single_video/channel
**/
/**
 * Name: appSet.videos.selectWhatToPlay.changed. Evid: 304.
 * Event description: When user choose which type of video to play in player (single/channel).

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * selection - Type: string. Desc: single_video/channel
 * @param {appSetVideosSelectWhatToPlayChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetVideosSelectWhatToPlayChanged = function (params) {
    return { evid: 304, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boGeneralPayPalStateParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - ADI / editor / МА
* @property {string} compId - player_id
**/
/**
 * Name: bo.general.PayPalState. Evid: 102.
 * Event description: PayPal state display  in bo.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string. Desc: player_id
 * @param {boGeneralPayPalStateParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boGeneralPayPalState = function (params) {
    return { evid: 102, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appGoLiveGoLiveClickParams
* @property {string} channelID - channel_id
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - from where user click on the button (new_video/schedualed_video)
* @property {string} compId - null
**/
/**
 * Name: app.goLive.goLive.click. Evid: 620.
 * Event description: User click on Go Live button  in go live screen.

 * channelID - Type: string. Desc: channel_id
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: from where user click on the button (new_video/schedualed_video)
 *
 * compId - Type: string.
 * @param {appGoLiveGoLiveClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appGoLiveGoLiveClick = function (params) {
    return { evid: 620, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidPageLivePopUpOpenedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} videoID - video_id
**/
/**
 * Name: bo.vidPage.livePopUp.opened. Evid: 383.
 * Event description: Live pop up opened.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: video_id
 * @param {boVidPageLivePopUpOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidPageLivePopUpOpened = function (params) {
    return { evid: 383, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boEmailMarketingPreviewPromoteChooseClickParams
* @property {GUID} videoInstanceID - null
* @property {GUID} biToken - null
* @property {string} origin - ADI / editor / МА
* @property {string} compId - null
* @property {string} templateType - Share Video/Promote Channel/Send Newsletter
**/
/**
 * Name: bo.emailMarketing.preview.promote.choose.click. Evid: 157.
 * Event description: Click on choose in promote box from preview in email marketing tab.

 * videoInstanceID - Type: guid.
 *
 * biToken - Type: guid.
 *
 * origin - Type: string. Desc: ADI / editor / МА
 *
 * compId - Type: string.
 *
 * templateType - Type: string. Desc: Share Video/Promote Channel/Send Newsletter
 * @param {boEmailMarketingPreviewPromoteChooseClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boEmailMarketingPreviewPromoteChooseClick = function (params) {
    return { evid: 157, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetLayoutInfoPositionChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} selection - on_video/below_video
**/
/**
 * Name: appSet.layout.infoPosition.changed. Evid: 401.
 * Event description: User changed info position in appSet.layout.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * selection - Type: string. Desc: on_video/below_video
 * @param {appSetLayoutInfoPositionChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetLayoutInfoPositionChanged = function (params) {
    return { evid: 401, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLiveEditConnectStreamRenewKeyClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.live.edit.connectStream.renewKey.click. Evid: 457.
 * Event description: Click on Renew Key on connect stream tab.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boLiveEditConnectStreamRenewKeyClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLiveEditConnectStreamRenewKeyClick = function (params) {
    return { evid: 457, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boTrailerTryAgainParams
* @property {string} button - contact_customer_care / try_again
* @property {string} channelID - channelID
* @property {string} errorType - error type
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} compId - null
**/
/**
 * Name: dummy-name. Evid: 821.
 * Event description: User clicked on one of the buttons in the auto-generated trailer fail message.

 * button - Type: string. Desc: contact_customer_care / try_again
 *
 * channelID - Type: string. Desc: channelID
 *
 * errorType - Type: string. Desc: error type
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * compId - Type: string.
 * @param {boTrailerTryAgainParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boTrailerTryAgain = function (params) {
    return { evid: 821, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boChEditChannelInfoSaveCompletedParams
* @property {string} channelID - channelID
* @property {boolean} descriptionExists - if description exist
* @property {boolean} hasCustomCover - has channel custom cover
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - origin
* @property {string} planIDs - list of plan_id
* @property {string} compId - player_id
* @property {boolean} pricingPlanEnabled - is pricing Plan Enabled
* @property {boolean} subscriptionEnabled - is subscription enable
* @property {boolean} subscriptionOnlyChange - if subscription changed
* @property {number} subscriptionPricing - subscription price doubled by 10000
* @property {boolean} titleChanged - title changed
**/
/**
 * Name: bo.chEdit.channelInfo.save.completed. Evid: 160.
 * Event description: "save" in channel info completed.

 * channelID - Type: string. Desc: channelID
 *
 * descriptionExists - Type: bool. Desc: if description exist
 *
 * hasCustomCover - Type: bool. Desc: has channel custom cover
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: origin
 *
 * planIDs - Type: string. Desc: list of plan_id
 *
 * compId - Type: string. Desc: player_id
 *
 * pricingPlanEnabled - Type: bool. Desc: is pricing Plan Enabled
 *
 * subscriptionEnabled - Type: bool. Desc: is subscription enable
 *
 * subscriptionOnlyChange - Type: bool. Desc: if subscription changed
 *
 * subscriptionPricing - Type: numeric. Desc: subscription price doubled by 10000
 *
 * titleChanged - Type: bool. Desc: title changed
 * @param {boChEditChannelInfoSaveCompletedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boChEditChannelInfoSaveCompleted = function (params) {
    return { evid: 160, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLiveEditDeletePopUpOpenedParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.live.edit.deletePopUp.opened. Evid: 474.
 * Event description: 'Delete this live stream'  pop up open.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boLiveEditDeletePopUpOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLiveEditDeletePopUpOpened = function (params) {
    return { evid: 474, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boSettingsEmailWhenSaleChangedParams
* @property {boolean} emailWhenSale - is an email is going to be send when there a sale
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.settings.emailWhenSale.changed. Evid: 36.
 * Event description: Changing if a email will be send after a sale or not.

 * emailWhenSale - Type: bool. Desc: is an email is going to be send when there a sale
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boSettingsEmailWhenSaleChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boSettingsEmailWhenSaleChanged = function (params) {
    return { evid: 36, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetSettingsMainItemShowTitleForMainItemChangedParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {string} layoutType - classic/strip/compact
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {boolean} toggle - true/false
**/
/**
 * Name: appSet.settings.mainItem.showTitleForMainItem.changed. Evid: 171.
 * Event description: User change in appSet.settings at main Item section to show title or not.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * layoutType - Type: string. Desc: classic/strip/compact
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * toggle - Type: bool. Desc: true/false
 * @param {appSetSettingsMainItemShowTitleForMainItemChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetSettingsMainItemShowTitleForMainItemChanged = function (params) {
    return { evid: 171, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boUploadStartParams
* @property {boolean} batch - several files in one import
* @property {number} batchSize - amount of files
* @property {string} button - drag&drop /upload
* @property {string} correlationId - correlation_Id to join with 53 per video
* @property {string} fileFormat - file extension
* @property {number} fileSize - file size in KB
* @property {string} fileType - image / video / audio / doc / folder
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isFirst - first time uploading
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
* @property {string} source - upload/drive/dropbox
* @property {string} tracksUploaded - number of files, what was selected to upload including current
* @property {string} uploadType - auto_resumed / user_resumed / common (upload)
**/
/**
 * Name: bo.upload.start. Evid: 52.
 * Event description: Uploading single video started. It includes only Drag&drop and upload by clicking on a button for videos library and wellcome screens.

 * batch - Type: bool. Desc: several files in one import
 *
 * batchSize - Type: numeric. Desc: amount of files
 *
 * button - Type: string. Desc: drag&drop /upload
 *
 * correlationId - Type: string. Desc: correlation_Id to join with 53 per video
 *
 * fileFormat - Type: string. Desc: file extension
 *
 * fileSize - Type: numeric. Desc: file size in KB
 *
 * fileType - Type: string. Desc: image / video / audio / doc / folder
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isFirst - Type: bool. Desc: first time uploading
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 *
 * source - Type: string. Desc: upload/drive/dropbox
 *
 * tracksUploaded - Type: string. Desc: number of files, what was selected to upload including current
 *
 * uploadType - Type: string. Desc: auto_resumed / user_resumed / common (upload)
 * @param {boUploadStartParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boUploadStart = function (params) {
    return { evid: 52, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} playerErrorParams
* @property {string} correlationId - ID for one unique view connection
* @property {string} errorType - Type of error
* @property {GUID} videoInstanceID - videoInstanceID
* @property {boolean} isEmbed - Ind if the video embedded
* @property {boolean} isLive - Ind if the video is live
* @property {GUID} biToken - biToken
* @property {string} compId - compId
* @property {string} streamProvider - Provider of stream
* @property {string} streamType - Type of stream
* @property {string} videoID - ID of video in terms of Wix VOD
* @property {string} videoUrl - Url of video source
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: player.error. Evid: 244.
 * Event description: New Video Player error system.

 * correlationId - Type: string. Desc: ID for one unique view connection
 *
 * errorType - Type: string. Desc: Type of error
 *
 * videoInstanceID - Type: guid. Desc: videoInstanceID
 *
 * isEmbed - Type: bool. Desc: Ind if the video embedded
 *
 * isLive - Type: bool. Desc: Ind if the video is live
 *
 * biToken - Type: guid. Desc: biToken
 *
 * compId - Type: string. Desc: compId
 *
 * streamProvider - Type: string. Desc: Provider of stream
 *
 * streamType - Type: string. Desc: Type of stream
 *
 * videoID - Type: string. Desc: ID of video in terms of Wix VOD
 *
 * videoUrl - Type: string. Desc: Url of video source
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {playerErrorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var playerError = function (params) {
    return { evid: 244, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boLiveEditConnectStreamScheduleClickParams
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {string} compId - player_id
**/
/**
 * Name: bo.live.edit.connectStream.schedule.click. Evid: 458.
 * Event description: Click on Schedule on connect stream tab.

 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * compId - Type: string. Desc: player_id
 * @param {boLiveEditConnectStreamScheduleClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boLiveEditConnectStreamScheduleClick = function (params) {
    return { evid: 458, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetOpenedParams
* @property {string} buyTypeDisplayed - rent/buyFrom/buy/none
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {boolean} isSubscriptionBtn - is subscription Button shows
* @property {boolean} isTrailerBtn - is trailer Button shows
* @property {string} layout - compact/strip/classic
* @property {number} loading_time - loading time
* @property {string} mainItem - featuredVid/channelCover
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {string} trailerType - preview/trailer
* @property {string} viewMode - editor/viewer
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.opened. Evid: 200.
 * Event description: Video widget opend.

 * buyTypeDisplayed - Type: string. Desc: rent/buyFrom/buy/none
 *
 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * isSubscriptionBtn - Type: bool. Desc: is subscription Button shows
 *
 * isTrailerBtn - Type: bool. Desc: is trailer Button shows
 *
 * layout - Type: string. Desc: compact/strip/classic
 *
 * loading_time - Type: numeric. Desc: loading time
 *
 * mainItem - Type: string. Desc: featuredVid/channelCover
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * trailerType - Type: string. Desc: preview/trailer
 *
 * viewMode - Type: string. Desc: editor/viewer
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetOpened = function (params) {
    return { evid: 200, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} appSetPayPalStateParams
* @property {string} editorMode - mandatory
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
**/
/**
 * Name: appSet.PayPalState. Evid: 101.
 * Event description: PayPal state display  in app settings.

 * editorMode - Type: string. Desc: mandatory
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 * @param {appSetPayPalStateParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var appSetPayPalState = function (params) {
    return { evid: 101, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} widgetCategoriesSelectedParams
* @property {string} channelID - channelID
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} compId - player_id
* @property {GUID} visitorID - visitorID
**/
/**
 * Name: widget.categories.selected. Evid: 212.
 * Event description: Categories selected from list.

 * channelID - Type: string. Desc: channelID
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * compId - Type: string. Desc: player_id
 *
 * visitorID - Type: guid. Desc: visitorID
 * @param {widgetCategoriesSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var widgetCategoriesSelected = function (params) {
    return { evid: 212, src: 71, endpoint: 'video', params: params };
};
/**
* @typedef {Object} boVidDeleteVidPopupBtnClickedParams
* @property {string} button - delete/cancel
* @property {GUID} videoInstanceID - InstanceID
* @property {GUID} biToken - msid
* @property {string} origin - my_account/editor/ADI
* @property {boolean} overQuoted - is video id under OverQuota, true / false
* @property {string} compId - player_id
* @property {string} videoID - videoID
**/
/**
 * Name: bo.vid.deleteVidPopupBtn.clicked. Evid: 60.
 * Event description: Clicking delete or cancel in the delete video popup.

 * button - Type: string. Desc: delete/cancel
 *
 * videoInstanceID - Type: guid. Desc: InstanceID
 *
 * biToken - Type: guid. Desc: msid
 *
 * origin - Type: string. Desc: my_account/editor/ADI
 *
 * overQuoted - Type: bool. Desc: is video id under OverQuota, true / false
 *
 * compId - Type: string. Desc: player_id
 *
 * videoID - Type: string. Desc: videoID
 * @param {boVidDeleteVidPopupBtnClickedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var boVidDeleteVidPopupBtnClicked = function (params) {
    return { evid: 60, src: 71, endpoint: 'video', params: params };
};
//# sourceMappingURL=index.js.map